export const customerSupportJson = {
  uid: "248f9ac4-729b-4713-845a-797e1b4acb65",
  componentName: "CustomerSupport",
  dataSource: "{19453B22-22AE-4D55-8F39-8C8F341FA873}",
  params: {
    buttonAlignment: "center",
    variant: "base",
    numberOfColumns: "three",
    backgroundColor: "orange-white",
    paddingTop: "Medium",
    paddingBottom: "Medium",
  },
  fields: {
    supportIcon: {
      id: "0853a008-9b3c-4a10-98b9-1e96a3cdc253",
      fieldType: "Droplink",
      fieldName: "supportIcon",
      url: "/sitecore/content/fwd/global/settings/list/linkvariant/call",
      fields: { value: { value: "call" }, key: { value: "Call" } },
    },
    title: { value: "了解更多 " },
    description: {
      value: "難以決定哪個產品更適合您? 想得到更多資訊? 請選擇以下選項。",
    },
    supportOptions: [
      {
        id: "48391c1c-5699-4669-ba3b-7492f9401e2f",
        fields: {
          contactNumber: { value: "+852 3123 3123" },
          subTitle: {
            value: "每日上午9時至晚上11時，我們都會全力協助您。",
          },
          icon: {
            value: {
              src: "/-/media/images/supports/call.svg?rev=5ed85ebbe95342b3972b09a5f8f8b3ac",
              alt: "call",
            },
          },
          title: { value: "致電客戶支援" },
          supportIcon: {
            id: "0853a008-9b3c-4a10-98b9-1e96a3cdc253",
            fieldType: "CustomDroplink",
            fieldName: "supportIcon",
            url: "/sitecore/content/fwd/global/settings/list/linkvariant/call",
            fields: {
              value: { value: "call" },
              key: { value: "Call" },
            },
          },
          buttonIcon: {
            id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
            fieldType: "CustomDroplink",
            fieldName: "buttonIcon",
            url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
            fields: {
              value: { value: "arrow-right" },
              key: { value: "Link" },
            },
          },
          link: {
            value: {
              href: "http://tel:+852 3123 3123",
              text: "致電 3123 3123",
              linktype: "external",
              url: "http://tel:+852 3123 3123",
              anchor: "",
              target: "",
            },
          },
          buttonMode: {
            id: "02a5a5c7-c318-4919-b773-86a65ba98969",
            fieldType: "Droplink",
            fieldName: "buttonMode",
            url: "/sitecore/content/fwd/global/settings/list/button-mode/simple-link",
            fields: {
              value: { value: "SimpleLink" },
              key: { value: "SimpleLink" },
            },
          },
          linkGALabelName: { value: "Call 3123 3123" },
          listType: {
            id: "a5bee68c-8e43-4f78-8d15-d42982fd053a",
            fieldType: "Droplink",
            fieldName: "listType",
            url: "/sitecore/content/fwd/global/settings/list/linklisttype/call",
            fields: {
              value: { value: "Call" },
              key: { value: "call" },
            },
          },
        },
      },

      {
        id: "b947c809-c632-4013-b6ed-24446509484c",
        fields: {
          medalliaForm: { value: "" },
          title: { value: "留訊息給我們" },
          icon: {
            value: {
              src: "/-/media/images/supports/call.svg?rev=5ed85ebbe95342b3972b09a5f8f8b3ac",
              alt: "call",
            },
          },
          subTitle: {
            value: "對於您的問題或寶貴意見，我們會儘快回覆您。",
          },
          supportIcon: {
            id: "f35ed9fd-ad24-494a-8fb6-33be8955a85d",
            fieldType: "CustomDroplink",
            fieldName: "supportIcon",
            url: "/sitecore/content/fwd/global/settings/list/linkvariant/call-email",
            fields: {
              value: { value: "call-email" },
              key: { value: "callEmail" },
            },
          },
          listType: {
            id: "f281af72-fa4b-4f87-98f1-4b9d77180e60",
            fieldType: "Droplink",
            fieldName: "listType",
            url: "/sitecore/content/fwd/global/settings/list/linklisttype/generic_link",
            fields: {
              value: { value: "Generic Link" },
              key: { value: "generic_link" },
            },
          },
          buttonIcon: {
            id: "f35ed9fd-ad24-494a-8fb6-33be8955a85d",
            fieldType: "CustomDroplink",
            fieldName: "buttonIcon",
            url: "/sitecore/content/fwd/global/settings/list/linkvariant/call-email",
            fields: {
              value: { value: "call-email" },
              key: { value: "callEmail" },
            },
          },
          link: {
            value: {
              text: "Enquire",
              linktype: "form",
              querystring: "enquiry",
              target: "",
              id: "{F2728281-FA5C-41CB-B168-773E0C78197F}",
              href: "/forms-list/product-enquiry-form",
            },
          },
          buttonMode: {
            id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
            fieldType: "Droplink",
            fieldName: "buttonMode",
            url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
            fields: {
              value: { value: "Primary" },
              key: { value: "Primary" },
            },
          },
          linkGALabelName: { value: "Product Enquiry" },
        },
      },
    ],
    buttonIcon: null,
    link: {
      value: {
        href: "https://www.fwd.com.hk/support/",
        text: "顯示所有支援方式",
        anchor: "",
        linktype: "internal",
        class: "",
        title: "",
        querystring: "",
        id: "{9C6D9E13-7967-40EA-AAAA-753CA0685D6C}",
      },
    },
    buttonMode: {
      id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
      fieldType: "Droplink",
      fieldName: "buttonMode",
      url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
      fields: {
        value: { value: "Primary" },
        key: { value: "Primary" },
      },
    },
    linkGALabelName: { value: "" },
    gaLabelName: { value: "" },
    gaCategoryName: { value: "" },
  },
  callbackForm: {
    sitecoreContext: {
      sitecore: {
        context: {
          pageEditing: false,
          site: { name: "fwd-hk" },
          pageState: "normal",
          language: "zh-HK",
          languageCode: "tc",
          defaultLanguage: "zh-HK",
          siteSettings: {
            productListPage: "/products/",
            splashPage: "",
            articleTagLink: "/search/",
            articleTypeDesign: [],
            articleOverlineText: false,
            globalMetaText: "富衛香港",
            globalMetaTag: "",
            cookieMessage:
              '<p>我們使用Cookies以優化您於我們網站的瀏覽體驗。如繼續瀏覽本網站，即表示您同意我們使用 Cookie 。</p>\n<p>詳情請參閱我們的<a href="~/link.aspx?_id=DCD61657FA884252B0580B7EBE7F06F1&amp;_z=z">Cookie</a>政策。</p>',
            cookieTimeStamp: "10",
            currencyPlacement: "BeforeNumericals",
            currencyWhitespace: false,
            currencySeparator: { value: {} },
            currencyLabel: {
              value: {
                USD: "美元",
                EUR: "歐元",
                HKD: "港元",
                AUD: "澳元",
                RMB: "人民幣",
              },
            },
            splashPageUpdatedDuration: "10",
            splashPageUpdatedDate: "",
            faviconImageUrl:
              "/-/media/global/images/icons/favicon.ico?rev=51cce1bfcfb347b3b2fc7d304180401d",
            productErrorPictogramUrl:
              "/-/media/pictograms/no-result-48px2x.png?rev=6b3f1e7975b545d780c8a676eb165ef0",
            dateFormat: "YYYY年M月D日",
            enablePlanCardSharePostCalc: "",
            sessionTimeout: "20",
            loaderTimeout: "20",
            gAID: "GTM-N6B3G67",
            gTMID: "GTM-N6B3G67",
            gtmParamters: [],
            optimize360: true,
            hostName: "https://www.fwd.com.hk",
            enableBackToTopButton: 1,
            dialogSessionTimeout: "20",
            productFallbackCTA: {
              value: {
                href: "/forms-list/product-enquiry-form",
                text: "查詢",
                anchor: "Enquire",
                linkType: "form",
                title: "查詢",
                queryString: "enquiry",
                id: "{F2728281-FA5C-41CB-B168-773E0C78197F}",
                gaLabel: "Enquiry",
              },
            },
            brightcoveAccountID: "5650355171001",
            languageIcon: { key: "language-globe", value: "language-globe" },
            enableMultipleNotifications: true,
            hidePrimaryLanguage: true,
            currencyGALabelName: "",
            showArticleSubtitle: false,
            hasArticleSubtitleFallback: false,
          },
          share: {
            socialApps: [
              {
                facebook: {
                  url: {
                    value: {
                      href: "https://www.facebook.com/sharer.php?u=",
                      text: "Facebook Url",
                      linktype: "external",
                      url: "https://www.facebook.com/sharer.php?u=",
                      anchor: "",
                      target: "",
                    },
                  },
                  header: { value: "分享至Facebook" },
                  toolTip: { value: "" },
                },
              },
              {
                Whatsapp: {
                  url: {
                    value: {
                      href: "https://web.whatsapp.com/send?text=",
                      linktype: "external",
                      url: "https://web.whatsapp.com/send?text=",
                      anchor: "",
                      target: "",
                    },
                  },
                  header: { value: "分享至Whatsapp" },
                  toolTip: { value: "" },
                },
              },
              {
                Linkedin: {
                  url: {
                    value: {
                      href: "https://www.linkedin.com/sharing/share-offsite/?url=",
                      linktype: "external",
                      url: "https://www.linkedin.com/sharing/share-offsite/?url=",
                      anchor: "",
                      target: "",
                    },
                  },
                  header: { value: "分享至Linkedin" },
                  toolTip: { value: "" },
                },
              },
            ],
          },
          siteNotifications: {
            notifications: [
              {
                hidePublishDate: { value: true },
                publishDate: "2022-08-18T04:08:00Z",
                description: {
                  value:
                    '<span style="color: #183028;">最新消息：富衛推出</span><span style="color: #183028;">「疫苗副作用特別保障」，</span>點擊<a href="/coronavirusfaq">此處</a>了解。',
                },
                expiryDate: "2024-03-31T00:00:00Z",
                pagesList: { value: "/" },
                icon: {
                  id: "c0c57154-6ec6-4264-8d86-a4efebbd1533",
                  fieldType: "CustomDroplink",
                  fieldName: "icon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/notification---obsolete",
                  fields: {
                    value: { value: "notification-icon" },
                    key: { value: "Notification" },
                  },
                },
              },
              {
                hidePublishDate: { value: true },
                publishDate: "2022-04-26T09:58:00Z",
                description: {
                  value:
                    "本網站 (https://fwd.com.hk/blog) 由富衛金融有限公司營運。富衛金融有限公司乃富衛人壽保險（百慕達）有限公司及富衛保險有限公司的委任持牌保險代理。",
                },
                expiryDate: "2030-12-31T23:30:00Z",
                pagesList: { value: "/blog/" },
              },
              {
                hidePublishDate: { value: true },
                publishDate: "2022-08-03T04:13:00Z",
                description: {
                  value:
                    "2019冠狀病毒病特別安排：富衛保險綜合服務中心之服務時間為星期一至六上午9時30分至下午5時30分，星期日及公眾假期休息。另外，客戶熱線的服務時間為每日上午9時至下午6時。",
                },
                expiryDate: "2025-11-30T11:36:00Z",
                pagesList: { value: "/, /business/" },
                icon: {
                  id: "c4ce9c6d-80fa-402f-9b49-87c412a21684",
                  fieldType: "CustomDroplink",
                  fieldName: "icon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/alert---obsolete",
                  fields: {
                    value: { value: "alert" },
                    key: { value: "alert" },
                  },
                },
              },
              {
                hidePublishDate: { value: true },
                publishDate: "2022-02-22T08:07:45Z",
                description: {
                  value:
                    '本網站 (<a href="https://www.fwd.com.hk/claims/">https://fwd.com.hk/claims</a>) 由富衛金融有限公司營運。富衛金融有限公司乃富衛人壽保險（百慕達）有限公司及富衛保險有限公司的委任持牌保險代理。',
                },
                expiryDate: "2030-02-22T00:00:00Z",
                pagesList: { value: "/claims/" },
              },
              {
                hidePublishDate: { value: true },
                publishDate: "2022-02-22T08:07:45Z",
                description: {
                  value:
                    '本網站 (<a href="https://www.fwd.com.hk/products">https://fwd.com.hk/products</a>) 由富衛金融有限公司營運。富衛金融有限公司乃富衛人壽保險（百慕達）有限公司及富衛保險有限公司的委任持牌保險代理。\n<div id="gtx-trans" style="position: absolute; left: 35px; top: 21px;">\n<div class="gtx-trans-icon">&nbsp;</div>\n</div>',
                },
                expiryDate: "2030-02-22T00:00:00Z",
                pagesList: { value: "/products/" },
              },
              {
                hidePublishDate: { value: true },
                publishDate: "2022-02-22T08:07:45Z",
                description: {
                  value:
                    '本網站 (<a href="https://www.fwd.com.hk/support">https://fwd.com.hk/support</a>) 由富衛金融有限公司營運。富衛金融有限公司乃富衛人壽保險（百慕達）有限公司及富衛保險有限公司的委任持牌保險代理。',
                },
                expiryDate: "2030-02-22T00:00:00Z",
                pagesList: { value: "https://www.fwd.com.hk/support/" },
              },
              {
                hidePublishDate: { value: true },
                publishDate: "2022-02-24T03:04:00Z",
                description: {
                  value:
                    "本網站 (https://fwd.com.hk) 由富衛人壽保險（百慕達）有限公司營運。",
                },
                expiryDate: "2025-11-30T11:36:00Z",
                pagesList: { value: "/, /business/" },
                icon: {
                  id: "c4ce9c6d-80fa-402f-9b49-87c412a21684",
                  fieldType: "CustomDroplink",
                  fieldName: "icon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/alert---obsolete",
                  fields: {
                    value: { value: "alert" },
                    key: { value: "alert" },
                  },
                },
              },
            ],
          },
          dialogModals: { modalList: [] },
          disclosurePopups: {
            popupList: [
              {
                title: { value: "風險披露聲明" },
                footerText: { value: "" },
                text: {
                  value:
                    '<p style="text-align: center;">（只適用於投資相連壽險計劃）\n</p>\n<ul>\n    <li>此乃富衛人壽保險（百慕達）有限公司<span style="color: #183028;">( 在百慕達註冊成立的有限責任公司</span><span style="color: #183028;">)</span>（"富衛"）發行之投資相連壽險計劃（"ILAS"）的投資選擇。 閣下之投資需承受富衛之信貸風險。<br />\n    <br />\n    </li>\n    <li>雖然閣下的<span style="color: #183028;">ILAS</span><span style="color: #183028;">是一份人壽保單，因身故權益與閣下不時所選擇的投資選擇表現掛鈎，閣下的身故權益須承受投資風險與市場波動。應付的身故權益可能顯著少於閣下已支付的保費，並且可能不足以滿足閣下的個人需求。</span></li>\n</ul>\n<ul>\n    <li><span style="color: #183028;">閣下就</span><span style="color: #183028;">ILAS</span><span style="color: #183028;">支付的保費</span>，<span style="color: #183028;">及任何由富衛按閣下選擇的投資選擇進行投資的相關基金，將成為</span>及留為<span style="color: #183028;">富衛資產的一部分。閣下對任何該等資產均沒有任何權利或擁有權。若追討賠償，閣下只可向富衛追索。</span></li>\n</ul>\n<ul>\n    <li>閣下所支付的保費將會由富衛按閣下所選擇的投資選擇，投資於投資選擇相對應的相關基金當中，以讓富衛進行資產負債管理。而分配給閣下保單戶口内的單位只是名義上的分配，目的只是用來釐定閣下保單内的戶口價值及權益。</li>\n</ul>\n<ul>\n    <li>閣下之投資回報是由富衛參照相關基金的的表現來計算。並且閣下的回報須持續支付收費及費用，並將從<span style="color: #183028;">ILAS</span><span style="color: #183028;">中扣除，因此回報或會低於相對應之相關基金的回報。各相關基金均有其各自的投資概況及相關風險。可供選擇的投資選擇相對應的相關基金均載列於投資選擇刊物內。這些相關基金是由證監會依據《單位信託及互惠基金守則》作出認可。請注意，證監會認可不等如對該產品作出推介或認許，亦不是對該產品的商業利弊或表現作出保證，更不代表該產品適合所有投資者，或認許該產品適合任何個別投資者或任何類別的投資者。</span></li>\n</ul>\n<ul>\n    <li>若提前終止、退保或於<span style="color: #183028;">ILAS</span><span style="color: #183028;">的戶口價值作部分提款</span>，<span style="color: #183028;">閣下的投資、已支付的本金及可收取的獎賞（如有）可能會蒙受重大損失。若相關基金表現欠佳，閣下所蒙受的投資虧損或會進一步擴大，而一切收費仍可被扣除。除此之外，根據美國的《外國帳戶稅收合規法》，若閣下的保單是由一家非參與的外國金融機構的公司持有，富衛可能終止閣下的</span><span style="color: #183028;">ILAS</span><span style="color: #183028;">。</span><span style="color: #183028;"></span></li>\n</ul>\n<ul>\n    <li><span style="color: #183028;">ILAS 所提供的各個投資選擇在產品特點及風險狀況或會有很大差異，部份投資選擇可能涉及高風險。部分投資選擇相對應的相關基金是衍生工具風險承擔淨額超逾其淨資產價值的50%的衍生產品基金。它可能只適合了解衍生產品複雜結構和相關風險的投資者。如果投資這些投資選擇，閣下可能會蒙受重大損失。懇請閣下謹慎選擇此投資選擇。</span><br />\n    <br />\n    </li>\n    <li>投資的決定是屬於閣下的，除非閣下已明白及獲解釋本產品適合閣下，否則閣下不應購買本產品。</li>\n</ul>\n<ul>\n    <li>投資選擇名字尾部標示有(「分派」) (統稱為「投資選擇(現金分派)」)連繫到相關基金旨在定期派息的股份類別。投資選擇(現金分派)可能會派發現金派息。若閣下選擇投資於此等投資選擇，若富衛從投資選擇的相關基金收取到相關的派息，閣下將獲現金派息。請注意:</li>\n</ul>\n<ol style="list-style-type: lower-roman; margin-left: 40px;">\n    <li><span>個別投資選擇</span><span>(</span><span>現金分派</span><span>)</span><span>相對應的相關基金可在其</span><span style="background: white; color: #1c1c1c;">酌情決定下從相關基金資本作出派息</span> <span>(</span><span>即是，獲總收入同時從<span style="background-color: #ffffff; color: #1c1c1c;">相關</span>基金的資本中收取</span><span>/</span><span>支付<span style="background-color: #ffffff; color: #1c1c1c;">相關基金</span>所有或部分費用及開支，從而導致<span style="background-color: #ffffff; color: #1c1c1c;">相關</span>基金用作派付的派息的可分派收入增加</span><span>。</span><span>)</span></li>\n    <li><span>相對應的相關基金從資本中</span><span style="background: white; color: #1c1c1c;">撥付派息，代表將投資者原投資金額或原投資金額應佔的任何資本收益部分退回或提取。</span></li>\n    <li><span>任何分派涉及從資本中撥付派息，將導致相關基金的每單位的淨資產價值即時減低，此舉會對投資選擇</span><span>(</span><span>現金分派</span><span>)</span><span>的價格有負面影響。這會導致閣下保單的戶口價值減低。在此情況下，身故權益、退保權益及期滿權益將會減少。</span></li>\n    <li><span>投資選擇</span><span>(</span><span>現金分派</span><span>)</span><span>相對應的相關基金並不保證</span><span>會派發現金派息或派發定額現金派息或定期派發現金派息。獲派發現金派息的金額並不能作為</span><span>未來將會派發的現金派息的</span><span>指標</span><span>、預測或推測</span><span>。</span></li>\n</ol>\n<p><strong><span style="color: #183028;">投資涉及風險，閣下應該細閱</span></strong><strong><span style="color: #183028;"> ILAS</span></strong><strong><span style="color: #183028;">及相關基金的銷售文件<strong>。</strong></span></strong></p>\n<p><strong>投資涉及風險。基金往績不應視作未來業績表現的指標。閣下不應只根據此資料而投資。有關 ILAS 之詳情及其風險因素，請參閱主要銷售文件。</strong></p>\n<p><strong>\n<br />\n發行人<br />\n富衛人壽保險（百慕達）有限公司</strong><strong><span style="color: #183028;">( 在百慕達註冊成立的有限責任公司</span></strong><strong><span style="color: #183028;">)</span></strong></p>\n<div><strong>&nbsp;</strong></div>',
                },
                sticky: { value: true },
                activeAtEndOfScroll: { value: true },
                isRiskDisclosure: { value: true },
                defaultPageLink: {
                  value: {
                    href: "/products/",
                    text: "",
                    anchor: "",
                    linktype: "internal",
                    class: "",
                    title: "",
                    querystring: "",
                    id: "{DB3FF0BC-2E10-4735-8BAA-76A87A906821}",
                  },
                },
                sessionTimeout: { value: "1" },
                enableSmallView: { value: false },
                frequency: {
                  id: "8342b7fa-a8ba-4fd5-b7ca-fea9248e4f42",
                  fieldType: "Droplink",
                  fieldName: "frequency",
                  url: "/sitecore/content/fwd/global/settings/list/disclosure-frequency-type/once-in-browsing-session",
                  fields: {
                    value: { value: "Once in browsing session" },
                    key: { value: "once-in-browsing-session" },
                  },
                },
                buttonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "buttonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                link: {
                  value: {
                    href: "/products/invest/",
                    text: "我已閱讀、了解及接受以上資訊。",
                    anchor: "",
                    linktype: "internal",
                    class: "",
                    title: "",
                    target: "",
                    querystring: "",
                    id: "{2375DA5B-104B-4B0C-A915-78223732320F}",
                  },
                },
                buttonMode: {
                  id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                  fieldType: "Droplink",
                  fieldName: "buttonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
                  fields: {
                    value: { value: "Primary" },
                    key: { value: "Primary" },
                  },
                },
                linkGALabelName: { value: "" },
                closeCTALabel: { value: "" },
                isCloseCTA: { value: false },
                secondaryLinkButtonMode: {
                  id: "b096e18e-daae-43a8-87dd-1775ad1f16b6",
                  fieldType: "Droplink",
                  fieldName: "secondaryLinkButtonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/secondary",
                  fields: {
                    value: { value: "Secondary" },
                    key: { value: "Secondary" },
                  },
                },
                secondaryLinkGALabelName: { value: "" },
                secondaryLink: { value: {} },
                secondaryLinkButtonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "secondaryLinkButtonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                secondaryCloseCTALabel: { value: "我不想繼續。" },
                isSecondaryCloseCTA: { value: true },
                FormParameters: { value: {} },
                IsFormPost: { value: false },
                id: "a502d7b5-56e5-49ee-af75-d767bb290981",
              },
              {
                title: { value: "" },
                footerText: { value: "" },
                text: {
                  value:
                    "富衛所分銷之強積金產品現由永明金融提供，您將被轉至相關強積金計劃的行政管理人網頁，以查閱您的強積金帳戶。",
                },
                sticky: { value: true },
                activeAtEndOfScroll: { value: true },
                isRiskDisclosure: { value: false },
                defaultPageLink: {
                  value: {
                    href: "/",
                    text: "",
                    anchor: "",
                    linktype: "internal",
                    class: "",
                    title: "",
                    querystring: "",
                    id: "{9CB72689-FA18-4900-B876-3AE397D3B009}",
                  },
                },
                sessionTimeout: { value: "10" },
                enableSmallView: { value: false },
                frequency: {
                  id: "8342b7fa-a8ba-4fd5-b7ca-fea9248e4f42",
                  fieldType: "Droplink",
                  fieldName: "frequency",
                  url: "/sitecore/content/fwd/global/settings/list/disclosure-frequency-type/once-in-browsing-session",
                  fields: {
                    value: { value: "Once in browsing session" },
                    key: { value: "once-in-browsing-session" },
                  },
                },
                buttonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "buttonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                link: {
                  value: {
                    href: "/products/invest/orso/",
                    text: "前往",
                    anchor: "",
                    linktype: "internal",
                    class: "",
                    title: "",
                    querystring: "",
                    id: "{1350A039-E306-4354-B38B-5BFB085DEC5A}",
                  },
                },
                buttonMode: {
                  id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                  fieldType: "Droplink",
                  fieldName: "buttonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
                  fields: {
                    value: { value: "Primary" },
                    key: { value: "Primary" },
                  },
                },
                linkGALabelName: { value: "" },
                closeCTALabel: { value: "" },
                isCloseCTA: { value: false },
                secondaryLinkButtonMode: {
                  id: "b096e18e-daae-43a8-87dd-1775ad1f16b6",
                  fieldType: "Droplink",
                  fieldName: "secondaryLinkButtonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/secondary",
                  fields: {
                    value: { value: "Secondary" },
                    key: { value: "Secondary" },
                  },
                },
                secondaryLinkGALabelName: { value: "" },
                secondaryLink: { value: {} },
                secondaryLinkButtonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "secondaryLinkButtonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                secondaryCloseCTALabel: { value: "" },
                isSecondaryCloseCTA: { value: false },
                FormParameters: { value: {} },
                IsFormPost: { value: false },
                id: "d6037e42-3522-4edd-8cd8-f814f3528e6b",
              },
              {
                title: { value: "" },
                footerText: { value: "" },
                text: {
                  value:
                    "<p>富衛與永明金融之香港退休保障服務分銷協議正式生效：</p>\n<p>由2017年10月3日起，富衛強積金計劃的保薦人改為香港永明金融有限公司（「永明金融」），故富衛強積金集成信託基本／綜合計劃亦改變為永明強積金基本／綜合計劃。</p>\n<p>富衛人壽保險（百慕達）有限公司（「富衛」）和永明金融雙方亦達成了為期15年的策略分銷協議，富衛的專屬代理人將可於香港分銷永明金融的強積金產品。</p>\n<p>如需更多有關永明金融強積金資料，請按「前往」瀏覽香港永明金融網站主頁及客戶服務專區，並登入網上退休金服務中心。如欲查詢相關強積金計劃，請致電 (852) 3183 1900。</p>\n<p>本網站所述之投資或不適合所有投資者。本網站提供的資料只供參考用途，並不構成任何投資建議。投資者應在作出任何投資決策之前尋求獨立意見。</p>\n<p>投資涉及風險，投資者或無法取回最初投資之金額。過往表現未必可作日後業績的準則。請詳細閱讀有關銷售文件，特別是基金特色及所涉及的風險。</p>\n<p>富衛受證監會監管。非香港居民在瀏灠本網頁所載資料前，有責任依循其所屬司法範圍的一切適用法例及規定。</p>\n<div>&nbsp;</div>",
                },
                sticky: { value: true },
                activeAtEndOfScroll: { value: true },
                isRiskDisclosure: { value: false },
                defaultPageLink: {
                  value: {
                    href: "/products/invest/orso/",
                    text: "",
                    anchor: "",
                    linktype: "internal",
                    class: "",
                    title: "",
                    target: "",
                    querystring: "",
                    id: "{1350A039-E306-4354-B38B-5BFB085DEC5A}",
                  },
                },
                sessionTimeout: { value: "10" },
                enableSmallView: { value: false },
                frequency: {
                  id: "0585858d-6024-4df6-a556-08bc04932510",
                  fieldType: "Droplink",
                  fieldName: "frequency",
                  url: "/sitecore/content/fwd/global/settings/list/disclosure-frequency-type/every-time-user-land-on-identified-page",
                  fields: {
                    value: {
                      value: "Every time user land on the identified page",
                    },
                    key: { value: "every-time-in-session" },
                  },
                },
                buttonIcon: null,
                link: {
                  value: {
                    href: "https://www.sunlife.com.hk/zh-hant/investments/mpf-orso-fund-prices-performance/?vgnLocale=zh_TW",
                    text: "前往",
                    linktype: "external",
                    url: "https://www.sunlife.com.hk/zh-hant/investments/mpf-orso-fund-prices-performance/?vgnLocale=zh_TW",
                    anchor: "",
                    target: "_blank",
                  },
                },
                buttonMode: {
                  id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                  fieldType: "Droplink",
                  fieldName: "buttonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
                  fields: {
                    value: { value: "Primary" },
                    key: { value: "Primary" },
                  },
                },
                linkGALabelName: { value: "" },
                closeCTALabel: { value: "" },
                isCloseCTA: { value: false },
                secondaryLinkButtonMode: {
                  id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                  fieldType: "Droplink",
                  fieldName: "secondaryLinkButtonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
                  fields: {
                    value: { value: "Primary" },
                    key: { value: "Primary" },
                  },
                },
                secondaryLinkGALabelName: { value: "" },
                secondaryLink: {
                  value: {
                    href: "/products/invest/orso/",
                    text: "關閉",
                    anchor: "",
                    linktype: "internal",
                    class: "",
                    title: "",
                    target: "",
                    querystring: "",
                    id: "{1350A039-E306-4354-B38B-5BFB085DEC5A}",
                  },
                },
                secondaryLinkButtonIcon: null,
                secondaryCloseCTALabel: { value: "" },
                isSecondaryCloseCTA: { value: true },
                FormParameters: { value: {} },
                IsFormPost: { value: false },
                id: "6907d3f8-481b-419c-b333-a1a0f654b773",
              },
              {
                title: { value: "" },
                footerText: { value: "" },
                text: {
                  value:
                    "<p><strong>重要</strong></p>\n<ul>\n    <li>富衛綜合公積金計劃（「本計劃」）是由富衛人壽保險(百慕達)有限公司 (「富衛人壽」）發出的保單所成立的集資退休計劃。</li>\n    <li>富衛本金保證基金的保證乃由富衛人壽所提供。因此，閣下於富衛本金保證基金的投資受富衛人壽的信用風險所影響。保證受本說明書附錄一所載有關富衛本金保證基金的限制性條件所管限。</li>\n    <li>計劃的各管理基金將投資於相應的項下基金。該等項下基金可能投資於具有不同風險概況的股票、債務證券及／或金融衍生工具（視情況而定）。</li>\n    <li>投資於新興市場的項下基金可能須承受較高的流通性及波動性風險。與依從更多元化投資政策的基金相比，投資於特定市場或行業的項下基金可能須承受較高的集中性風險。</li>\n    <li>與投資於較高信貸評級的債務證券的基金相比，投資於低評級或非投資級別的債務證券的項下基金或須承受較高的信貸及交易對手風險。</li>\n    <li>主要投資於金融衍生工具的項下基金可能須承受重大的流通性及交易對手違約風險，因此，項下基金可能出現重大損失。</li>\n    <li>計劃以保單形式組成。計劃的利益款項乃參考投資選項的表現計算，閣下並非投資於相關投資基金／資產，亦不會就相關投資基金／資產擁有任何權利或擁有權。有關相關投資基金／資產乃由富衛人壽合法擁有。閣下只擁有合約權利以向富衛人壽申索計劃項下利益的金額。閣下於計劃的投資因而須承受富衛人壽的信用風險。</li>\n    <li>閣下在作出任何投資選擇前，應考慮閣下本身的風險承受程度及財政狀況。如閣下對管理基金是否適合閣下（包括與閣下的投資目標是否一致）存有任何疑問，應諮詢獨立財務及╱或專業意見。</li>\n    <li>您不應僅倚賴此網站而作出投資。閣下應參閱本說明書以了解包括產品特點、費用及收費以及風險因素等有關進一步詳情（載列於第3節「投資風險及風險因素」）。</li>\n</ul>\n<p><strong>重要事項</strong>︰</p>\n<ul>\n    <li>本計劃已獲證劵及期貨事務監察委員會認可。有關認可並不意味著獲得證監會官方推介。</li>\n    <li>投資涉及風險；所呈列的過往表現資料不應視爲未來回報指標。本計劃內的每一項投資選擇不一定適合任何所有人士。投資回報並無擔保，而您的投資/累算權益或會承受重大損失。</li>\n    <li>有關本計劃和各基金的特點，請參閱本計劃的說明書。投資選擇或須承受的某些風險論述如下。有關項下基金的投資目標、政策、策略及風險，請參閱投資選擇相應的項下基金的最新銷售文件。如您對說明書及個别基金的銷售文件的內容的含義或影響有任何疑問，您應徵詢專業人士的意見。</li>\n</ul>\n<p>由富衛人壽保險（百慕達）有限公司發出。</p>\n<p><strong>重要資料</strong></p>\n<p>請細心閱讀下文後按 同意 ，以便繼續瀏覽網頁。</p>\n<p>本網站內包含的資料依其「現況」或「可利用之狀況」提取。本公司對上述資料及內容之充足性不予保證。關於上述資料本公司並不作出任何種類之暗示、明示或法律上保証，包括但不限於著作權、茲有權、可商售權、對開特定用途的適用權以及無電腦病毒等保証。</p>\n<p>本網站資料更新至刊載日期，如有更改將不會另行通知。</p>\n<p>獲強積金管理局和證券及期貨事務監察委員會註冊、核准或認可，並不意味官方推介。</p>\n<p>投資附帶風險，基金價格可跌可升。過往表現不應視為未來回報指標。詳情請參閱有關銷售說明書。</p>",
                },
                sticky: { value: true },
                activeAtEndOfScroll: { value: false },
                isRiskDisclosure: { value: false },
                defaultPageLink: {
                  value: {
                    href: "/products/invest/orso/",
                    text: "",
                    anchor: "",
                    linktype: "internal",
                    class: "",
                    title: "",
                    querystring: "",
                    id: "{1350A039-E306-4354-B38B-5BFB085DEC5A}",
                  },
                },
                sessionTimeout: { value: "2" },
                enableSmallView: { value: false },
                frequency: {
                  id: "0585858d-6024-4df6-a556-08bc04932510",
                  fieldType: "Droplink",
                  fieldName: "frequency",
                  url: "/sitecore/content/fwd/global/settings/list/disclosure-frequency-type/every-time-user-land-on-identified-page",
                  fields: {
                    value: {
                      value: "Every time user land on the identified page",
                    },
                    key: { value: "every-time-in-session" },
                  },
                },
                buttonIcon: null,
                link: {
                  value: {
                    href: "/products/invest/orso/fund-performance/",
                    text: "同意",
                    anchor: "",
                    linktype: "internal",
                    class: "",
                    title: "",
                    querystring: "",
                    id: "{08204FFD-2104-462A-9271-72552A3B5491}",
                  },
                },
                buttonMode: {
                  id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                  fieldType: "Droplink",
                  fieldName: "buttonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
                  fields: {
                    value: { value: "Primary" },
                    key: { value: "Primary" },
                  },
                },
                linkGALabelName: { value: "" },
                closeCTALabel: { value: "" },
                isCloseCTA: { value: false },
                secondaryLinkButtonMode: {
                  id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                  fieldType: "Droplink",
                  fieldName: "secondaryLinkButtonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
                  fields: {
                    value: { value: "Primary" },
                    key: { value: "Primary" },
                  },
                },
                secondaryLinkGALabelName: { value: "" },
                secondaryLink: {
                  value: {
                    href: "/products/invest/orso/",
                    text: "不同意",
                    anchor: "",
                    linktype: "internal",
                    class: "",
                    title: "",
                    querystring: "",
                    id: "{1350A039-E306-4354-B38B-5BFB085DEC5A}",
                  },
                },
                secondaryLinkButtonIcon: null,
                secondaryCloseCTALabel: { value: "" },
                isSecondaryCloseCTA: { value: true },
                FormParameters: { value: {} },
                IsFormPost: { value: false },
                id: "a87c6d76-dac0-4e31-b731-fd439a9d247b",
              },
              {
                title: { value: "閣下即將離開本網站" },
                footerText: { value: "" },
                text: {
                  value:
                    '<p>此超連結將連接至由第三方經營之網站。<br />\n<br />\n富衛人壽保險(百慕達) 有限公司 (於百慕達註冊成立之有限公司)(「富衛人壽」）不會就第三方網站之內容、產品、服務或資訊給予任何明示或暗示的批准、認可、保證及陳述，亦不會為該網站所包含之內容承擔任何責任。富衛人壽並不會就閣下因接入連結所引致或產生之損害或損失承擔任何責任。<br />\n<br />\n本人確認本人已參閱、明白及接受富衛人壽的<a rel="noopener noreferrer" href="https://www.fwd.com.hk/privacy-policy/fwd-life-insurance-company/" target="_blank">收集個人資料聲明</a>，並同意接受其約束。<br />\n<br />\n謹提示閣下當按下連結及進入第三方網站時，閣下將受所瀏覽之第三方網站的使用條款及私隱政策所約束。</p>\n<div>&nbsp;</div>\n<br />',
                },
                sticky: { value: true },
                activeAtEndOfScroll: { value: false },
                isRiskDisclosure: { value: false },
                defaultPageLink: { value: {} },
                sessionTimeout: { value: "" },
                enableSmallView: { value: false },
                frequency: {
                  id: "0585858d-6024-4df6-a556-08bc04932510",
                  fieldType: "Droplink",
                  fieldName: "frequency",
                  url: "/sitecore/content/fwd/global/settings/list/disclosure-frequency-type/every-time-user-land-on-identified-page",
                  fields: {
                    value: {
                      value: "Every time user land on the identified page",
                    },
                    key: { value: "every-time-in-session" },
                  },
                },
                buttonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "buttonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                link: {
                  value: {
                    href: "https://wa.me/85265320781",
                    text: "確認並繼續",
                    linktype: "external",
                    url: "https://wa.me/85265320781",
                    anchor: "",
                    target: "",
                  },
                },
                buttonMode: {
                  id: "02a5a5c7-c318-4919-b773-86a65ba98969",
                  fieldType: "Droplink",
                  fieldName: "buttonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/simple-link",
                  fields: {
                    value: { value: "SimpleLink" },
                    key: { value: "SimpleLink" },
                  },
                },
                linkGALabelName: { value: "" },
                closeCTALabel: { value: "" },
                isCloseCTA: { value: false },
                secondaryLinkButtonMode: {
                  id: "b096e18e-daae-43a8-87dd-1775ad1f16b6",
                  fieldType: "Droplink",
                  fieldName: "secondaryLinkButtonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/secondary",
                  fields: {
                    value: { value: "Secondary" },
                    key: { value: "Secondary" },
                  },
                },
                secondaryLinkGALabelName: { value: "" },
                secondaryLink: { value: {} },
                secondaryLinkButtonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "secondaryLinkButtonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                secondaryCloseCTALabel: { value: "返回" },
                isSecondaryCloseCTA: { value: true },
                FormParameters: { value: {} },
                IsFormPost: { value: false },
                id: "9393cb81-8d91-4cda-a494-70ab242c70a4",
              },
              {
                title: {
                  value: "正在前往富衛一般保險 (Bolttech集團成員) 網站",
                },
                footerText: { value: "" },
                text: {
                  value:
                    "此導向本身不構成富衛人壽保險(百慕達) 有限公司 (於百慕達註冊成立之有限公司)(「富衛人壽」）對富衛一般保險或其超連結之內容、產品、服務或其中包含或可用的資訊給予任何明示或暗示的批准、認可、保證及陳述。富衛人壽對連結之富衛一般保險網站所包含之內容並不負任何責任及不會就任何由於閣下接入連結所引致或產生之損害或損失負上任何責任。",
                },
                sticky: { value: true },
                activeAtEndOfScroll: { value: true },
                isRiskDisclosure: { value: true },
                defaultPageLink: {
                  value: {
                    href: "/fwd/fwd-hk/Home/Products/car-boat/motor-smart-plus",
                    linktype: "external",
                    url: "/fwd/fwd-hk/Home/Products/car-boat/motor-smart-plus",
                    anchor: "",
                    target: "",
                  },
                },
                sessionTimeout: { value: "1" },
                enableSmallView: { value: false },
                frequency: {
                  id: "0585858d-6024-4df6-a556-08bc04932510",
                  fieldType: "Droplink",
                  fieldName: "frequency",
                  url: "/sitecore/content/fwd/global/settings/list/disclosure-frequency-type/every-time-user-land-on-identified-page",
                  fields: {
                    value: {
                      value: "Every time user land on the identified page",
                    },
                    key: { value: "every-time-in-session" },
                  },
                },
                buttonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "buttonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                link: {
                  value: {
                    href: "https://www.fwdgi.hk/car-insurance?pc=FMSPO10&utm_source=ifwd&utm_medium=referral&utm_content=buynowbutton",
                    text: "同意並繼續",
                    linktype: "external",
                    url: "https://www.fwdgi.hk/car-insurance?pc=FMSPO10&utm_source=ifwd&utm_medium=referral&utm_content=buynowbutton",
                    anchor: "",
                    target: "",
                  },
                },
                buttonMode: {
                  id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                  fieldType: "Droplink",
                  fieldName: "buttonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
                  fields: {
                    value: { value: "Primary" },
                    key: { value: "Primary" },
                  },
                },
                linkGALabelName: { value: "" },
                closeCTALabel: { value: "" },
                isCloseCTA: { value: false },
                secondaryLinkButtonMode: {
                  id: "b096e18e-daae-43a8-87dd-1775ad1f16b6",
                  fieldType: "Droplink",
                  fieldName: "secondaryLinkButtonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/secondary",
                  fields: {
                    value: { value: "Secondary" },
                    key: { value: "Secondary" },
                  },
                },
                secondaryLinkGALabelName: { value: "" },
                secondaryLink: { value: {} },
                secondaryLinkButtonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "secondaryLinkButtonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                secondaryCloseCTALabel: { value: "" },
                isSecondaryCloseCTA: { value: false },
                FormParameters: { value: {} },
                IsFormPost: { value: false },
                id: "5ff33e21-1230-4247-8dfe-ae59221944fa",
              },
              {
                title: {
                  value: "正在前往富衛一般保險 (Bolttech集團成員) 網站",
                },
                footerText: { value: "" },
                text: {
                  value:
                    "此導向本身不構成富衛人壽保險(百慕達) 有限公司 (於百慕達註冊成立之有限公司)(「富衛人壽」）對富衛一般保險或其超連結之內容、產品、服務或其中包含或可用的資訊給予任何明示或暗示的批准、認可、保證及陳述。富衛人壽對連結之富衛一般保險網站所包含之內容並不負任何責任及不會就任何由於閣下接入連結所引致或產生之損害或損失負上任何責任。",
                },
                sticky: { value: true },
                activeAtEndOfScroll: { value: true },
                isRiskDisclosure: { value: true },
                defaultPageLink: {
                  value: {
                    href: "/fwd/fwd-hk/Home/Products/helper/helper-care-insurance",
                    linktype: "external",
                    url: "/fwd/fwd-hk/Home/Products/helper/helper-care-insurance",
                    anchor: "",
                    target: "",
                  },
                },
                sessionTimeout: { value: "1" },
                enableSmallView: { value: false },
                frequency: {
                  id: "0585858d-6024-4df6-a556-08bc04932510",
                  fieldType: "Droplink",
                  fieldName: "frequency",
                  url: "/sitecore/content/fwd/global/settings/list/disclosure-frequency-type/every-time-user-land-on-identified-page",
                  fields: {
                    value: {
                      value: "Every time user land on the identified page",
                    },
                    key: { value: "every-time-in-session" },
                  },
                },
                buttonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "buttonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                link: {
                  value: {
                    href: "https://www.fwdgi.hk/domestic-helper-insurance?utm_source=ifwd&utm_content=buynowbutton&pc=HELPER10",
                    text: "同意並繼續",
                    linktype: "external",
                    url: "https://www.fwdgi.hk/domestic-helper-insurance?utm_source=ifwd&utm_content=buynowbutton&pc=HELPER10",
                    anchor: "",
                    target: "",
                  },
                },
                buttonMode: {
                  id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                  fieldType: "Droplink",
                  fieldName: "buttonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
                  fields: {
                    value: { value: "Primary" },
                    key: { value: "Primary" },
                  },
                },
                linkGALabelName: { value: "" },
                closeCTALabel: { value: "" },
                isCloseCTA: { value: false },
                secondaryLinkButtonMode: {
                  id: "b096e18e-daae-43a8-87dd-1775ad1f16b6",
                  fieldType: "Droplink",
                  fieldName: "secondaryLinkButtonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/secondary",
                  fields: {
                    value: { value: "Secondary" },
                    key: { value: "Secondary" },
                  },
                },
                secondaryLinkGALabelName: { value: "" },
                secondaryLink: { value: {} },
                secondaryLinkButtonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "secondaryLinkButtonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                secondaryCloseCTALabel: { value: "" },
                isSecondaryCloseCTA: { value: false },
                FormParameters: { value: {} },
                IsFormPost: { value: false },
                id: "0a84b12a-2810-414e-a01c-ffc8f28b71c0",
              },
              {
                title: {
                  value: "正在前往富衛一般保險 (Bolttech集團成員) 網站",
                },
                footerText: { value: "" },
                text: {
                  value:
                    "此導向本身不構成富衛人壽保險(百慕達) 有限公司 (於百慕達註冊成立之有限公司)(「富衛人壽」）對富衛一般保險或其超連結之內容、產品、服務或其中包含或可用的資訊給予任何明示或暗示的批准、認可、保證及陳述。富衛人壽對連結之富衛一般保險網站所包含之內容並不負任何責任及不會就任何由於閣下接入連結所引致或產生之損害或損失負上任何責任。",
                },
                sticky: { value: true },
                activeAtEndOfScroll: { value: true },
                isRiskDisclosure: { value: true },
                defaultPageLink: {
                  value: {
                    href: "/fwd/fwd-hk/Home/Products/household-pets/home-care-insurance/",
                    linktype: "external",
                    url: "/fwd/fwd-hk/Home/Products/household-pets/home-care-insurance/",
                    anchor: "",
                    target: "",
                  },
                },
                sessionTimeout: { value: "1" },
                enableSmallView: { value: false },
                frequency: {
                  id: "0585858d-6024-4df6-a556-08bc04932510",
                  fieldType: "Droplink",
                  fieldName: "frequency",
                  url: "/sitecore/content/fwd/global/settings/list/disclosure-frequency-type/every-time-user-land-on-identified-page",
                  fields: {
                    value: {
                      value: "Every time user land on the identified page",
                    },
                    key: { value: "every-time-in-session" },
                  },
                },
                buttonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "buttonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                link: {
                  value: {
                    href: "https://www.fwdgi.hk/home-care-insurance?utm_source=ifwd&utm_content=buynowbutton&pc=HOMEC10",
                    text: "同意並繼續",
                    linktype: "external",
                    url: "https://www.fwdgi.hk/home-care-insurance?utm_source=ifwd&utm_content=buynowbutton&pc=HOMEC10",
                    anchor: "",
                    target: "",
                  },
                },
                buttonMode: {
                  id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                  fieldType: "Droplink",
                  fieldName: "buttonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
                  fields: {
                    value: { value: "Primary" },
                    key: { value: "Primary" },
                  },
                },
                linkGALabelName: { value: "" },
                closeCTALabel: { value: "" },
                isCloseCTA: { value: false },
                secondaryLinkButtonMode: {
                  id: "b096e18e-daae-43a8-87dd-1775ad1f16b6",
                  fieldType: "Droplink",
                  fieldName: "secondaryLinkButtonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/secondary",
                  fields: {
                    value: { value: "Secondary" },
                    key: { value: "Secondary" },
                  },
                },
                secondaryLinkGALabelName: { value: "" },
                secondaryLink: { value: {} },
                secondaryLinkButtonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "secondaryLinkButtonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                secondaryCloseCTALabel: { value: "" },
                isSecondaryCloseCTA: { value: false },
                FormParameters: { value: {} },
                IsFormPost: { value: false },
                id: "1af378f3-ec18-4f13-90aa-37c28070087d",
              },
              {
                title: {
                  value: "正在前往富衛一般保險 (Bolttech集團成員) 網站",
                },
                footerText: { value: "" },
                text: {
                  value:
                    "此導向本身不構成富衛人壽保險(百慕達) 有限公司 (於百慕達註冊成立之有限公司)(「富衛人壽」）對富衛一般保險或其超連結之內容、產品、服務或其中包含或可用的資訊給予任何明示或暗示的批准、認可、保證及陳述。富衛人壽對連結之富衛一般保險網站所包含之內容並不負任何責任及不會就任何由於閣下接入連結所引致或產生之損害或損失負上任何責任。",
                },
                sticky: { value: true },
                activeAtEndOfScroll: { value: true },
                isRiskDisclosure: { value: true },
                defaultPageLink: {
                  value: {
                    href: "/products/household-pets/easy-home-care/",
                    text: "",
                    anchor: "",
                    linktype: "internal",
                    class: "",
                    title: "",
                    target: "",
                    querystring: "",
                    id: "{4C2582F3-9667-4957-B3F9-53C8056EBA7F}",
                  },
                },
                sessionTimeout: { value: "1" },
                enableSmallView: { value: false },
                frequency: {
                  id: "0585858d-6024-4df6-a556-08bc04932510",
                  fieldType: "Droplink",
                  fieldName: "frequency",
                  url: "/sitecore/content/fwd/global/settings/list/disclosure-frequency-type/every-time-user-land-on-identified-page",
                  fields: {
                    value: {
                      value: "Every time user land on the identified page",
                    },
                    key: { value: "every-time-in-session" },
                  },
                },
                buttonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "buttonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                link: {
                  value: {
                    href: "https://www.fwdgi.hk/easy-home-insurance?utm_source=ifwd&pc=EHOME10",
                    text: "同意並繼續",
                    linktype: "external",
                    url: "https://www.fwdgi.hk/easy-home-insurance?utm_source=ifwd&pc=EHOME10",
                    anchor: "",
                    target: "",
                  },
                },
                buttonMode: {
                  id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                  fieldType: "Droplink",
                  fieldName: "buttonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
                  fields: {
                    value: { value: "Primary" },
                    key: { value: "Primary" },
                  },
                },
                linkGALabelName: { value: "" },
                closeCTALabel: { value: "" },
                isCloseCTA: { value: false },
                secondaryLinkButtonMode: {
                  id: "b096e18e-daae-43a8-87dd-1775ad1f16b6",
                  fieldType: "Droplink",
                  fieldName: "secondaryLinkButtonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/secondary",
                  fields: {
                    value: { value: "Secondary" },
                    key: { value: "Secondary" },
                  },
                },
                secondaryLinkGALabelName: { value: "" },
                secondaryLink: { value: {} },
                secondaryLinkButtonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "secondaryLinkButtonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                secondaryCloseCTALabel: { value: "" },
                isSecondaryCloseCTA: { value: false },
                FormParameters: { value: {} },
                IsFormPost: { value: false },
                id: "81e0fce7-b5ed-4ff2-959a-d1ef9a1d1fd9",
              },
              {
                title: {
                  value: "正在前往富衛一般保險 (Bolttech集團成員) 網站",
                },
                footerText: { value: "" },
                text: {
                  value:
                    "此導向本身不構成富衛人壽保險(百慕達) 有限公司 (於百慕達註冊成立之有限公司)(「富衛人壽」）對富衛一般保險或其超連結之內容、產品、服務或其中包含或可用的資訊給予任何明示或暗示的批准、認可、保證及陳述。富衛人壽對連結之富衛一般保險網站所包含之內容並不負任何責任及不會就任何由於閣下接入連結所引致或產生之損害或損失負上任何責任。",
                },
                sticky: { value: true },
                activeAtEndOfScroll: { value: true },
                isRiskDisclosure: { value: true },
                defaultPageLink: {
                  value: {
                    href: "/products/travel-golf/travel-care-insurance/",
                    text: "",
                    anchor: "",
                    linktype: "internal",
                    class: "",
                    title: "",
                    target: "",
                    querystring: "",
                    id: "{42609B4A-3495-46CB-93CD-20B2BA82AABD}",
                  },
                },
                sessionTimeout: { value: "1" },
                enableSmallView: { value: false },
                frequency: {
                  id: "0585858d-6024-4df6-a556-08bc04932510",
                  fieldType: "Droplink",
                  fieldName: "frequency",
                  url: "/sitecore/content/fwd/global/settings/list/disclosure-frequency-type/every-time-user-land-on-identified-page",
                  fields: {
                    value: {
                      value: "Every time user land on the identified page",
                    },
                    key: { value: "every-time-in-session" },
                  },
                },
                buttonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "buttonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                link: {
                  value: {
                    href: "https://www.fwdgi.hk/travel-insurance?utm_source=ifwd&pc=TRAVEL30",
                    text: "同意並繼續",
                    linktype: "external",
                    url: "https://www.fwdgi.hk/travel-insurance?utm_source=ifwd&pc=TRAVEL30",
                    anchor: "",
                    target: "",
                  },
                },
                buttonMode: {
                  id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                  fieldType: "Droplink",
                  fieldName: "buttonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
                  fields: {
                    value: { value: "Primary" },
                    key: { value: "Primary" },
                  },
                },
                linkGALabelName: { value: "" },
                closeCTALabel: { value: "" },
                isCloseCTA: { value: false },
                secondaryLinkButtonMode: {
                  id: "b096e18e-daae-43a8-87dd-1775ad1f16b6",
                  fieldType: "Droplink",
                  fieldName: "secondaryLinkButtonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/secondary",
                  fields: {
                    value: { value: "Secondary" },
                    key: { value: "Secondary" },
                  },
                },
                secondaryLinkGALabelName: { value: "" },
                secondaryLink: { value: {} },
                secondaryLinkButtonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "secondaryLinkButtonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                secondaryCloseCTALabel: { value: "" },
                isSecondaryCloseCTA: { value: false },
                FormParameters: { value: {} },
                IsFormPost: { value: false },
                id: "70835a3d-3089-4cb4-9520-cb33336b4eac",
              },
            ],
          },
          localizedPages: [
            { "en-hk": "/en/products" },
            { "zh-Hant-hk": "/products" },
          ],
          isRequestFromExternalSource: false,
          availableLanguages: ["en", "tc"],
        },
        route: {
          name: "Products",
          displayName: "Products",
          fields: {
            contentType: null,
            pagedescription: { value: "" },
            pagetitle: { value: "" },
            disableHTMLCache: { value: false },
            globalMetaTextSetting: null,
            pageType: {
              id: "4fded742-177c-4850-9853-fa31cc47d63e",
              fieldType: "Droplink",
              fieldName: "pageType",
              url: "/components/pagetype/individual",
              fields: {
                value: { value: "Individual" },
                key: { value: "individual" },
              },
            },
            localizedPages: { value: {} },
            metadataTitle: { value: "富衛保險產品" },
            metadataDescription: {
              value:
                "富衛設計保險產品的理念源自客戶。現在就探索富衛的保險產品, 選擇最適合您，您的生活及需求的保險產品。",
            },
            metadataKeywords: { value: "" },
            overwriteGlobalMetaTag: { value: false },
            additionalMetaTag: { value: "" },
            accrediationValue: null,
            accreditationMode: null,
            accreditationDescription: { value: "" },
            disableCompliance: { value: false },
            Priority: { value: "1" },
            openGraphType: { value: "" },
            openGraphDescription: { value: "" },
            openGraphURL: { value: {} },
            openGraphImage: { value: {} },
            openGraphTitle: { value: "" },
            canonicalUrl: { value: "" },
            isPageSearchable: { value: true },
            hideInSitemap: { value: false },
            hideLocalizedVersion: { value: false },
            seoScript: { value: "" },
          },
          databaseName: "web",
          deviceId: "fe5d7fdf-89c0-4d99-9aa3-b5fbd009c9f3",
          itemId: "db3ff0bc-2e10-4735-8baa-76a87a906821",
          itemLanguage: "zh-HK",
          itemVersion: 1,
          layoutId: "e60605a5-f4f9-479a-b992-741bce767b1d",
          templateId: "52873596-fd74-488b-9e6e-6382b1cc2eb2",
          templateName: "Product Listing Page",
          placeholders: {
            "jss-metadata": [],
            "jss-header": [
              {
                uid: "abaca3eb-6579-47ef-b88f-c9e713f1ec17",
                componentName: "Header",
                dataSource: "{52FE66AF-9AFC-4EAD-9027-76A10FFC8C75}",
                params: {
                  backgroundColor: "white-orange",
                  paddingTop: "None",
                  paddingBottom: "None",
                },
                fields: {
                  iconNavigationLinks: [
                    {
                      id: "386f4e5d-7e07-4bb4-a649-4aea9ff4f806",
                      name: "Login",
                      displayName: "Login",
                      fields: {
                        enableDropdown: { value: true },
                        buttonIcon: {
                          id: "a12ce2e2-a53a-455b-8c36-2050fedba642",
                          fieldType: "CustomDroplink",
                          fieldName: "buttonIcon",
                          url: "/sitecore/content/fwd/global/settings/list/linkvariant/team",
                          fields: {
                            value: { value: "team" },
                            key: { value: "Team" },
                          },
                        },
                        title: { value: "登錄" },
                        link: { value: {} },
                        listType: {
                          id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                          fieldType: "Droplink",
                          fieldName: "listType",
                          url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                          fields: {
                            value: { value: "Generic Link" },
                            key: { value: "generic_link" },
                          },
                        },
                        gaLabelName: { value: "Login" },
                        gaCategoryName: { value: "" },
                      },
                      Children: [
                        {
                          id: "8857e87a-6c66-4c2e-95c5-21592c529311",
                          name: "Customer",
                          displayName: "Customer",
                          fields: {
                            buttonIcon: {
                              id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                              fieldType: "CustomDroplink",
                              fieldName: "buttonIcon",
                              url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                              fields: {
                                value: { value: "chevron-right" },
                                key: { value: "chevronRight" },
                              },
                            },
                            title: { value: "個人 / 團體醫療保險 " },
                            link: {
                              value: {
                                href: "https://eservices.fwd.com.hk/web/fwd/login/index",
                                linktype: "external",
                                url: "https://eservices.fwd.com.hk/web/fwd/login/index",
                                anchor: "",
                                target: "",
                              },
                            },
                            listType: {
                              id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                              fieldType: "Droplink",
                              fieldName: "listType",
                              url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                              fields: {
                                value: { value: "Generic Link" },
                                key: { value: "generic_link" },
                              },
                            },
                            gaLabelName: {
                              value: "Individual / Group Medical Insurance ",
                            },
                            gaCategoryName: { value: "" },
                          },
                        },
                        {
                          id: "68c50418-4c45-4ebc-812b-809d77ded615",
                          name: "MPF account",
                          displayName: "MPF account",
                          fields: {
                            buttonIcon: {
                              id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                              fieldType: "CustomDroplink",
                              fieldName: "buttonIcon",
                              url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                              fields: {
                                value: { value: "chevron-right" },
                                key: { value: "chevronRight" },
                              },
                            },
                            title: { value: "強積金賬戶 " },
                            link: {
                              value: {
                                text: "",
                                linktype: "modelpopup",
                                querystring: "",
                                target: "",
                                id: "{D6037E42-3522-4EDD-8CD8-F814F3528E6B}",
                                disclosurepopupcontent: {
                                  disclosure: {
                                    value:
                                      "d6037e42-3522-4edd-8cd8-f814f3528e6b",
                                  },
                                },
                              },
                            },
                            listType: {
                              id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                              fieldType: "Droplink",
                              fieldName: "listType",
                              url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                              fields: {
                                value: { value: "Generic Link" },
                                key: { value: "generic_link" },
                              },
                            },
                            gaLabelName: { value: "MPF account" },
                            gaCategoryName: { value: "" },
                          },
                        },
                        {
                          id: "196ffd7d-c5d6-491e-a472-52f8857fc7d3",
                          name: "Agents",
                          displayName: "Agents",
                          fields: {
                            buttonIcon: {
                              id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                              fieldType: "CustomDroplink",
                              fieldName: "buttonIcon",
                              url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                              fields: {
                                value: { value: "chevron-right" },
                                key: { value: "chevronRight" },
                              },
                            },
                            title: { value: "理財顧問 " },
                            link: {
                              value: {
                                href: "https://irisplus.fwd.com.hk/",
                                text: "Agents",
                                linktype: "external",
                                url: "https://irisplus.fwd.com.hk/",
                                anchor: "",
                                target: "",
                              },
                            },
                            listType: {
                              id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                              fieldType: "Droplink",
                              fieldName: "listType",
                              url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                              fields: {
                                value: { value: "Generic Link" },
                                key: { value: "generic_link" },
                              },
                            },
                            gaLabelName: { value: "Agent Login" },
                            gaCategoryName: { value: "" },
                          },
                        },
                        {
                          id: "c2be08a0-e9db-4930-a9c1-44e935e38e52",
                          name: "Partners",
                          displayName: "Partners",
                          fields: {
                            buttonIcon: {
                              id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                              fieldType: "CustomDroplink",
                              fieldName: "buttonIcon",
                              url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                              fields: {
                                value: { value: "chevron-right" },
                                key: { value: "chevronRight" },
                              },
                            },
                            title: { value: "合作伙伴 " },
                            link: {
                              value: {
                                href: "https://irisplus.fwd.com.hk/",
                                linktype: "external",
                                url: "https://irisplus.fwd.com.hk/",
                                anchor: "",
                                target: "",
                              },
                            },
                            listType: {
                              id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                              fieldType: "Droplink",
                              fieldName: "listType",
                              url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                              fields: {
                                value: { value: "Generic Link" },
                                key: { value: "generic_link" },
                              },
                            },
                            gaLabelName: { value: "Partners Login" },
                            gaCategoryName: { value: "" },
                          },
                        },
                        {
                          id: "86e3ca61-2631-4739-bce5-d03e1499fcf3",
                          name: "FWD Wellness Pass",
                          displayName: "FWD Wellness Pass",
                          fields: {
                            buttonIcon: {
                              id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                              fieldType: "CustomDroplink",
                              fieldName: "buttonIcon",
                              url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                              fields: {
                                value: { value: "chevron-right" },
                                key: { value: "chevronRight" },
                              },
                            },
                            title: { value: "富衛健康通行證" },
                            link: {
                              value: {
                                href: "https://www.fwd.com.hk/fwd-wellness-pass",
                                text: "富衛健康通行證",
                                linktype: "external",
                                url: "https://www.fwd.com.hk/fwd-wellness-pass",
                                anchor: "",
                                target: "_blank",
                              },
                            },
                            listType: {
                              id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                              fieldType: "Droplink",
                              fieldName: "listType",
                              url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                              fields: {
                                value: { value: "Generic Link" },
                                key: { value: "generic_link" },
                              },
                            },
                            gaLabelName: { value: "Wellness-pass" },
                            gaCategoryName: { value: "" },
                          },
                        },
                      ],
                    },
                    {
                      id: "4b5352aa-8be7-41a0-8131-17a60c0f5588",
                      name: "Support",
                      displayName: "Support",
                      fields: {
                        enableDropdown: { value: true },
                        buttonIcon: {
                          id: "79cc843a-2212-40b5-b09f-2018d04c72a9",
                          fieldType: "CustomDroplink",
                          fieldName: "buttonIcon",
                          url: "/sitecore/content/fwd/global/settings/list/linkvariant/contact",
                          fields: {
                            value: { value: "contact" },
                            key: { value: "Contact" },
                          },
                        },
                        title: { value: "" },
                        link: { value: {} },
                        listType: {
                          id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                          fieldType: "Droplink",
                          fieldName: "listType",
                          url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                          fields: {
                            value: { value: "Generic Link" },
                            key: { value: "generic_link" },
                          },
                        },
                        gaLabelName: { value: "Support" },
                        gaCategoryName: { value: "" },
                      },
                      Children: [
                        {
                          id: "d4cd8abe-7723-4e70-9d3b-65390303e779",
                          name: "Call",
                          displayName: "Call",
                          fields: {
                            buttonIcon: {
                              id: "0853a008-9b3c-4a10-98b9-1e96a3cdc253",
                              fieldType: "CustomDroplink",
                              fieldName: "buttonIcon",
                              url: "/sitecore/content/fwd/global/settings/list/linkvariant/call",
                              fields: {
                                value: { value: "call" },
                                key: { value: "Call" },
                              },
                            },
                            title: { value: "致電 3123 3123 " },
                            link: {
                              value: {
                                href: "http://tel:31233123",
                                linktype: "external",
                                url: "tel:31233123",
                                anchor: "",
                                target: "",
                              },
                            },
                            listType: {
                              id: "fd670504-d972-4fee-9582-656b0d6ba342",
                              fieldType: "Droplink",
                              fieldName: "listType",
                              url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/call",
                              fields: {
                                value: { value: "Call" },
                                key: { value: "call" },
                              },
                            },
                            gaLabelName: { value: "Call" },
                            gaCategoryName: { value: "" },
                          },
                        },
                        {
                          id: "c7e12cea-809d-4bc1-a5ca-3fc5fdc9d09b",
                          name: "Chat",
                          displayName: "Chat",
                          fields: {
                            buttonIcon: {
                              id: "631bc306-c30e-4d10-afe5-670237118479",
                              fieldType: "CustomDroplink",
                              fieldName: "buttonIcon",
                              url: "/sitecore/content/fwd/global/settings/list/linkvariant/chat",
                              fields: {
                                value: { value: "chat" },
                                key: { value: "chat" },
                              },
                            },
                            title: { value: "即時對話 " },
                            link: { value: {} },
                            listType: {
                              id: "5e19aacf-53fc-4f68-a278-b0c8ab1c5b67",
                              fieldType: "Droplink",
                              fieldName: "listType",
                              url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/chat",
                              fields: {
                                value: { value: "Chat" },
                                key: { value: "chat" },
                              },
                            },
                            gaLabelName: { value: "Chat" },
                            gaCategoryName: { value: "" },
                          },
                        },
                      ],
                    },
                    {
                      id: "2ecea1f2-4d14-4b34-8ed5-d8ed889a6730",
                      name: "Search",
                      displayName: "Search",
                      fields: {
                        enableDropdown: { value: false },
                        buttonIcon: {
                          id: "8e6f2179-2d7b-420d-9d47-d13c408bb3c5",
                          fieldType: "CustomDroplink",
                          fieldName: "buttonIcon",
                          url: "/sitecore/content/fwd/global/settings/list/linkvariant/search",
                          fields: {
                            value: { value: "search" },
                            key: { value: "Search" },
                          },
                        },
                        title: { value: "" },
                        link: {
                          value: {
                            href: "/search/",
                            text: "",
                            anchor: "",
                            linktype: "internal",
                            class: "",
                            title: "",
                            querystring: "",
                            id: "{AA2127DC-2C63-4FDD-B43D-2583EC5200A4}",
                          },
                        },
                        listType: {
                          id: "b91e87f2-99cc-4a93-a0ba-3ee8c14f36a4",
                          fieldType: "Droplink",
                          fieldName: "listType",
                          url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/search",
                          fields: {
                            value: { value: "Search" },
                            key: { value: "search" },
                          },
                        },
                        gaLabelName: { value: "Search" },
                        gaCategoryName: { value: "" },
                      },
                    },
                  ],
                  headerNavigationLinks: [
                    {
                      id: "03f7d1bb-e0de-498f-bec2-918e48c3be3d",
                      name: "personal-insurance",
                      displayName: "personal-insurance",
                      fields: {
                        buttonIcon: null,
                        title: { value: "個人保障 " },
                        link: {
                          value: {
                            href: "/products/",
                            text: "",
                            anchor: "",
                            linktype: "internal",
                            class: "",
                            title: "",
                            target: "",
                            querystring: "",
                            id: "{DB3FF0BC-2E10-4735-8BAA-76A87A906821}",
                          },
                        },
                        pageType: {
                          id: "4fded742-177c-4850-9853-fa31cc47d63e",
                          fieldType: "Droptree",
                          fieldName: "pageType",
                          url: "/components/pagetype/individual",
                          fields: {
                            value: { value: "Individual" },
                            key: { value: "individual" },
                          },
                        },
                        listType: {
                          id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                          fieldType: "Droplink",
                          fieldName: "listType",
                          url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                          fields: {
                            value: { value: "Generic Link" },
                            key: { value: "generic_link" },
                          },
                        },
                        gaLabelName: { value: "Personal insurance" },
                        gaCategoryName: { value: "" },
                      },
                      Children: [
                        {
                          id: "7e9ea3f0-9071-4379-a25c-f1ac576e3463",
                          name: "Products",
                          displayName: "Products",
                          fields: {
                            buttonIcon: {
                              id: "19fcb2e6-0897-424f-9d15-b35209e646ed",
                              fieldType: "CustomDroplink",
                              fieldName: "buttonIcon",
                              url: "/sitecore/content/fwd/global/settings/list/linkvariant/products",
                              fields: {
                                value: { value: "products" },
                                key: { value: "products" },
                              },
                            },
                            title: { value: "產品 " },
                            link: {
                              value: {
                                href: "/products/",
                                text: "",
                                anchor: "",
                                linktype: "internal",
                                class: "",
                                title: "",
                                target: "",
                                querystring: "",
                                id: "{DB3FF0BC-2E10-4735-8BAA-76A87A906821}",
                              },
                            },
                            pageType: {
                              id: "4fded742-177c-4850-9853-fa31cc47d63e",
                              fieldType: "Droptree",
                              fieldName: "pageType",
                              url: "/components/pagetype/individual",
                              fields: {
                                value: { value: "Individual" },
                                key: { value: "individual" },
                              },
                            },
                            listType: {
                              id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                              fieldType: "Droplink",
                              fieldName: "listType",
                              url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                              fields: {
                                value: { value: "Generic Link" },
                                key: { value: "generic_link" },
                              },
                            },
                            gaLabelName: { value: "Products" },
                            gaCategoryName: { value: "" },
                          },
                        },
                        {
                          id: "263a64a1-ba2e-48cb-b459-882d4d37430f",
                          name: "Buy online",
                          displayName: "Buy online",
                          fields: {
                            buttonIcon: {
                              id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                              fieldType: "CustomDroplink",
                              fieldName: "buttonIcon",
                              url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                              fields: {
                                value: { value: "chevron-right" },
                                key: { value: "chevronRight" },
                              },
                            },
                            title: { value: "網上投保" },
                            link: {
                              value: {
                                href: "https://www.fwd.com.hk/online-insurance/",
                                linktype: "external",
                                url: "https://www.fwd.com.hk/online-insurance/",
                                anchor: "",
                                target: "_blank",
                              },
                            },
                            listType: {
                              id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                              fieldType: "Droplink",
                              fieldName: "listType",
                              url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                              fields: {
                                value: { value: "Generic Link" },
                                key: { value: "generic_link" },
                              },
                            },
                            gaLabelName: { value: "" },
                            gaCategoryName: { value: "" },
                          },
                        },
                        {
                          id: "ce7d4b83-4bcc-4064-ab5d-6407be87d748",
                          name: "Support",
                          displayName: "Support",
                          fields: {
                            buttonIcon: {
                              id: "fbdc2dbb-311b-47d3-929d-214d7b812ba5",
                              fieldType: "CustomDroplink",
                              fieldName: "buttonIcon",
                              url: "/sitecore/content/fwd/global/settings/list/linkvariant/supportoutline---obsolete",
                              fields: {
                                value: { value: "support-outline" },
                                key: { value: "supportOutline" },
                              },
                            },
                            title: { value: "支援 " },
                            link: {
                              value: {
                                href: "https://www.fwd.com.hk/support/",
                                text: "",
                                anchor: "",
                                linktype: "internal",
                                class: "",
                                title: "",
                                querystring: "",
                                id: "{9C6D9E13-7967-40EA-AAAA-753CA0685D6C}",
                              },
                            },
                            listType: {
                              id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                              fieldType: "Droplink",
                              fieldName: "listType",
                              url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                              fields: {
                                value: { value: "Generic Link" },
                                key: { value: "generic_link" },
                              },
                            },
                            gaLabelName: { value: "Support" },
                            gaCategoryName: { value: "" },
                          },
                        },
                        {
                          id: "0adc557e-2d1f-4a94-a991-5bdffb56e3a7",
                          name: "Claims",
                          displayName: "Claims",
                          fields: {
                            buttonIcon: {
                              id: "8ba0c144-7d03-426d-84a8-3329cca6784a",
                              fieldType: "CustomDroplink",
                              fieldName: "buttonIcon",
                              url: "/sitecore/content/fwd/global/settings/list/linkvariant/claims",
                              fields: {
                                value: { value: "claims" },
                                key: { value: "claims" },
                              },
                            },
                            title: { value: "索償 " },
                            link: {
                              value: {
                                href: "/claims/",
                                text: "Claims",
                                anchor: "",
                                linktype: "internal",
                                class: "",
                                title: "",
                                querystring: "",
                                id: "{1ECCEDC9-E80A-4521-A507-CC81BD2A5EC6}",
                              },
                            },
                            pageType: {
                              id: "4fded742-177c-4850-9853-fa31cc47d63e",
                              fieldType: "Droptree",
                              fieldName: "pageType",
                              url: "/components/pagetype/individual",
                              fields: {
                                value: { value: "Individual" },
                                key: { value: "individual" },
                              },
                            },
                            listType: {
                              id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                              fieldType: "Droplink",
                              fieldName: "listType",
                              url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                              fields: {
                                value: { value: "Generic Link" },
                                key: { value: "generic_link" },
                              },
                            },
                            gaLabelName: { value: "Claims" },
                            gaCategoryName: { value: "" },
                          },
                        },
                        {
                          id: "2dc44112-f941-4b79-8850-41d7b81f0509",
                          name: "Live",
                          displayName: "Live",
                          fields: {
                            buttonIcon: {
                              id: "2fb55194-6b17-4d01-acf7-d7455cf1b768",
                              fieldType: "CustomDroplink",
                              fieldName: "buttonIcon",
                              url: "/sitecore/content/fwd/global/settings/list/linkvariant/criticalillness",
                              fields: {
                                value: { value: "critical-illness" },
                                key: { value: "criticalIllness" },
                              },
                            },
                            title: { value: "網誌" },
                            link: {
                              value: {
                                href: "/blog/",
                                text: "Live",
                                anchor: "",
                                linktype: "internal",
                                class: "",
                                title: "",
                                querystring: "",
                                id: "{68E8B2B6-DD6C-411F-91E1-B1B25B2107EB}",
                              },
                            },
                            listType: {
                              id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                              fieldType: "Droplink",
                              fieldName: "listType",
                              url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                              fields: {
                                value: { value: "Generic Link" },
                                key: { value: "generic_link" },
                              },
                            },
                            gaLabelName: { value: "" },
                            gaCategoryName: { value: "" },
                          },
                        },
                      ],
                    },
                    {
                      id: "089319f0-9b3b-4d3e-8efc-627dc9a0fdd2",
                      name: "business-insurance",
                      displayName: "business-insurance",
                      fields: {
                        buttonIcon: null,
                        title: { value: "企業保障 " },
                        link: {
                          value: {
                            href: "/business/",
                            text: "business product landing page",
                            anchor: "",
                            linktype: "internal",
                            class: "",
                            title: "",
                            querystring: "",
                            id: "{BBB4F360-4715-4653-8CDE-BA9E60D1E26D}",
                          },
                        },
                        pageType: {
                          id: "de6c17ec-dbdd-4363-9494-5437e7f5eb8b",
                          fieldType: "Droptree",
                          fieldName: "pageType",
                          url: "/components/pagetype/business",
                          fields: {
                            value: { value: "Business" },
                            key: { value: "business" },
                          },
                        },
                        listType: {
                          id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                          fieldType: "Droplink",
                          fieldName: "listType",
                          url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                          fields: {
                            value: { value: "Generic Link" },
                            key: { value: "generic_link" },
                          },
                        },
                        gaLabelName: { value: "Business insurance" },
                        gaCategoryName: { value: "" },
                      },
                      Children: [
                        {
                          id: "d1abefd7-61f3-4b42-b8ef-5d708bcf809a",
                          name: "Products",
                          displayName: "Products",
                          fields: {
                            buttonIcon: {
                              id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                              fieldType: "CustomDroplink",
                              fieldName: "buttonIcon",
                              url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                              fields: {
                                value: { value: "chevron-right" },
                                key: { value: "chevronRight" },
                              },
                            },
                            title: { value: "產品 " },
                            link: {
                              value: {
                                href: "/business/",
                                text: "",
                                anchor: "",
                                linktype: "internal",
                                class: "",
                                title: "",
                                querystring: "",
                                id: "{BBB4F360-4715-4653-8CDE-BA9E60D1E26D}",
                              },
                            },
                            listType: {
                              id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                              fieldType: "Droplink",
                              fieldName: "listType",
                              url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                              fields: {
                                value: { value: "Generic Link" },
                                key: { value: "generic_link" },
                              },
                            },
                            gaLabelName: { value: "Products" },
                            gaCategoryName: { value: "" },
                          },
                        },
                        {
                          id: "67f87d28-686e-43a6-9e12-360f9888baca",
                          name: "Support",
                          displayName: "Support",
                          fields: {
                            buttonIcon: {
                              id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                              fieldType: "CustomDroplink",
                              fieldName: "buttonIcon",
                              url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                              fields: {
                                value: { value: "chevron-right" },
                                key: { value: "chevronRight" },
                              },
                            },
                            title: { value: "支援 " },
                            link: {
                              value: {
                                href: "/business/support/",
                                text: "",
                                anchor: "",
                                linktype: "internal",
                                class: "",
                                title: "",
                                querystring: "",
                                id: "{E4F2827A-E55D-4DC5-80F3-354AD44C78C8}",
                              },
                            },
                            listType: {
                              id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                              fieldType: "Droplink",
                              fieldName: "listType",
                              url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                              fields: {
                                value: { value: "Generic Link" },
                                key: { value: "generic_link" },
                              },
                            },
                            gaLabelName: { value: "Support" },
                            gaCategoryName: { value: "" },
                          },
                        },
                        {
                          id: "52c758aa-80b2-46c9-8587-09586d65c8e0",
                          name: "Claims",
                          displayName: "Claims",
                          fields: {
                            buttonIcon: {
                              id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                              fieldType: "CustomDroplink",
                              fieldName: "buttonIcon",
                              url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                              fields: {
                                value: { value: "chevron-right" },
                                key: { value: "chevronRight" },
                              },
                            },
                            title: { value: "索償 " },
                            link: {
                              value: {
                                href: "/business/claims/",
                                text: "",
                                anchor: "",
                                linktype: "internal",
                                class: "",
                                title: "",
                                querystring: "",
                                id: "{CC6F6069-65DE-4A82-8A12-86402AC320C4}",
                              },
                            },
                            listType: {
                              id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                              fieldType: "Droplink",
                              fieldName: "listType",
                              url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                              fields: {
                                value: { value: "Generic Link" },
                                key: { value: "generic_link" },
                              },
                            },
                            gaLabelName: { value: "Claims" },
                            gaCategoryName: { value: "" },
                          },
                        },
                      ],
                    },
                    {
                      id: "f57b6b73-b940-4bec-a14a-4d82d9de70c8",
                      name: "FWD Max",
                      displayName: "FWD Max",
                      fields: {
                        buttonIcon: null,
                        title: { value: "FWD Max" },
                        link: {
                          value: {
                            href: "https://fwdmax.fwd.com.hk/#/",
                            linktype: "external",
                            url: "https://fwdmax.fwd.com.hk/#/",
                          },
                        },
                        pageType: {
                          id: "4fded742-177c-4850-9853-fa31cc47d63e",
                          fieldType: "Droptree",
                          fieldName: "pageType",
                          url: "/components/pagetype/individual",
                          fields: {
                            value: { value: "Individual" },
                            key: { value: "individual" },
                          },
                        },
                        listType: {
                          id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                          fieldType: "Droplink",
                          fieldName: "listType",
                          url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                          fields: {
                            value: { value: "Generic Link" },
                            key: { value: "generic_link" },
                          },
                        },
                        gaLabelName: { value: "FWD Max" },
                        gaCategoryName: { value: "" },
                      },
                    },
                    {
                      id: "fc43b3cb-09f9-458c-a359-435548e15c3c",
                      name: "FWD Care",
                      displayName: "FWD Care",
                      fields: {
                        buttonIcon: null,
                        title: { value: "FWD Care" },
                        link: {
                          value: {
                            href: "/fwd-care/",
                            text: "",
                            anchor: "",
                            linktype: "internal",
                            class: "",
                            title: "",
                            target: "",
                            querystring: "",
                            id: "{6264591E-F484-4C44-9F22-76CC0AAAA96C}",
                          },
                        },
                        pageType: {
                          id: "4fded742-177c-4850-9853-fa31cc47d63e",
                          fieldType: "Droptree",
                          fieldName: "pageType",
                          url: "/components/pagetype/individual",
                          fields: {
                            value: { value: "Individual" },
                            key: { value: "individual" },
                          },
                        },
                        listType: {
                          id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                          fieldType: "Droplink",
                          fieldName: "listType",
                          url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                          fields: {
                            value: { value: "Generic Link" },
                            key: { value: "generic_link" },
                          },
                        },
                        gaLabelName: { value: "FWD Care" },
                        gaCategoryName: { value: "" },
                      },
                    },
                    {
                      id: "43605822-a526-4658-a490-e8307981a5b7",
                      name: "about-us",
                      displayName: "about-us",
                      fields: {
                        buttonIcon: {
                          id: "368ba79d-8cae-435c-a781-fe6fb2f3725d",
                          fieldType: "CustomDroplink",
                          fieldName: "buttonIcon",
                          url: "/sitecore/content/fwd/global/settings/list/linkvariant/collection---obsolete",
                          fields: {
                            value: { value: "collection" },
                            key: { value: "Collection" },
                          },
                        },
                        title: { value: "關於我們" },
                        link: {
                          value: {
                            href: "/about-us/",
                            text: "",
                            anchor: "",
                            linktype: "internal",
                            class: "",
                            title: "",
                            querystring: "",
                            id: "{E5F9A3FD-CB1D-4BE3-BC8B-C33AB0CA8199}",
                          },
                        },
                        pageType: {
                          id: "de6c17ec-dbdd-4363-9494-5437e7f5eb8b",
                          fieldType: "Droptree",
                          fieldName: "pageType",
                          url: "/components/pagetype/business",
                          fields: {
                            value: { value: "Business" },
                            key: { value: "business" },
                          },
                        },
                        listType: {
                          id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                          fieldType: "Droplink",
                          fieldName: "listType",
                          url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                          fields: {
                            value: { value: "Generic Link" },
                            key: { value: "generic_link" },
                          },
                        },
                        gaLabelName: { value: "About us" },
                        gaCategoryName: { value: "" },
                      },
                    },
                  ],
                  mobileLogo: {
                    value: {
                      src: "/-/media/images/fwd_logo-mobile-optimized.gif?rev=a8b502d8e15f4138b3886f4f4055d8e1",
                      alt: "Mobile Logo",
                      x1: "/-/media/images/fwd_logo-mobile-optimized.gif?rev=a8b502d8e15f4138b3886f4f4055d8e1&cx=0&cy=0&cw=160&ch=55&hash=7022D21F9F18BB0976118AB5D2581224",
                      x2: "/-/media/images/fwd_logo-mobile-optimized.gif?rev=a8b502d8e15f4138b3886f4f4055d8e1&cx=0&cy=0&cw=320&ch=110&hash=7AA10FB71EF1FBCEA89E0E4CEC328D3A",
                    },
                  },
                  logo: {
                    value: {
                      src: "/-/media/images/fwd_logo-desktop_optimized.gif?rev=65cf41896c74464b91195aef5f75ab38",
                      alt: "Desktop Logo",
                      x1: "/-/media/images/fwd_logo-desktop_optimized.gif?rev=65cf41896c74464b91195aef5f75ab38&cx=0.34&cy=0.49&cw=420&ch=145&hash=BA06E53B6851E960624E0E9D65530568",
                      x2: "/-/media/images/fwd_logo-desktop_optimized.gif?rev=65cf41896c74464b91195aef5f75ab38&cx=0.34&cy=0.49&cw=840&ch=290&hash=6B51AE82CBDA193DA8CCB3D5FABFC3DB",
                    },
                  },
                  logoLink: {
                    value: {
                      text: "Home",
                      anchor: "",
                      linktype: "internal",
                      class: "",
                      title: "Home",
                      querystring: "",
                      id: "{D9C6779B-43E9-4106-8357-AD0510A8547C}",
                    },
                  },
                  headerLogo: {
                    value: {
                      src: "/-/media/global/images/fwdlogod.svg?rev=a209dbca469647fa89f47c76a00dc55c",
                      alt: "FWD Desktop Logo",
                    },
                  },
                  countrySelector: [
                    {
                      id: "b43fd69b-bd63-4f64-9aab-06f1b0d527c7",
                      name: "Group",
                      displayName: "Group",
                      fields: {
                        isDefault: { value: false },
                        buttonIcon: null,
                        title: { value: "富衛集團" },
                        link: {
                          value: {
                            href: "https://www.fwd.com/",
                            linktype: "external",
                            url: "https://www.fwd.com/",
                            anchor: "",
                            target: "_blank",
                          },
                        },
                        listType: {
                          id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                          fieldType: "Droplink",
                          fieldName: "listType",
                          url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                          fields: {
                            value: { value: "Generic Link" },
                            key: { value: "generic_link" },
                          },
                        },
                        gaLabelName: { value: "" },
                        gaCategoryName: { value: "" },
                      },
                    },
                    {
                      id: "eb9ee5ea-e079-4bde-af3c-b82e5ebee28a",
                      name: "Hong Kong",
                      displayName: "Hong Kong",
                      fields: {
                        isDefault: { value: true },
                        buttonIcon: null,
                        title: { value: "香港" },
                        link: {
                          value: {
                            href: "/",
                            text: "",
                            anchor: "",
                            linktype: "internal",
                            class: "",
                            title: "",
                            querystring: "",
                            id: "{9CB72689-FA18-4900-B876-3AE397D3B009}",
                          },
                        },
                        listType: {
                          id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                          fieldType: "Droplink",
                          fieldName: "listType",
                          url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                          fields: {
                            value: { value: "Generic Link" },
                            key: { value: "generic_link" },
                          },
                        },
                        gaLabelName: { value: "" },
                        gaCategoryName: { value: "" },
                      },
                    },
                    {
                      id: "dc6f0a0c-f056-44c6-a565-2044c8b494a6",
                      name: "Macau",
                      displayName: "Macau",
                      fields: {
                        isDefault: { value: false },
                        buttonIcon: null,
                        title: { value: "澳門" },
                        link: {
                          value: {
                            href: "https://www.fwd.com.mo/en/",
                            linktype: "external",
                            url: "https://www.fwd.com.mo/en/",
                            anchor: "",
                            target: "_blank",
                          },
                        },
                        listType: {
                          id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                          fieldType: "Droplink",
                          fieldName: "listType",
                          url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                          fields: {
                            value: { value: "Generic Link" },
                            key: { value: "generic_link" },
                          },
                        },
                        gaLabelName: { value: "" },
                        gaCategoryName: { value: "" },
                      },
                    },
                    {
                      id: "62bb0970-5392-494c-8969-53863b8728d3",
                      name: "China representative office",
                      displayName: "China representative office",
                      fields: {
                        isDefault: { value: false },
                        buttonIcon: null,
                        title: { value: "中國代表處" },
                        link: {
                          value: {
                            href: "https://www.fwd.cn/",
                            linktype: "external",
                            url: "https://www.fwd.cn/",
                            anchor: "",
                            target: "_blank",
                          },
                        },
                        listType: {
                          id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                          fieldType: "Droplink",
                          fieldName: "listType",
                          url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                          fields: {
                            value: { value: "Generic Link" },
                            key: { value: "generic_link" },
                          },
                        },
                        gaLabelName: { value: "" },
                        gaCategoryName: { value: "" },
                      },
                    },
                    {
                      id: "79ec13ea-0312-44f7-b305-3660acd71adf",
                      name: "Indonesia",
                      displayName: "Indonesia",
                      fields: {
                        isDefault: { value: false },
                        buttonIcon: null,
                        title: { value: "印尼" },
                        link: {
                          value: {
                            href: "https://www.fwd.co.id/en/",
                            linktype: "external",
                            url: "https://www.fwd.co.id/en/",
                            anchor: "",
                            target: "_blank",
                          },
                        },
                        listType: {
                          id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                          fieldType: "Droplink",
                          fieldName: "listType",
                          url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                          fields: {
                            value: { value: "Generic Link" },
                            key: { value: "generic_link" },
                          },
                        },
                        gaLabelName: { value: "" },
                        gaCategoryName: { value: "" },
                      },
                    },
                    {
                      id: "e5b1b516-9ca4-4a59-9417-03cdedeaab5a",
                      name: "Japan",
                      displayName: "Japan",
                      fields: {
                        isDefault: { value: false },
                        buttonIcon: null,
                        title: { value: "日本" },
                        link: {
                          value: {
                            href: "https://www.fwdlife.co.jp/",
                            linktype: "external",
                            url: "https://www.fwdlife.co.jp/",
                            anchor: "",
                            target: "_blank",
                          },
                        },
                        listType: {
                          id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                          fieldType: "Droplink",
                          fieldName: "listType",
                          url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                          fields: {
                            value: { value: "Generic Link" },
                            key: { value: "generic_link" },
                          },
                        },
                        gaLabelName: { value: "" },
                        gaCategoryName: { value: "" },
                      },
                    },
                    {
                      id: "d3f70c56-ff92-468e-a8e7-bdede76909d1",
                      name: "Malaysia",
                      displayName: "Malaysia",
                      fields: {
                        isDefault: { value: false },
                        buttonIcon: null,
                        title: { value: "馬來西亞" },
                        link: {
                          value: {
                            href: "https://www.fwd.com.my/en/",
                            linktype: "external",
                            url: "https://www.fwd.com.my/en/",
                            anchor: "",
                            target: "_blank",
                          },
                        },
                        listType: {
                          id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                          fieldType: "Droplink",
                          fieldName: "listType",
                          url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                          fields: {
                            value: { value: "Generic Link" },
                            key: { value: "generic_link" },
                          },
                        },
                        gaLabelName: { value: "" },
                        gaCategoryName: { value: "" },
                      },
                    },
                    {
                      id: "0bff6386-fa8a-4ba5-800f-24c2afffbbe0",
                      name: "Philippines",
                      displayName: "Philippines",
                      fields: {
                        isDefault: { value: false },
                        buttonIcon: null,
                        title: { value: "菲律賓" },
                        link: {
                          value: {
                            href: "https://www.fwd.com.ph/en/",
                            linktype: "external",
                            url: "https://www.fwd.com.ph/en/",
                            anchor: "",
                            target: "_blank",
                          },
                        },
                        listType: {
                          id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                          fieldType: "Droplink",
                          fieldName: "listType",
                          url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                          fields: {
                            value: { value: "Generic Link" },
                            key: { value: "generic_link" },
                          },
                        },
                        gaLabelName: { value: "" },
                        gaCategoryName: { value: "" },
                      },
                    },
                    {
                      id: "7bb44e4e-75eb-4b9d-8ff8-4a4a8203cf36",
                      name: "Singapore",
                      displayName: "Singapore",
                      fields: {
                        isDefault: { value: false },
                        buttonIcon: null,
                        title: { value: "新加坡" },
                        link: {
                          value: {
                            href: "https://www.fwd.com.sg/",
                            linktype: "external",
                            url: "https://www.fwd.com.sg/",
                            anchor: "",
                            target: "_blank",
                          },
                        },
                        listType: {
                          id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                          fieldType: "Droplink",
                          fieldName: "listType",
                          url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                          fields: {
                            value: { value: "Generic Link" },
                            key: { value: "generic_link" },
                          },
                        },
                        gaLabelName: { value: "" },
                        gaCategoryName: { value: "" },
                      },
                    },
                    {
                      id: "dc572c84-d525-48c9-a5e0-6215970d93b4",
                      name: "Thailand",
                      displayName: "Thailand",
                      fields: {
                        isDefault: { value: false },
                        buttonIcon: null,
                        title: { value: "泰國" },
                        link: {
                          value: {
                            href: "https://www.fwd.co.th/en/",
                            linktype: "external",
                            url: "https://www.fwd.co.th/en/",
                            anchor: "",
                            target: "_blank",
                          },
                        },
                        listType: {
                          id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                          fieldType: "Droplink",
                          fieldName: "listType",
                          url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                          fields: {
                            value: { value: "Generic Link" },
                            key: { value: "generic_link" },
                          },
                        },
                        gaLabelName: { value: "" },
                        gaCategoryName: { value: "" },
                      },
                    },
                    {
                      id: "4499f614-f9e5-4cd8-a924-8a8ce0c82348",
                      name: "Vietnam",
                      displayName: "Vietnam",
                      fields: {
                        isDefault: { value: false },
                        buttonIcon: null,
                        title: { value: "越南" },
                        link: {
                          value: {
                            href: "https://www.fwd.com.vn/en/",
                            linktype: "external",
                            url: "https://www.fwd.com.vn/en/",
                            anchor: "",
                            target: "_blank",
                          },
                        },
                        listType: {
                          id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                          fieldType: "Droplink",
                          fieldName: "listType",
                          url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                          fields: {
                            value: { value: "Generic Link" },
                            key: { value: "generic_link" },
                          },
                        },
                        gaLabelName: { value: "" },
                        gaCategoryName: { value: "" },
                      },
                    },
                  ],
                  displayMode: {
                    id: "c81d8d8f-e8d9-468f-acfc-bbdce30d66ec",
                    fieldType: "Droplink",
                    fieldName: "displayMode",
                    url: "/sitecore/content/fwd/global/settings/list/carouselmode/mobile",
                    fields: {
                      value: { value: "Mobile" },
                      key: { value: "Mobile" },
                    },
                  },
                  searchPageLink: {
                    value: {
                      href: "/search/",
                      text: "",
                      anchor: "",
                      linktype: "internal",
                      class: "",
                      title: "",
                      querystring: "",
                      id: "{AA2127DC-2C63-4FDD-B43D-2583EC5200A4}",
                    },
                  },
                  pastSearchRecordsCount: { value: "8" },
                  title: { value: "我在找 ..." },
                  placeholderText: { value: "請輸入關鍵字或者詞組 " },
                  enableLanguageToggle: { value: true },
                  languageList: [
                    {
                      id: "f7d73a71-1c14-4b6a-8db1-263b40425b4f",
                      fields: {
                        languageName: { value: "EN" },
                        defaultLanguage: { value: "Tc" },
                        languageCode: { value: "en" },
                      },
                    },
                    {
                      id: "8e721d84-8219-4d9b-9470-4621a8beff37",
                      fields: {
                        languageName: { value: "繁" },
                        defaultLanguage: { value: "En" },
                        languageCode: { value: "tc" },
                      },
                    },
                  ],
                  languageModalDescription: {
                    value:
                      "We currently working to have this content in your language. You can choose to stay on this page, or proceed to explore other relevant content.",
                  },
                  languageModalLink: {
                    value: {
                      href: "/",
                      text: "Explore",
                      anchor: "",
                      linktype: "internal",
                      class: "",
                      title: "Okie",
                      target: "",
                      querystring: "",
                      id: "{9CB72689-FA18-4900-B876-3AE397D3B009}",
                    },
                  },
                  languageModalSecondaryLink: { value: "Stay on page" },
                  languageModalTitle: {
                    value: "This content might not be in your language.",
                  },
                },
              },
            ],
            "jss-main": [
              {
                uid: "bd9bbfd0-cc3f-422c-ac56-008cba8fcade",
                componentName: "ProductListFilter",
                dataSource: "{1F91B8E6-5FC2-4857-8B9A-4FB879212F41}",
                fields: {
                  mobileImage: {
                    value: {
                      src: "/-/media/images/products-old/asian-children.png?rev=adda35998f1b4130907fbea01a608814",
                      x1: "/-/media/images/products-old/asian-children.png?rev=adda35998f1b4130907fbea01a608814&cx=0.38&cy=0.46&cw=360&ch=360&hash=487A69075A334BCB66052313A7F70A4B",
                      x2: "/-/media/images/products-old/asian-children.png?rev=adda35998f1b4130907fbea01a608814&cx=0.38&cy=0.46&cw=720&ch=720&hash=9F61DE576E3CBAAEB3C4E743D28F0C0D",
                    },
                  },
                  image: {
                    value: {
                      src: "/-/media/images/products-old/asian-children.png?rev=adda35998f1b4130907fbea01a608814",
                      x1: "/-/media/images/products-old/asian-children.png?rev=adda35998f1b4130907fbea01a608814&cx=0.31&cy=0.43&cw=1366&ch=456&hash=514E868C48AB96E13CA5BDB67106B40B",
                      x2: "/-/media/images/products-old/asian-children.png?rev=adda35998f1b4130907fbea01a608814&cx=0.31&cy=0.43&cw=2732&ch=912&hash=E68E4ED52263B1B53073D93319D80990",
                      x3: "/-/media/images/products-old/asian-children.png?rev=adda35998f1b4130907fbea01a608814&cx=0.31&cy=0.43&cw=1200&ch=630&hash=184258384EAE21E9BC331EBD1D139447",
                    },
                  },
                  secondaryNeedTags: [
                    {
                      id: "4f17c5e7-dc4e-4f8b-b412-ed18b5dc7180",
                      name: "accidental damage",
                      displayName: "意外損毀",
                      fields: {
                        searchName: { value: "accidental damage" },
                        name: { value: "意外損毀" },
                        articlePillarPage: { value: "" },
                        image: { value: {} },
                        mobileImage: { value: {} },
                        filterBy: null,
                      },
                    },
                    {
                      id: "6b5d518e-e5ac-4483-8e41-98dfc5ffe5f7",
                      name: "all-in-one plan",
                      displayName: "一站式方案",
                      fields: {
                        searchName: { value: "all-in-one plan" },
                        name: { value: "一站式方案" },
                        articlePillarPage: { value: "" },
                        image: { value: {} },
                        mobileImage: { value: {} },
                        filterBy: null,
                      },
                    },
                    {
                      id: "26cf526d-8d9e-4033-9a64-3dc83714b267",
                      name: "annuity",
                      displayName: "年金",
                      fields: {
                        searchName: { value: "annuity" },
                        name: { value: "年金" },
                        articlePillarPage: { value: "" },
                        image: { value: {} },
                        mobileImage: { value: {} },
                        filterBy: null,
                      },
                    },
                    {
                      id: "56215901-6be5-4d49-ba89-ba228464c96c",
                      name: "budget-friendly",
                      displayName: "經濟實惠",
                      fields: {
                        searchName: { value: "budget-friendly" },
                        name: { value: "經濟實惠" },
                        articlePillarPage: { value: "" },
                        image: { value: {} },
                        mobileImage: { value: {} },
                        filterBy: null,
                      },
                    },
                    {
                      id: "eff9badf-fe58-4778-ad95-8cfad5da6160",
                      name: "cancer",
                      displayName: "癌症保障",
                      fields: {
                        searchName: { value: "cancer" },
                        name: { value: "癌症保障" },
                        articlePillarPage: { value: "" },
                        image: { value: {} },
                        mobileImage: { value: {} },
                        filterBy: null,
                      },
                    },
                    {
                      id: "883ff1d4-8f5e-41e7-abd4-616c85275fbf",
                      name: "cash back",
                      displayName: "現金回贈",
                      fields: {
                        searchName: { value: "cash back" },
                        name: { value: "現金回贈" },
                        articlePillarPage: { value: "" },
                        image: { value: {} },
                        mobileImage: { value: {} },
                        filterBy: null,
                      },
                    },
                    {
                      id: "44a7940a-b065-4c95-9a2f-414942cd4bed",
                      name: "cashless treatment",
                      displayName: "出院免找數",
                      fields: {
                        searchName: { value: "cashless treatment" },
                        name: { value: "出院免找數" },
                        articlePillarPage: { value: "" },
                        image: { value: {} },
                        mobileImage: { value: {} },
                        filterBy: null,
                      },
                    },
                    {
                      id: "5b087c4c-dddc-4ce1-86b5-ad5d66e873b2",
                      name: "covers infants",
                      displayName: "保障幼兒",
                      fields: {
                        searchName: { value: "covers infants" },
                        name: { value: "保障幼兒" },
                        articlePillarPage: { value: "" },
                        image: { value: {} },
                        mobileImage: { value: {} },
                        filterBy: null,
                      },
                    },
                    {
                      id: "9ed6a519-8e91-493e-9c79-07052bf92b92",
                      name: "critical illness cover",
                      displayName: "意外損毀",
                      fields: {
                        searchName: { value: "critical illness cover" },
                        name: { value: "危疾保障" },
                        articlePillarPage: { value: "" },
                        image: { value: {} },
                        mobileImage: { value: {} },
                        filterBy: null,
                      },
                    },
                    {
                      id: "3a72c09f-3871-4724-bf67-81ec6f7bfb62",
                      name: "flexible payment terms",
                      displayName: "彈性保費",
                      fields: {
                        searchName: { value: "flexible payment terms" },
                        name: { value: "彈性保費" },
                        articlePillarPage: { value: "" },
                        image: { value: {} },
                        mobileImage: { value: {} },
                        filterBy: null,
                      },
                    },
                    {
                      id: "7bd2fb21-c2f7-4f57-9096-76ae9b882250",
                      name: "full medical cover",
                      displayName: "全面醫療保險",
                      fields: {
                        searchName: { value: "full medical cover" },
                        name: { value: "全面醫療保險" },
                        articlePillarPage: { value: "" },
                        image: { value: {} },
                        mobileImage: { value: {} },
                        filterBy: null,
                      },
                    },
                    {
                      id: "806c6239-22e1-4f1e-8d2d-296fc90a9924",
                      name: "future-disease proof",
                      displayName: "新型疾病保障",
                      fields: {
                        searchName: { value: "future-disease proof" },
                        name: { value: "新型疾病保障" },
                        articlePillarPage: { value: "" },
                        image: { value: {} },
                        mobileImage: { value: {} },
                        filterBy: null,
                      },
                    },
                    {
                      id: "96fc26f9-763a-4260-8650-389cc0693bf3",
                      name: "high potential returns",
                      displayName: "高潛在回報",
                      fields: {
                        searchName: { value: "high potential returns" },
                        name: { value: "高潛在回報" },
                        articlePillarPage: { value: "" },
                        image: { value: {} },
                        mobileImage: { value: {} },
                        filterBy: null,
                      },
                    },
                    {
                      id: "da4ce6f1-b8b7-48e2-ac39-97faeb38c10d",
                      name: "hospital cash",
                      displayName: "住院現金保障",
                      fields: {
                        searchName: { value: "hospital cash" },
                        name: { value: "住院現金保障" },
                        articlePillarPage: { value: "" },
                        image: { value: {} },
                        mobileImage: { value: {} },
                        filterBy: null,
                      },
                    },
                    {
                      id: "6fde52b9-5a1e-46fc-a3c0-6963e4608ca7",
                      name: "legacy",
                      displayName: "財富傳承",
                      fields: {
                        searchName: { value: "legacy" },
                        name: { value: "財富傳承" },
                        articlePillarPage: { value: "" },
                        image: { value: {} },
                        mobileImage: { value: {} },
                        filterBy: null,
                      },
                    },
                    {
                      id: "b743b84c-6628-443e-9cb7-66b4b225e7f7",
                      name: "loss of life",
                      displayName: "身故",
                      fields: {
                        searchName: { value: "loss of life" },
                        name: { value: "身故" },
                        articlePillarPage: { value: "" },
                        image: { value: {} },
                        mobileImage: { value: {} },
                        filterBy: null,
                      },
                    },
                    {
                      id: "bb0ca8a3-5c91-49e9-bf2a-39fadccc166d",
                      name: "medical reimbursement",
                      displayName: "醫療賠償（實報實銷）",
                      fields: {
                        searchName: { value: "medical reimbursement" },
                        name: { value: "醫療賠償（實報實銷）" },
                        articlePillarPage: { value: "" },
                        image: { value: {} },
                        mobileImage: { value: {} },
                        filterBy: null,
                      },
                    },
                    {
                      id: "d8904cf5-06fa-43be-880e-dbf9f98739bb",
                      name: "mental health",
                      displayName: "情緒健康",
                      fields: {
                        searchName: { value: "mental health" },
                        name: { value: "情緒健康" },
                        articlePillarPage: { value: "" },
                        image: { value: {} },
                        mobileImage: { value: {} },
                        filterBy: null,
                      },
                    },
                    {
                      id: "35171d2f-6ee3-478b-832e-c82344f2f016",
                      name: "multiple claims",
                      displayName: "多次賠償",
                      fields: {
                        searchName: { value: "multiple claims" },
                        name: { value: "多次賠償" },
                        articlePillarPage: { value: "" },
                        image: { value: {} },
                        mobileImage: { value: {} },
                        filterBy: null,
                      },
                    },
                    {
                      id: "f3c17198-c5be-461b-ace6-19178f4c8a2e",
                      name: "no medical exam",
                      displayName: "毋須驗身",
                      fields: {
                        searchName: { value: "no medical exam" },
                        name: { value: "毋須驗身" },
                        articlePillarPage: { value: "" },
                        image: { value: {} },
                        mobileImage: { value: {} },
                        filterBy: null,
                      },
                    },
                    {
                      id: "8dfc228e-43f4-4a75-8172-99ae03b633e9",
                      name: "no-claims discount",
                      displayName: "無索償折扣",
                      fields: {
                        searchName: { value: "no-claims discount" },
                        name: { value: "無索償折扣" },
                        articlePillarPage: { value: "" },
                        image: { value: {} },
                        mobileImage: { value: {} },
                        filterBy: null,
                      },
                    },
                    {
                      id: "04e49f45-fbb7-4097-a5fe-acef5910cbef",
                      name: "overseas",
                      displayName: "海外",
                      fields: {
                        searchName: { value: "overseas" },
                        name: { value: "海外" },
                        articlePillarPage: { value: "" },
                        image: { value: {} },
                        mobileImage: { value: {} },
                        filterBy: null,
                      },
                    },
                    {
                      id: "1bff101c-d03f-43d5-9489-0201a7dd54ae",
                      name: "pan-asia",
                      displayName: "泛亞",
                      fields: {
                        searchName: { value: "pan-asia" },
                        name: { value: "泛亞" },
                        articlePillarPage: { value: "" },
                        image: { value: {} },
                        mobileImage: { value: {} },
                        filterBy: null,
                      },
                    },
                    {
                      id: "8f525df2-5a7c-464c-8d21-633780793df7",
                      name: "personal accident",
                      displayName: "個人意外保險",
                      fields: {
                        searchName: { value: "personal accident" },
                        name: { value: "個人意外保險" },
                        articlePillarPage: { value: "" },
                        image: { value: {} },
                        mobileImage: { value: {} },
                        filterBy: null,
                      },
                    },
                    {
                      id: "abffcbf7-ed7c-4788-bb96-eb128dbdf729",
                      name: "premium refund",
                      displayName: "保費退還",
                      fields: {
                        searchName: { value: "premium refund" },
                        name: { value: "保費退還" },
                        articlePillarPage: { value: "" },
                        image: { value: {} },
                        mobileImage: { value: {} },
                        filterBy: null,
                      },
                    },
                    {
                      id: "afe74b6e-4f0b-4eb0-8436-657245b59e35",
                      name: "regular premiums",
                      displayName: "定期保費",
                      fields: {
                        searchName: { value: "regular premiums" },
                        name: { value: "定期保費" },
                        articlePillarPage: { value: "" },
                        image: { value: {} },
                        mobileImage: { value: {} },
                        filterBy: null,
                      },
                    },
                    {
                      id: "a03681df-6c37-4e64-97c8-f8b6663ad059",
                      name: "retirement income",
                      displayName: "退休收入",
                      fields: {
                        searchName: { value: "retirement income" },
                        name: { value: "退休收入" },
                        articlePillarPage: { value: "" },
                        image: { value: {} },
                        mobileImage: { value: {} },
                        filterBy: null,
                      },
                    },
                    {
                      id: "01a1f5c0-43a6-4859-b366-3d5869d14217",
                      name: "savings",
                      displayName: "儲蓄成份",
                      fields: {
                        searchName: { value: "saving elements" },
                        name: { value: "儲蓄成份" },
                        articlePillarPage: { value: "" },
                        image: { value: {} },
                        mobileImage: { value: {} },
                        filterBy: null,
                      },
                    },
                    {
                      id: "c533b33f-b0cd-4e96-91bc-613d701c3dbb",
                      name: "single premium",
                      displayName: "躉繳保費",
                      fields: {
                        searchName: { value: "single premium" },
                        name: { value: "躉繳保費" },
                        articlePillarPage: { value: "" },
                        image: { value: {} },
                        mobileImage: { value: {} },
                        filterBy: null,
                      },
                    },
                    {
                      id: "18e13af1-159b-4734-be02-23654fe4ce59",
                      name: "sports",
                      displayName: "運動",
                      fields: {
                        searchName: { value: "sports" },
                        name: { value: "運動" },
                        articlePillarPage: { value: "" },
                        image: { value: {} },
                        mobileImage: { value: {} },
                        filterBy: null,
                      },
                    },
                    {
                      id: "06eaac7c-447d-4807-90cb-edcd8119b05c",
                      name: "tax benefits",
                      displayName: "稅務優惠",
                      fields: {
                        searchName: { value: "tax benefits" },
                        name: { value: "稅務優惠" },
                        articlePillarPage: { value: "" },
                        image: { value: {} },
                        mobileImage: { value: {} },
                        filterBy: null,
                      },
                    },
                    {
                      id: "8c20efc7-d745-4671-b3c9-b869db395686",
                      name: "third party",
                      displayName: "第三者保險",
                      fields: {
                        searchName: { value: "third party" },
                        name: { value: "第三者保險" },
                        articlePillarPage: { value: "" },
                        image: { value: {} },
                        mobileImage: { value: {} },
                        filterBy: null,
                      },
                    },
                    {
                      id: "257edb85-1964-496d-ae52-3148096e8831",
                      name: "without saving elements",
                      displayName: "意外損毀",
                      fields: {
                        searchName: { value: "without saving elements" },
                        name: { value: "無儲蓄成份" },
                        articlePillarPage: { value: "" },
                        image: { value: {} },
                        mobileImage: { value: {} },
                        filterBy: null,
                      },
                    },
                  ],
                  resetLinkIcon: {
                    id: "333fe4f4-b36c-409b-90ad-503a6561b8d8",
                    fieldType: "Droplink",
                    fieldName: "resetLinkIcon",
                    url: "/sitecore/content/fwd/global/settings/list/linkvariant/reset",
                    fields: {
                      value: { value: "reset" },
                      key: { value: "Reset" },
                    },
                  },
                  linkIcon: {
                    id: "8e6f2179-2d7b-420d-9d47-d13c408bb3c5",
                    fieldType: "Droplink",
                    fieldName: "linkIcon",
                    url: "/sitecore/content/fwd/global/settings/list/linkvariant/search",
                    fields: {
                      value: { value: "search" },
                      key: { value: "Search" },
                    },
                  },
                  resetLinkItem: {
                    value: {
                      href: "https://uat-www.fwd.com.hk/products/",
                      text: "重設 ",
                      linktype: "external",
                      url: "https://uat-www.fwd.com.hk/products/",
                      anchor: "",
                      title: "重設 ",
                      target: "",
                    },
                  },
                  linkItem: { value: {} },
                  title: { value: "我想了解更多關於 " },
                  primaryNeedTags: [
                    {
                      id: "16bfd479-e272-4639-8279-482b12236fc6",
                      fields: {
                        searchName: { value: "life protection" },
                        name: { value: "人壽" },
                        articlePillarPage: { value: "" },
                        image: { value: {} },
                        mobileImage: { value: {} },
                        filterBy: null,
                      },
                    },
                    {
                      id: "44dd9e8c-0c32-4798-82aa-1c486a05171b",
                      fields: {
                        searchName: { value: "medical cover" },
                        name: { value: "醫療保障" },
                        articlePillarPage: { value: "" },
                        image: { value: {} },
                        mobileImage: { value: {} },
                        filterBy: null,
                      },
                    },
                    {
                      id: "062d5d51-cf89-4cc0-96d0-8b000cee4b67",
                      fields: {
                        searchName: { value: "critical illness" },
                        name: { value: "危疾" },
                        articlePillarPage: { value: "" },
                        image: { value: {} },
                        mobileImage: { value: {} },
                        filterBy: null,
                      },
                    },
                    {
                      id: "aa970c76-d978-4b9f-9aa6-298ee0d362e6",
                      fields: {
                        searchName: { value: "household/pets" },
                        name: { value: "家居／寵物" },
                        articlePillarPage: { value: "" },
                        image: { value: {} },
                        mobileImage: { value: {} },
                        filterBy: null,
                      },
                    },
                    {
                      id: "a669f103-df6a-492a-bbd6-da406644c78a",
                      fields: {
                        searchName: { value: "travel/golf" },
                        name: { value: "旅遊／高爾夫球" },
                        articlePillarPage: { value: "" },
                        image: { value: {} },
                        mobileImage: { value: {} },
                        filterBy: null,
                      },
                    },
                    {
                      id: "86154087-c46b-406d-b42c-0ece46173165",
                      fields: {
                        searchName: { value: "savings" },
                        name: { value: "儲蓄" },
                        articlePillarPage: { value: "" },
                        image: { value: {} },
                        mobileImage: { value: {} },
                        filterBy: null,
                      },
                    },
                    {
                      id: "e3257454-326d-4aa3-a9ac-1b2ca38ddec1",
                      fields: {
                        searchName: { value: "car/boat" },
                        name: { value: "汽車／遊艇" },
                        articlePillarPage: { value: "" },
                        image: { value: {} },
                        mobileImage: { value: {} },
                        filterBy: null,
                      },
                    },
                    {
                      id: "f7d946f9-aa2d-4911-8290-cc730545bdfc",
                      fields: {
                        searchName: { value: "accident/disability" },
                        name: { value: "意外／傷殘" },
                        articlePillarPage: { value: "" },
                        image: { value: {} },
                        mobileImage: { value: {} },
                        filterBy: null,
                      },
                    },
                    {
                      id: "cbbc0d58-bd1e-457b-b4e8-c992984bc760",
                      fields: {
                        searchName: { value: "helper" },
                        name: { value: "外傭" },
                        articlePillarPage: { value: "" },
                        image: { value: {} },
                        mobileImage: { value: {} },
                        filterBy: null,
                      },
                    },
                    {
                      id: "8683e132-ce5e-45f2-a70c-df3b4bbee0ea",
                      fields: {
                        disclosure: {
                          value: "a502d7b5-56e5-49ee-af75-d767bb290981",
                        },
                        articlePillarPage: { value: "" },
                        image: { value: {} },
                        mobileImage: { value: {} },
                        filterBy: null,
                        searchName: { value: "Investment" },
                        name: { value: "投資" },
                      },
                    },
                  ],
                  gaLabelName: { value: "" },
                  gaCategoryName: { value: "" },
                },
              },
              {
                uid: "ba834dbc-c916-4864-8a59-0e51f187827c",
                componentName: "ProductCardList",
                dataSource: "{1C45F9E0-F11F-4633-9BB9-83D3717EBD4D}",
                params: {
                  showProductCTA: "1",
                  backgroundColor: "grey-white",
                  paddingTop: "Medium",
                  paddingBottom: "Medium",
                },
                fields: {
                  linkItems: null,
                  filtersList: [
                    {
                      id: "3d0213d6-2dbe-4871-809f-400c7f94ff21",
                      fields: {
                        isBooleanFilter: { value: false },
                        queryStringKey: { value: "" },
                        value: { value: "產品類別" },
                        key: { value: "plancomponentfield_s" },
                      },
                    },
                    {
                      id: "0f0de57e-1571-40be-a20f-ffee468d56d7",
                      fields: {
                        isBooleanFilter: { value: false },
                        queryStringKey: { value: "" },
                        value: { value: "立即購買" },
                        key: { value: "purchasemethodfield_sm" },
                      },
                    },
                  ],
                  noResultFoundSource: {
                    id: "307bb32d-5276-48f3-806a-2abe29de59e3",
                    fieldType: "Droplink",
                    fieldName: "noResultFoundSource",
                    url: "/components/noresultfound/product-listing",
                    fields: {
                      title: { value: "沒有搜尋結果 " },
                      icon: {
                        value: {
                          src: "/-/media/global/images/icons/noresult.png?rev=be6415d413fc434f961897dfa2a18891",
                        },
                      },
                      subTitle: {
                        value:
                          "我們找不到任何符合已選取標籤的產品。 \r\n請嘗試選取較少標籤。 ",
                      },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                  },
                  apiAllowPagination: { value: false },
                  apiPageSize: { value: "9" },
                  apiContentType: {
                    id: "3b19d2b5-aaa3-4fb7-a107-4cec5f9110f1",
                    fieldType: "Droplink",
                    fieldName: "apiContentType",
                    url: "/sitecore/content/fwd/global/settings/api-query/search-api/products",
                    fields: {
                      apiName: { value: "Products" },
                      value: {
                        value:
                          "https://prd-api-www.fwd.com/search/{language}/GetProductList",
                      },
                      key: {
                        value:
                          "C9VX6X34b56tC2n2b67hlL5N97VoHguVy1mVnH65KgCm0MWVATlgx9Z453Zb0gE0HXpOzo0Z6ery6oRiNN28z34mBk",
                      },
                    },
                  },
                  apiSortBy: {
                    id: "28c97c30-319a-403c-8d47-85eb8baa708f",
                    fieldType: "Droplink",
                    fieldName: "apiSortBy",
                    url: "/sitecore/content/fwd/global/settings/api-query/sort-by/score-and-title",
                    fields: {
                      value: { value: "scorevalue_l desc,titlefield_s asc" },
                      key: { value: "ScoreAndTitle" },
                    },
                  },
                  apiMobilePageSize: { value: "6" },
                  apiSubType: null,
                  gaLabelName: { value: "" },
                  gaCategoryName: { value: "" },
                },
              },
              {
                uid: "248f9ac4-729b-4713-845a-797e1b4acb65",
                componentName: "CustomerSupport",
                dataSource: "{19453B22-22AE-4D55-8F39-8C8F341FA873}",
                params: {
                  buttonAlignment: "center",
                  variant: "base",
                  numberOfColumns: "three",
                  backgroundColor: "orange-white",
                  paddingTop: "Medium",
                  paddingBottom: "Medium",
                },
                fields: {
                  supportIcon: {
                    id: "0853a008-9b3c-4a10-98b9-1e96a3cdc253",
                    fieldType: "Droplink",
                    fieldName: "supportIcon",
                    url: "/sitecore/content/fwd/global/settings/list/linkvariant/call",
                    fields: {
                      value: { value: "call" },
                      key: { value: "Call" },
                    },
                  },
                  title: { value: "了解更多 " },
                  description: {
                    value:
                      "難以決定哪個產品更適合您? 想得到更多資訊? 請選擇以下選項。",
                  },
                  supportOptions: [
                    {
                      id: "48391c1c-5699-4669-ba3b-7492f9401e2f",
                      fields: {
                        contactNumber: { value: "+852 3123 3123" },
                        subTitle: {
                          value: "每日上午9時至晚上11時，我們都會全力協助您。",
                        },
                        icon: {
                          value: {
                            src: "/-/media/images/supports/call.svg?rev=5ed85ebbe95342b3972b09a5f8f8b3ac",
                            alt: "call",
                          },
                        },
                        title: { value: "致電客戶支援" },
                        supportIcon: {
                          id: "0853a008-9b3c-4a10-98b9-1e96a3cdc253",
                          fieldType: "CustomDroplink",
                          fieldName: "supportIcon",
                          url: "/sitecore/content/fwd/global/settings/list/linkvariant/call",
                          fields: {
                            value: { value: "call" },
                            key: { value: "Call" },
                          },
                        },
                        buttonIcon: {
                          id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                          fieldType: "CustomDroplink",
                          fieldName: "buttonIcon",
                          url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                          fields: {
                            value: { value: "arrow-right" },
                            key: { value: "Link" },
                          },
                        },
                        link: {
                          value: {
                            href: "http://tel:+852 3123 3123",
                            text: "致電 3123 3123",
                            linktype: "external",
                            url: "http://tel:+852 3123 3123",
                            anchor: "",
                            target: "",
                          },
                        },
                        buttonMode: {
                          id: "02a5a5c7-c318-4919-b773-86a65ba98969",
                          fieldType: "Droplink",
                          fieldName: "buttonMode",
                          url: "/sitecore/content/fwd/global/settings/list/button-mode/simple-link",
                          fields: {
                            value: { value: "SimpleLink" },
                            key: { value: "SimpleLink" },
                          },
                        },
                        linkGALabelName: { value: "Call 3123 3123" },
                        listType: {
                          id: "a5bee68c-8e43-4f78-8d15-d42982fd053a",
                          fieldType: "Droplink",
                          fieldName: "listType",
                          url: "/sitecore/content/fwd/global/settings/list/linklisttype/call",
                          fields: {
                            value: { value: "Call" },
                            key: { value: "call" },
                          },
                        },
                      },
                    },
                    {
                      id: "2757552b-e7b7-4b23-96ee-1ba924a4178b",
                      fields: {
                        title: { value: "開始即時對話" },
                        icon: {
                          value: {
                            src: "/-/media/images/supports/chat.svg?rev=aaa9f20075e348f199dad4c0f99609d9",
                            alt: "chat",
                          },
                        },
                        subTitle: { value: "我們全天候24小時為您服務。" },
                        supportIcon: {
                          id: "631bc306-c30e-4d10-afe5-670237118479",
                          fieldType: "CustomDroplink",
                          fieldName: "supportIcon",
                          url: "/sitecore/content/fwd/global/settings/list/linkvariant/chat",
                          fields: {
                            value: { value: "chat" },
                            key: { value: "chat" },
                          },
                        },
                        buttonIcon: {
                          id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                          fieldType: "CustomDroplink",
                          fieldName: "buttonIcon",
                          url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                          fields: {
                            value: { value: "arrow-right" },
                            key: { value: "Link" },
                          },
                        },
                        link: { value: {} },
                        buttonMode: {
                          id: "02a5a5c7-c318-4919-b773-86a65ba98969",
                          fieldType: "Droplink",
                          fieldName: "buttonMode",
                          url: "/sitecore/content/fwd/global/settings/list/button-mode/simple-link",
                          fields: {
                            value: { value: "SimpleLink" },
                            key: { value: "SimpleLink" },
                          },
                        },
                        linkGALabelName: { value: "Chat Support" },
                        listType: {
                          id: "dda5c48b-3a8a-4afe-9b24-eaba5cda8c77",
                          fieldType: "Droplink",
                          fieldName: "listType",
                          url: "/sitecore/content/fwd/global/settings/list/linklisttype/chat",
                          fields: {
                            value: { value: "Chat" },
                            key: { value: "chat" },
                          },
                        },
                      },
                    },
                    {
                      id: "b947c809-c632-4013-b6ed-24446509484c",
                      fields: {
                        medalliaForm: { value: "" },
                        title: { value: "留訊息給我們" },
                        icon: {
                          value: {
                            src: "/-/media/images/supports/call.svg?rev=5ed85ebbe95342b3972b09a5f8f8b3ac",
                            alt: "call",
                          },
                        },
                        subTitle: {
                          value: "對於您的問題或寶貴意見，我們會儘快回覆您。",
                        },
                        supportIcon: {
                          id: "f35ed9fd-ad24-494a-8fb6-33be8955a85d",
                          fieldType: "CustomDroplink",
                          fieldName: "supportIcon",
                          url: "/sitecore/content/fwd/global/settings/list/linkvariant/call-email",
                          fields: {
                            value: { value: "call-email" },
                            key: { value: "callEmail" },
                          },
                        },
                        listType: {
                          id: "f281af72-fa4b-4f87-98f1-4b9d77180e60",
                          fieldType: "Droplink",
                          fieldName: "listType",
                          url: "/sitecore/content/fwd/global/settings/list/linklisttype/generic_link",
                          fields: {
                            value: { value: "Generic Link" },
                            key: { value: "generic_link" },
                          },
                        },
                        buttonIcon: {
                          id: "f35ed9fd-ad24-494a-8fb6-33be8955a85d",
                          fieldType: "CustomDroplink",
                          fieldName: "buttonIcon",
                          url: "/sitecore/content/fwd/global/settings/list/linkvariant/call-email",
                          fields: {
                            value: { value: "call-email" },
                            key: { value: "callEmail" },
                          },
                        },
                        link: {
                          value: {
                            text: "Enquire",
                            linktype: "form",
                            querystring: "enquiry",
                            target: "",
                            id: "{F2728281-FA5C-41CB-B168-773E0C78197F}",
                            href: "/forms-list/product-enquiry-form",
                          },
                        },
                        buttonMode: {
                          id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                          fieldType: "Droplink",
                          fieldName: "buttonMode",
                          url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
                          fields: {
                            value: { value: "Primary" },
                            key: { value: "Primary" },
                          },
                        },
                        linkGALabelName: { value: "Product Enquiry" },
                      },
                    },
                  ],
                  buttonIcon: null,
                  link: {
                    value: {
                      href: "https://www.fwd.com.hk/support/",
                      text: "顯示所有支援方式",
                      anchor: "",
                      linktype: "internal",
                      class: "",
                      title: "",
                      querystring: "",
                      id: "{9C6D9E13-7967-40EA-AAAA-753CA0685D6C}",
                    },
                  },
                  buttonMode: {
                    id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                    fieldType: "Droplink",
                    fieldName: "buttonMode",
                    url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
                    fields: {
                      value: { value: "Primary" },
                      key: { value: "Primary" },
                    },
                  },
                  linkGALabelName: { value: "" },
                  gaLabelName: { value: "" },
                  gaCategoryName: { value: "" },
                },
              },
            ],
            "jss-footer": [
              {
                uid: "d6134fb5-960b-4784-8ae2-7231655f27dc",
                componentName: "Footer",
                dataSource: "{9EBE2261-EE52-4C15-A42C-D9F3E2DA9353}",
                params: {
                  backgroundColor: "orangeLighter-white",
                  paddingTop: "Medium",
                  paddingBottom: "None",
                },
                fields: {
                  logo: {
                    value: {
                      src: "/-/media/global/images/fwd-logo_colour.svg?rev=77f0e92219254f9caea8bbe5bba16478",
                      alt: "FWD logo svg",
                    },
                  },
                  logoLink: {
                    value: {
                      href: "/",
                      text: "Home",
                      anchor: "",
                      linktype: "internal",
                      class: "",
                      title: "Home",
                      target: "",
                      querystring: "",
                      id: "{9CB72689-FA18-4900-B876-3AE397D3B009}",
                    },
                  },
                  callingHoursTextAfterTooltip: { value: "" },
                  call: { value: "3123 3123" },
                  enableCallingHoursText: { value: false },
                  callingHoursTextBeforeTooltip: { value: "" },
                  callingHoursTooltip: { value: "" },
                  icon: {
                    id: "0853a008-9b3c-4a10-98b9-1e96a3cdc253",
                    fieldType: "CustomDroplink",
                    fieldName: "icon",
                    url: "/sitecore/content/fwd/global/settings/list/linkvariant/call",
                    fields: {
                      value: { value: "call" },
                      key: { value: "Call" },
                    },
                  },
                  siteNavigationLinks: [
                    {
                      id: "1ebeab06-370c-4369-9651-c7d6a619b279",
                      name: "column-1",
                      displayName: "column-1",
                      fields: {},
                      Children: [
                        {
                          id: "3431b193-681c-4142-9f73-794ae4e593d4",
                          name: "Product",
                          displayName: "Product",
                          fields: {
                            buttonIcon: {
                              id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                              fieldType: "CustomDroplink",
                              fieldName: "buttonIcon",
                              url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                              fields: {
                                value: { value: "chevron-right" },
                                key: { value: "chevronRight" },
                              },
                            },
                            title: { value: "產品 " },
                            link: {
                              value: {
                                href: "/products/",
                                text: "Products",
                                anchor: "",
                                linktype: "internal",
                                class: "",
                                title: "",
                                target: "",
                                querystring: "",
                                id: "{DB3FF0BC-2E10-4735-8BAA-76A87A906821}",
                              },
                            },
                            listType: {
                              id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                              fieldType: "Droplink",
                              fieldName: "listType",
                              url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                              fields: {
                                value: { value: "Generic Link" },
                                key: { value: "generic_link" },
                              },
                            },
                            gaLabelName: { value: "" },
                            gaCategoryName: { value: "" },
                          },
                          Children: [
                            {
                              id: "6543e042-8c82-4c41-a523-b4c867515f60",
                              name: "Critical Illness",
                              displayName: "Critical Illness",
                              fields: {
                                buttonIcon: {
                                  id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                  fieldType: "CustomDroplink",
                                  fieldName: "buttonIcon",
                                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                  fields: {
                                    value: { value: "chevron-right" },
                                    key: { value: "chevronRight" },
                                  },
                                },
                                title: { value: "危疾 " },
                                link: {
                                  value: {
                                    href: "/products/critical-illness/",
                                    text: "Critical Illness",
                                    anchor: "",
                                    linktype: "internal",
                                    class: "",
                                    title: "",
                                    querystring: "",
                                    id: "{A82A3182-0C78-4208-B8A3-F15B27C2E709}",
                                  },
                                },
                                listType: {
                                  id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                  fieldType: "Droplink",
                                  fieldName: "listType",
                                  url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                  fields: {
                                    value: { value: "Generic Link" },
                                    key: { value: "generic_link" },
                                  },
                                },
                                gaLabelName: { value: "" },
                                gaCategoryName: { value: "" },
                              },
                            },
                            {
                              id: "7651448b-e7b8-4914-aeb5-fbe68e498ca0",
                              name: "Life Protection",
                              displayName: "Life Protection",
                              fields: {
                                buttonIcon: {
                                  id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                  fieldType: "CustomDroplink",
                                  fieldName: "buttonIcon",
                                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                  fields: {
                                    value: { value: "chevron-right" },
                                    key: { value: "chevronRight" },
                                  },
                                },
                                title: { value: "人壽 " },
                                link: {
                                  value: {
                                    href: "/products/life-protection/",
                                    text: "Life Protection",
                                    anchor: "",
                                    linktype: "internal",
                                    class: "",
                                    title: "",
                                    querystring: "",
                                    id: "{6F14A835-42D9-4317-993F-19811456F986}",
                                  },
                                },
                                listType: {
                                  id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                  fieldType: "Droplink",
                                  fieldName: "listType",
                                  url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                  fields: {
                                    value: { value: "Generic Link" },
                                    key: { value: "generic_link" },
                                  },
                                },
                                gaLabelName: { value: "" },
                                gaCategoryName: { value: "" },
                              },
                            },
                            {
                              id: "c57f02ee-be06-4dc8-a96d-4ce3c78f13db",
                              name: "Medical Cover",
                              displayName: "Medical Cover",
                              fields: {
                                buttonIcon: {
                                  id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                  fieldType: "CustomDroplink",
                                  fieldName: "buttonIcon",
                                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                  fields: {
                                    value: { value: "chevron-right" },
                                    key: { value: "chevronRight" },
                                  },
                                },
                                title: { value: "醫療保障" },
                                link: {
                                  value: {
                                    href: "/products/medical-cover/",
                                    text: "Medical Cover",
                                    anchor: "",
                                    linktype: "internal",
                                    class: "",
                                    title: "",
                                    querystring: "",
                                    id: "{636DDAC6-5889-4950-BE35-02B32E5C4F18}",
                                  },
                                },
                                listType: {
                                  id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                  fieldType: "Droplink",
                                  fieldName: "listType",
                                  url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                  fields: {
                                    value: { value: "Generic Link" },
                                    key: { value: "generic_link" },
                                  },
                                },
                                gaLabelName: { value: "" },
                                gaCategoryName: { value: "" },
                              },
                            },
                            {
                              id: "927bc564-132e-4e48-bd6b-ba61f687d2f0",
                              name: "VHIS",
                              displayName: "VHIS",
                              fields: {
                                buttonIcon: {
                                  id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                  fieldType: "CustomDroplink",
                                  fieldName: "buttonIcon",
                                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                  fields: {
                                    value: { value: "chevron-right" },
                                    key: { value: "chevronRight" },
                                  },
                                },
                                title: { value: "自願醫保計劃" },
                                link: {
                                  value: {
                                    href: "/products/vhis/",
                                    text: "Vhis",
                                    anchor: "",
                                    linktype: "internal",
                                    class: "",
                                    title: "",
                                    querystring: "",
                                    id: "{162A0204-90F2-4731-8FF8-1B40FD8BFC8F}",
                                  },
                                },
                                listType: {
                                  id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                  fieldType: "Droplink",
                                  fieldName: "listType",
                                  url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                  fields: {
                                    value: { value: "Generic Link" },
                                    key: { value: "generic_link" },
                                  },
                                },
                                gaLabelName: { value: "" },
                                gaCategoryName: { value: "" },
                              },
                            },
                            {
                              id: "68247ed9-3f30-4229-9cfb-c5937bbb6682",
                              name: "Savings",
                              displayName: "Savings",
                              fields: {
                                buttonIcon: {
                                  id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                  fieldType: "CustomDroplink",
                                  fieldName: "buttonIcon",
                                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                  fields: {
                                    value: { value: "chevron-right" },
                                    key: { value: "chevronRight" },
                                  },
                                },
                                title: { value: "儲蓄 " },
                                link: {
                                  value: {
                                    href: "/products/savings/",
                                    text: "Savings",
                                    anchor: "",
                                    linktype: "internal",
                                    class: "",
                                    title: "",
                                    querystring: "",
                                    id: "{D1312CF3-9AE4-4E3C-9375-DDE2398104B5}",
                                  },
                                },
                                listType: {
                                  id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                  fieldType: "Droplink",
                                  fieldName: "listType",
                                  url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                  fields: {
                                    value: { value: "Generic Link" },
                                    key: { value: "generic_link" },
                                  },
                                },
                                gaLabelName: { value: "" },
                                gaCategoryName: { value: "" },
                              },
                            },
                            {
                              id: "0267eb8f-84a7-47f0-8ecb-d8a76e115802",
                              name: "Accident and Disability",
                              displayName: "Accident and Disability",
                              fields: {
                                buttonIcon: {
                                  id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                  fieldType: "CustomDroplink",
                                  fieldName: "buttonIcon",
                                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                  fields: {
                                    value: { value: "chevron-right" },
                                    key: { value: "chevronRight" },
                                  },
                                },
                                title: { value: "意外／傷殘 " },
                                link: {
                                  value: {
                                    href: "/products/accident-disability/",
                                    text: "Accident Disability",
                                    anchor: "",
                                    linktype: "internal",
                                    class: "",
                                    title: "",
                                    querystring: "",
                                    id: "{67CEF236-323A-4DBB-A4A5-44D8B231BF78}",
                                  },
                                },
                                listType: {
                                  id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                  fieldType: "Droplink",
                                  fieldName: "listType",
                                  url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                  fields: {
                                    value: { value: "Generic Link" },
                                    key: { value: "generic_link" },
                                  },
                                },
                                gaLabelName: { value: "" },
                                gaCategoryName: { value: "" },
                              },
                            },
                            {
                              id: "6b329393-9d7a-4ab2-81af-f5a0899ce0fd",
                              name: "Household and Pets",
                              displayName: "Household and Pets",
                              fields: {
                                buttonIcon: {
                                  id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                  fieldType: "CustomDroplink",
                                  fieldName: "buttonIcon",
                                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                  fields: {
                                    value: { value: "chevron-right" },
                                    key: { value: "chevronRight" },
                                  },
                                },
                                title: { value: "家居／寵物 " },
                                link: {
                                  value: {
                                    href: "/products/household-pets/",
                                    text: "Household-pets",
                                    anchor: "",
                                    linktype: "internal",
                                    class: "",
                                    title: "",
                                    querystring: "",
                                    id: "{A923A2DC-E458-44F7-97D5-BCECC64F7497}",
                                  },
                                },
                                listType: {
                                  id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                  fieldType: "Droplink",
                                  fieldName: "listType",
                                  url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                  fields: {
                                    value: { value: "Generic Link" },
                                    key: { value: "generic_link" },
                                  },
                                },
                                gaLabelName: { value: "" },
                                gaCategoryName: { value: "" },
                              },
                            },
                            {
                              id: "176cb320-6acb-4cf1-9c3d-f2905f339597",
                              name: "Invest",
                              displayName: "Invest",
                              fields: {
                                buttonIcon: {
                                  id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                  fieldType: "CustomDroplink",
                                  fieldName: "buttonIcon",
                                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                  fields: {
                                    value: { value: "chevron-right" },
                                    key: { value: "chevronRight" },
                                  },
                                },
                                title: { value: "投資 " },
                                link: {
                                  value: {
                                    href: "/products/invest/",
                                    text: "Invest",
                                    anchor: "",
                                    linktype: "internal",
                                    class: "",
                                    title: "",
                                    querystring: "",
                                    id: "{2375DA5B-104B-4B0C-A915-78223732320F}",
                                  },
                                },
                                listType: {
                                  id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                  fieldType: "Droplink",
                                  fieldName: "listType",
                                  url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                  fields: {
                                    value: { value: "Generic Link" },
                                    key: { value: "generic_link" },
                                  },
                                },
                                gaLabelName: { value: "" },
                                gaCategoryName: { value: "" },
                              },
                            },
                            {
                              id: "6972d099-a073-4faa-a92f-4ed0f5620bdf",
                              name: "Car-boat",
                              displayName: "Car-boat",
                              fields: {
                                buttonIcon: {
                                  id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                  fieldType: "CustomDroplink",
                                  fieldName: "buttonIcon",
                                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                  fields: {
                                    value: { value: "chevron-right" },
                                    key: { value: "chevronRight" },
                                  },
                                },
                                title: { value: "汽車／遊艇 " },
                                link: {
                                  value: {
                                    href: "/products/car-boat/",
                                    text: "car-boat",
                                    anchor: "",
                                    linktype: "internal",
                                    class: "",
                                    title: "",
                                    querystring: "",
                                    id: "{676FD29E-0036-4C29-BF5E-D0032622E7B7}",
                                  },
                                },
                                listType: {
                                  id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                  fieldType: "Droplink",
                                  fieldName: "listType",
                                  url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                  fields: {
                                    value: { value: "Generic Link" },
                                    key: { value: "generic_link" },
                                  },
                                },
                                gaLabelName: { value: "" },
                                gaCategoryName: { value: "" },
                              },
                            },
                            {
                              id: "3acb3f96-9d5d-4cb4-b1ee-dd86fe4af2c6",
                              name: "Helper",
                              displayName: "Helper",
                              fields: {
                                buttonIcon: {
                                  id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                  fieldType: "CustomDroplink",
                                  fieldName: "buttonIcon",
                                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                  fields: {
                                    value: { value: "chevron-right" },
                                    key: { value: "chevronRight" },
                                  },
                                },
                                title: { value: "外傭 " },
                                link: {
                                  value: {
                                    href: "/products/helper/",
                                    text: "helper",
                                    anchor: "",
                                    linktype: "internal",
                                    class: "",
                                    title: "",
                                    querystring: "",
                                    id: "{F758BC09-C312-4E75-B5DF-4A5660CBE482}",
                                  },
                                },
                                listType: {
                                  id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                  fieldType: "Droplink",
                                  fieldName: "listType",
                                  url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                  fields: {
                                    value: { value: "Generic Link" },
                                    key: { value: "generic_link" },
                                  },
                                },
                                gaLabelName: { value: "" },
                                gaCategoryName: { value: "" },
                              },
                            },
                            {
                              id: "320242c6-7fb0-4c4b-b0ad-5d71a9830fd7",
                              name: "Travel and golf",
                              displayName: "Travel and golf",
                              fields: {
                                buttonIcon: {
                                  id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                  fieldType: "CustomDroplink",
                                  fieldName: "buttonIcon",
                                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                  fields: {
                                    value: { value: "chevron-right" },
                                    key: { value: "chevronRight" },
                                  },
                                },
                                title: { value: "旅遊／高爾夫球 " },
                                link: {
                                  value: {
                                    href: "/products/travel-golf/",
                                    text: "travel-golf",
                                    anchor: "",
                                    linktype: "internal",
                                    class: "",
                                    title: "",
                                    querystring: "",
                                    id: "{47EF2BAA-5211-49C4-A4B5-50133E343C8D}",
                                  },
                                },
                                listType: {
                                  id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                  fieldType: "Droplink",
                                  fieldName: "listType",
                                  url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                  fields: {
                                    value: { value: "Generic Link" },
                                    key: { value: "generic_link" },
                                  },
                                },
                                gaLabelName: { value: "" },
                                gaCategoryName: { value: "" },
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      id: "b51fdc29-b76e-47dc-920d-ab68aaad347d",
                      name: "column-2",
                      displayName: "column-2",
                      fields: {},
                      Children: [
                        {
                          id: "a865ba29-89d5-490a-a941-1fe3cf1bfc49",
                          name: "Claims",
                          displayName: "Claims",
                          fields: {
                            buttonIcon: {
                              id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                              fieldType: "CustomDroplink",
                              fieldName: "buttonIcon",
                              url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                              fields: {
                                value: { value: "chevron-right" },
                                key: { value: "chevronRight" },
                              },
                            },
                            title: { value: "索償 " },
                            link: {
                              value: {
                                href: "/claims/",
                                text: "",
                                anchor: "",
                                linktype: "internal",
                                class: "",
                                title: "",
                                target: "",
                                querystring: "",
                                id: "{1ECCEDC9-E80A-4521-A507-CC81BD2A5EC6}",
                              },
                            },
                            listType: {
                              id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                              fieldType: "Droplink",
                              fieldName: "listType",
                              url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                              fields: {
                                value: { value: "Generic Link" },
                                key: { value: "generic_link" },
                              },
                            },
                            gaLabelName: { value: "" },
                            gaCategoryName: { value: "" },
                          },
                          Children: [
                            {
                              id: "bb12f25f-2a51-4bfd-9858-969e4b67a4ea",
                              name: "Find a form",
                              displayName: "Find a form",
                              fields: {
                                buttonIcon: {
                                  id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                  fieldType: "CustomDroplink",
                                  fieldName: "buttonIcon",
                                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                  fields: {
                                    value: { value: "chevron-right" },
                                    key: { value: "chevronRight" },
                                  },
                                },
                                title: { value: "尋找表格 " },
                                link: {
                                  value: {
                                    href: "https://www.fwd.com.hk/support/forms/",
                                    text: "forms",
                                    anchor: "",
                                    linktype: "internal",
                                    class: "",
                                    title: "",
                                    querystring: "",
                                    id: "{DA98F73B-F736-4913-AC1A-CE0A74A11DC5}",
                                  },
                                },
                                listType: {
                                  id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                  fieldType: "Droplink",
                                  fieldName: "listType",
                                  url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                  fields: {
                                    value: { value: "Generic Link" },
                                    key: { value: "generic_link" },
                                  },
                                },
                                gaLabelName: { value: "" },
                                gaCategoryName: { value: "" },
                              },
                            },
                            {
                              id: "f8618e3c-ea42-4090-8fea-a5de61600ed5",
                              name: "Travel claims",
                              displayName: "Travel claims",
                              fields: {
                                buttonIcon: {
                                  id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                  fieldType: "CustomDroplink",
                                  fieldName: "buttonIcon",
                                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                  fields: {
                                    value: { value: "chevron-right" },
                                    key: { value: "chevronRight" },
                                  },
                                },
                                title: { value: "旅遊索償 " },
                                link: {
                                  value: {
                                    href: "/claims/travel/",
                                    text: "travel",
                                    anchor: "",
                                    linktype: "internal",
                                    class: "",
                                    title: "",
                                    querystring: "",
                                    id: "{FB5C74DC-4135-451B-82AC-1A15B1F6A0B5}",
                                  },
                                },
                                listType: {
                                  id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                  fieldType: "Droplink",
                                  fieldName: "listType",
                                  url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                  fields: {
                                    value: { value: "Generic Link" },
                                    key: { value: "generic_link" },
                                  },
                                },
                                gaLabelName: { value: "" },
                                gaCategoryName: { value: "" },
                              },
                            },
                            {
                              id: "6b39cade-87bc-4517-9b54-5dff4599e599",
                              name: "Medical claims",
                              displayName: "Medical claims",
                              fields: {
                                buttonIcon: {
                                  id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                  fieldType: "CustomDroplink",
                                  fieldName: "buttonIcon",
                                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                  fields: {
                                    value: { value: "chevron-right" },
                                    key: { value: "chevronRight" },
                                  },
                                },
                                title: { value: "醫療索償 " },
                                link: {
                                  value: {
                                    href: "/claims/outpatient/",
                                    text: "medical",
                                    anchor: "",
                                    linktype: "internal",
                                    class: "",
                                    title: "",
                                    target: "",
                                    querystring: "",
                                    id: "{2C9488E4-20C5-4124-818F-95C3F0AD1883}",
                                  },
                                },
                                listType: {
                                  id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                  fieldType: "Droplink",
                                  fieldName: "listType",
                                  url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                  fields: {
                                    value: { value: "Generic Link" },
                                    key: { value: "generic_link" },
                                  },
                                },
                                gaLabelName: { value: "" },
                                gaCategoryName: { value: "" },
                              },
                            },
                            {
                              id: "f1c3d1f6-5690-4577-b1fa-95bfdce295e3",
                              name: "Critical illness claims",
                              displayName: "Critical illness claims",
                              fields: {
                                buttonIcon: {
                                  id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                  fieldType: "CustomDroplink",
                                  fieldName: "buttonIcon",
                                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                  fields: {
                                    value: { value: "chevron-right" },
                                    key: { value: "chevronRight" },
                                  },
                                },
                                title: { value: "危疾索償 " },
                                link: {
                                  value: {
                                    href: "/claims/critical-illness/",
                                    text: "critical illness",
                                    anchor: "",
                                    linktype: "internal",
                                    class: "",
                                    title: "",
                                    querystring: "",
                                    id: "{08C951DA-1F83-4DB6-9748-F939B690B0E6}",
                                  },
                                },
                                listType: {
                                  id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                  fieldType: "Droplink",
                                  fieldName: "listType",
                                  url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                  fields: {
                                    value: { value: "Generic Link" },
                                    key: { value: "generic_link" },
                                  },
                                },
                                gaLabelName: { value: "" },
                                gaCategoryName: { value: "" },
                              },
                            },
                            {
                              id: "d7c8c122-dcf4-4f69-8d46-bbd76e50aba9",
                              name: "Accident claims",
                              displayName: "Accident claims",
                              fields: {
                                buttonIcon: {
                                  id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                  fieldType: "CustomDroplink",
                                  fieldName: "buttonIcon",
                                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                  fields: {
                                    value: { value: "chevron-right" },
                                    key: { value: "chevronRight" },
                                  },
                                },
                                title: { value: "意外索償 " },
                                link: {
                                  value: {
                                    href: "/claims/accident/",
                                    text: "",
                                    anchor: "",
                                    linktype: "internal",
                                    class: "",
                                    title: "",
                                    target: "",
                                    querystring: "",
                                    id: "{45A7B83E-EE58-4312-A6F5-3F4D8E920729}",
                                  },
                                },
                                listType: {
                                  id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                  fieldType: "Droplink",
                                  fieldName: "listType",
                                  url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                  fields: {
                                    value: { value: "Generic Link" },
                                    key: { value: "generic_link" },
                                  },
                                },
                                gaLabelName: { value: "" },
                                gaCategoryName: { value: "" },
                              },
                            },
                            {
                              id: "c377828a-ff25-4100-9b42-765e7c164c49",
                              name: "Disablement claims",
                              displayName: "Disablement claims",
                              fields: {
                                buttonIcon: {
                                  id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                  fieldType: "CustomDroplink",
                                  fieldName: "buttonIcon",
                                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                  fields: {
                                    value: { value: "chevron-right" },
                                    key: { value: "chevronRight" },
                                  },
                                },
                                title: { value: "傷殘索償 " },
                                link: {
                                  value: {
                                    href: "/claims/total-permanent-disablement/",
                                    text: "disablement",
                                    anchor: "",
                                    linktype: "internal",
                                    class: "",
                                    title: "",
                                    querystring: "",
                                    id: "{25AE1954-DCBC-4545-AE03-BB21E5727685}",
                                  },
                                },
                                listType: {
                                  id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                  fieldType: "Droplink",
                                  fieldName: "listType",
                                  url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                  fields: {
                                    value: { value: "Generic Link" },
                                    key: { value: "generic_link" },
                                  },
                                },
                                gaLabelName: { value: "" },
                                gaCategoryName: { value: "" },
                              },
                            },
                            {
                              id: "0c09574b-df50-4e2d-8602-ce3ed7fe6c2c",
                              name: "Helper claims",
                              displayName: "Helper claims",
                              fields: {
                                buttonIcon: {
                                  id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                  fieldType: "CustomDroplink",
                                  fieldName: "buttonIcon",
                                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                  fields: {
                                    value: { value: "chevron-right" },
                                    key: { value: "chevronRight" },
                                  },
                                },
                                title: { value: "外傭保障 " },
                                link: {
                                  value: {
                                    href: "/claims/helper/",
                                    text: "helper",
                                    anchor: "",
                                    linktype: "internal",
                                    class: "",
                                    title: "",
                                    querystring: "",
                                    id: "{CB346164-7028-4BFA-9259-F1D69A99E1AD}",
                                  },
                                },
                                listType: {
                                  id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                  fieldType: "Droplink",
                                  fieldName: "listType",
                                  url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                  fields: {
                                    value: { value: "Generic Link" },
                                    key: { value: "generic_link" },
                                  },
                                },
                                gaLabelName: { value: "" },
                                gaCategoryName: { value: "" },
                              },
                            },
                            {
                              id: "dbbcf56c-83cf-43bc-984c-6cabccdb221e",
                              name: "Home and property claims",
                              displayName: "Home and property claims",
                              fields: {
                                buttonIcon: {
                                  id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                  fieldType: "CustomDroplink",
                                  fieldName: "buttonIcon",
                                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                  fields: {
                                    value: { value: "chevron-right" },
                                    key: { value: "chevronRight" },
                                  },
                                },
                                title: { value: "家居財物索償 " },
                                link: {
                                  value: {
                                    href: "/claims/home-property/",
                                    text: "home-property",
                                    anchor: "",
                                    linktype: "internal",
                                    class: "",
                                    title: "",
                                    querystring: "",
                                    id: "{A5A8371A-8C30-4B37-A54E-22C8052C3B60}",
                                  },
                                },
                                listType: {
                                  id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                  fieldType: "Droplink",
                                  fieldName: "listType",
                                  url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                  fields: {
                                    value: { value: "Generic Link" },
                                    key: { value: "generic_link" },
                                  },
                                },
                                gaLabelName: { value: "" },
                                gaCategoryName: { value: "" },
                              },
                            },
                            {
                              id: "417907cc-9285-454d-b5c4-4d5fbbb265c8",
                              name: "Pets claims",
                              displayName: "Pets claims",
                              fields: {
                                buttonIcon: {
                                  id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                  fieldType: "CustomDroplink",
                                  fieldName: "buttonIcon",
                                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                  fields: {
                                    value: { value: "chevron-right" },
                                    key: { value: "chevronRight" },
                                  },
                                },
                                title: { value: "寵物索償 " },
                                link: {
                                  value: {
                                    href: "/claims/pets/",
                                    text: "pets",
                                    anchor: "",
                                    linktype: "internal",
                                    class: "",
                                    title: "",
                                    querystring: "",
                                    id: "{080FDC62-0EE8-446A-9318-970262DE4605}",
                                  },
                                },
                                listType: {
                                  id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                  fieldType: "Droplink",
                                  fieldName: "listType",
                                  url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                  fields: {
                                    value: { value: "Generic Link" },
                                    key: { value: "generic_link" },
                                  },
                                },
                                gaLabelName: { value: "" },
                                gaCategoryName: { value: "" },
                              },
                            },
                            {
                              id: "ea00b33a-a4e4-40e2-85ea-dfa352683213",
                              name: "Car and boat claims",
                              displayName: "Car and boat claims",
                              fields: {
                                buttonIcon: {
                                  id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                  fieldType: "CustomDroplink",
                                  fieldName: "buttonIcon",
                                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                  fields: {
                                    value: { value: "chevron-right" },
                                    key: { value: "chevronRight" },
                                  },
                                },
                                title: { value: "汽車及遊艇索償 " },
                                link: {
                                  value: {
                                    href: "/claims/car-boat/",
                                    text: "car-boat",
                                    anchor: "",
                                    linktype: "internal",
                                    class: "",
                                    title: "",
                                    querystring: "",
                                    id: "{D11A872C-2C11-4FCF-B6A8-E8D38029F9CC}",
                                  },
                                },
                                listType: {
                                  id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                  fieldType: "Droplink",
                                  fieldName: "listType",
                                  url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                  fields: {
                                    value: { value: "Generic Link" },
                                    key: { value: "generic_link" },
                                  },
                                },
                                gaLabelName: { value: "" },
                                gaCategoryName: { value: "" },
                              },
                            },
                            {
                              id: "4c7d44e6-2181-4935-9164-01f8c0e62f9c",
                              name: "Golf claims",
                              displayName: "Golf claims",
                              fields: {
                                buttonIcon: {
                                  id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                  fieldType: "CustomDroplink",
                                  fieldName: "buttonIcon",
                                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                  fields: {
                                    value: { value: "chevron-right" },
                                    key: { value: "chevronRight" },
                                  },
                                },
                                title: { value: "高爾夫球索償 " },
                                link: {
                                  value: {
                                    href: "/products/travel-golf/",
                                    text: "travel-golf",
                                    anchor: "",
                                    linktype: "internal",
                                    class: "",
                                    title: "",
                                    querystring: "",
                                    id: "{47EF2BAA-5211-49C4-A4B5-50133E343C8D}",
                                  },
                                },
                                listType: {
                                  id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                  fieldType: "Droplink",
                                  fieldName: "listType",
                                  url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                  fields: {
                                    value: { value: "Generic Link" },
                                    key: { value: "generic_link" },
                                  },
                                },
                                gaLabelName: { value: "" },
                                gaCategoryName: { value: "" },
                              },
                            },
                            {
                              id: "e041152c-d786-4ea7-99bd-4136ee1a225a",
                              name: "Loss of life claims",
                              displayName: "Loss of life claims",
                              fields: {
                                buttonIcon: {
                                  id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                  fieldType: "CustomDroplink",
                                  fieldName: "buttonIcon",
                                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                  fields: {
                                    value: { value: "chevron-right" },
                                    key: { value: "chevronRight" },
                                  },
                                },
                                title: { value: "死亡索償  " },
                                link: {
                                  value: {
                                    href: "/claims/loss-of-life/",
                                    text: "loss of life",
                                    anchor: "",
                                    linktype: "internal",
                                    class: "",
                                    title: "",
                                    querystring: "",
                                    id: "{B5FEAC69-4732-4FC4-9D78-F6ADD0779995}",
                                  },
                                },
                                listType: {
                                  id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                  fieldType: "Droplink",
                                  fieldName: "listType",
                                  url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                  fields: {
                                    value: { value: "Generic Link" },
                                    key: { value: "generic_link" },
                                  },
                                },
                                gaLabelName: { value: "" },
                                gaCategoryName: { value: "" },
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      id: "a357808e-7483-45e8-b843-4e3c1b30108a",
                      name: "column-3",
                      displayName: "column-3",
                      fields: {},
                      Children: [
                        {
                          id: "79504469-ea34-4ff0-b5e8-a6f3202abf11",
                          name: "Support",
                          displayName: "Support",
                          fields: {
                            buttonIcon: {
                              id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                              fieldType: "CustomDroplink",
                              fieldName: "buttonIcon",
                              url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                              fields: {
                                value: { value: "chevron-right" },
                                key: { value: "chevronRight" },
                              },
                            },
                            title: { value: "支援 " },
                            link: {
                              value: {
                                href: "https://www.fwd.com.hk/support/",
                                text: "",
                                anchor: "",
                                linktype: "internal",
                                class: "",
                                title: "",
                                querystring: "",
                                id: "{9C6D9E13-7967-40EA-AAAA-753CA0685D6C}",
                              },
                            },
                            listType: {
                              id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                              fieldType: "Droplink",
                              fieldName: "listType",
                              url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                              fields: {
                                value: { value: "Generic Link" },
                                key: { value: "generic_link" },
                              },
                            },
                            gaLabelName: { value: "" },
                            gaCategoryName: { value: "" },
                          },
                          Children: [
                            {
                              id: "656a9743-2044-4e9b-8ea1-7291502ee15d",
                              name: "FAQs",
                              displayName: "FAQs",
                              fields: {
                                buttonIcon: {
                                  id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                  fieldType: "CustomDroplink",
                                  fieldName: "buttonIcon",
                                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                  fields: {
                                    value: { value: "chevron-right" },
                                    key: { value: "chevronRight" },
                                  },
                                },
                                title: { value: "常見問題 " },
                                link: {
                                  value: {
                                    href: "https://www.fwd.com.hk/support/faq/",
                                    text: "",
                                    anchor: "",
                                    linktype: "internal",
                                    class: "",
                                    title: "",
                                    querystring: "",
                                    id: "{777F29A0-742A-4A61-8985-5D7C6C75C0E9}",
                                  },
                                },
                                listType: {
                                  id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                  fieldType: "Droplink",
                                  fieldName: "listType",
                                  url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                  fields: {
                                    value: { value: "Generic Link" },
                                    key: { value: "generic_link" },
                                  },
                                },
                                gaLabelName: { value: "" },
                                gaCategoryName: { value: "" },
                              },
                            },
                            {
                              id: "8adb753b-5ead-414f-a7e8-6bec902e5006",
                              name: "Call",
                              displayName: "Call",
                              fields: {
                                buttonIcon: {
                                  id: "0853a008-9b3c-4a10-98b9-1e96a3cdc253",
                                  fieldType: "CustomDroplink",
                                  fieldName: "buttonIcon",
                                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/call",
                                  fields: {
                                    value: { value: "call" },
                                    key: { value: "Call" },
                                  },
                                },
                                title: { value: "致電 3123 3123 " },
                                link: {
                                  value: {
                                    href: "http://tel:31233123",
                                    text: "Call",
                                    linktype: "external",
                                    url: "tel:31233123",
                                    anchor: "",
                                    target: "",
                                  },
                                },
                                listType: {
                                  id: "fd670504-d972-4fee-9582-656b0d6ba342",
                                  fieldType: "Droplink",
                                  fieldName: "listType",
                                  url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/call",
                                  fields: {
                                    value: { value: "Call" },
                                    key: { value: "call" },
                                  },
                                },
                                gaLabelName: { value: "" },
                                gaCategoryName: { value: "" },
                              },
                            },
                            {
                              id: "ac3ab723-d9c1-49af-890f-9b701e2ae311",
                              name: "locate-an-office",
                              displayName: "locate-an-office",
                              fields: {
                                buttonIcon: {
                                  id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                  fieldType: "CustomDroplink",
                                  fieldName: "buttonIcon",
                                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                  fields: {
                                    value: { value: "chevron-right" },
                                    key: { value: "chevronRight" },
                                  },
                                },
                                title: { value: "服務中心地點 " },
                                link: {
                                  value: {
                                    href: "https://www.fwd.com.hk/support/#locatorComponent",
                                    text: "",
                                    anchor: "locatorComponent",
                                    linktype: "internal",
                                    class: "",
                                    title: "",
                                    querystring: "",
                                    id: "{9C6D9E13-7967-40EA-AAAA-753CA0685D6C}",
                                  },
                                },
                                listType: {
                                  id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                  fieldType: "Droplink",
                                  fieldName: "listType",
                                  url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                  fields: {
                                    value: { value: "Generic Link" },
                                    key: { value: "generic_link" },
                                  },
                                },
                                gaLabelName: { value: "" },
                                gaCategoryName: { value: "" },
                              },
                            },
                            {
                              id: "4d695e11-4209-4e75-bd28-83df492ef150",
                              name: "Chat",
                              displayName: "Chat",
                              fields: {
                                buttonIcon: {
                                  id: "631bc306-c30e-4d10-afe5-670237118479",
                                  fieldType: "CustomDroplink",
                                  fieldName: "buttonIcon",
                                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/chat",
                                  fields: {
                                    value: { value: "chat" },
                                    key: { value: "chat" },
                                  },
                                },
                                title: { value: "即時對話 " },
                                link: { value: {} },
                                listType: {
                                  id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                  fieldType: "Droplink",
                                  fieldName: "listType",
                                  url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                  fields: {
                                    value: { value: "Generic Link" },
                                    key: { value: "generic_link" },
                                  },
                                },
                                gaLabelName: { value: "" },
                                gaCategoryName: { value: "" },
                              },
                            },
                            {
                              id: "6c82abe5-623f-4d52-b003-e58ad4778773",
                              name: "online-enquiry",
                              displayName: "online-enquiry",
                              fields: {
                                buttonIcon: {
                                  id: "f35ed9fd-ad24-494a-8fb6-33be8955a85d",
                                  fieldType: "CustomDroplink",
                                  fieldName: "buttonIcon",
                                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/call-email",
                                  fields: {
                                    value: { value: "call-email" },
                                    key: { value: "callEmail" },
                                  },
                                },
                                title: { value: "網上查詢 " },
                                link: {
                                  value: {
                                    text: "Enquire",
                                    linktype: "form",
                                    querystring: "bookAnAgent",
                                    target: "",
                                    id: "{3F7AFE34-5245-4587-ADEC-6A0239C32FF3}",
                                    href: "/forms-list/general-enquiry-form",
                                  },
                                },
                                listType: {
                                  id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                  fieldType: "Droplink",
                                  fieldName: "listType",
                                  url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                  fields: {
                                    value: { value: "Generic Link" },
                                    key: { value: "generic_link" },
                                  },
                                },
                                gaLabelName: { value: "" },
                                gaCategoryName: { value: "" },
                              },
                            },
                            {
                              id: "9f835c92-5c30-4fa7-9940-cad05c4293a7",
                              name: "FWD Moments",
                              displayName: "FWD Moments",
                              fields: {
                                buttonIcon: {
                                  id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                  fieldType: "CustomDroplink",
                                  fieldName: "buttonIcon",
                                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                  fields: {
                                    value: { value: "chevron-right" },
                                    key: { value: "chevronRight" },
                                  },
                                },
                                title: { value: "FWD Moments" },
                                link: {
                                  value: {
                                    href: "https://www.fwd.com.hk/fwd-moments/",
                                    linktype: "external",
                                    url: "https://www.fwd.com.hk/fwd-moments/",
                                    anchor: "",
                                    target: "",
                                  },
                                },
                                listType: {
                                  id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                  fieldType: "Droplink",
                                  fieldName: "listType",
                                  url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                  fields: {
                                    value: { value: "Generic Link" },
                                    key: { value: "generic_link" },
                                  },
                                },
                                gaLabelName: { value: "" },
                                gaCategoryName: { value: "" },
                              },
                            },
                            {
                              id: "06e581d3-9c75-44ba-8596-b411f60a95a6",
                              name: "View ex-Metlife information",
                              displayName: "View ex-Metlife information",
                              fields: {
                                buttonIcon: {
                                  id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                  fieldType: "CustomDroplink",
                                  fieldName: "buttonIcon",
                                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                  fields: {
                                    value: { value: "chevron-right" },
                                    key: { value: "chevronRight" },
                                  },
                                },
                                title: { value: "前大都會人壽資訊" },
                                link: {
                                  value: {
                                    href: "https://www.fwdlife.hk/tc/",
                                    linktype: "external",
                                    url: "https://www.fwdlife.hk/tc/",
                                    anchor: "",
                                    target: "_blank",
                                  },
                                },
                                listType: {
                                  id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                  fieldType: "Droplink",
                                  fieldName: "listType",
                                  url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                  fields: {
                                    value: { value: "Generic Link" },
                                    key: { value: "generic_link" },
                                  },
                                },
                                gaLabelName: { value: "" },
                                gaCategoryName: { value: "" },
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      id: "e42e892f-502b-4723-8173-f024cd4d9ee3",
                      name: "column-4",
                      displayName: "column-4",
                      fields: {},
                      Children: [
                        {
                          id: "e8df46d2-3126-4eb5-a2db-55fe3d66fe24",
                          name: "Business Insurance",
                          displayName: "Business Insurance",
                          fields: {
                            buttonIcon: {
                              id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                              fieldType: "CustomDroplink",
                              fieldName: "buttonIcon",
                              url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                              fields: {
                                value: { value: "chevron-right" },
                                key: { value: "chevronRight" },
                              },
                            },
                            title: { value: "企業保障 " },
                            link: {
                              value: {
                                href: "/business/",
                                text: "business",
                                anchor: "",
                                linktype: "internal",
                                class: "",
                                title: "",
                                querystring: "",
                                id: "{BBB4F360-4715-4653-8CDE-BA9E60D1E26D}",
                              },
                            },
                            listType: {
                              id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                              fieldType: "Droplink",
                              fieldName: "listType",
                              url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                              fields: {
                                value: { value: "Generic Link" },
                                key: { value: "generic_link" },
                              },
                            },
                            gaLabelName: { value: "" },
                            gaCategoryName: { value: "" },
                          },
                          Children: [
                            {
                              id: "434ca16b-5a1e-4d12-a2cf-41ba2acb21b8",
                              name: "Employee benefits",
                              displayName: "Employee benefits",
                              fields: {
                                buttonIcon: {
                                  id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                  fieldType: "CustomDroplink",
                                  fieldName: "buttonIcon",
                                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                  fields: {
                                    value: { value: "chevron-right" },
                                    key: { value: "chevronRight" },
                                  },
                                },
                                title: { value: "僱員福利" },
                                link: {
                                  value: {
                                    href: "https://www.fwd.com.hk/business/employee-benefits/",
                                    text: "僱員福利",
                                    linktype: "external",
                                    url: "https://www.fwd.com.hk/business/employee-benefits/",
                                    anchor: "",
                                    target: "",
                                  },
                                },
                                listType: {
                                  id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                  fieldType: "Droplink",
                                  fieldName: "listType",
                                  url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                  fields: {
                                    value: { value: "Generic Link" },
                                    key: { value: "generic_link" },
                                  },
                                },
                                gaLabelName: { value: "" },
                                gaCategoryName: { value: "" },
                              },
                            },
                            {
                              id: "bcedebbb-1387-4bc6-86bd-4a059edadc7d",
                              name: "Commercial",
                              displayName: "Commercial",
                              fields: {
                                buttonIcon: {
                                  id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                  fieldType: "CustomDroplink",
                                  fieldName: "buttonIcon",
                                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                  fields: {
                                    value: { value: "chevron-right" },
                                    key: { value: "chevronRight" },
                                  },
                                },
                                title: { value: "商業保險" },
                                link: {
                                  value: {
                                    href: "https://www.fwd.com.hk/business/commercial/",
                                    text: "商業保險",
                                    linktype: "external",
                                    url: "https://www.fwd.com.hk/business/commercial/",
                                    anchor: "",
                                    target: "",
                                  },
                                },
                                listType: {
                                  id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                  fieldType: "Droplink",
                                  fieldName: "listType",
                                  url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                  fields: {
                                    value: { value: "Generic Link" },
                                    key: { value: "generic_link" },
                                  },
                                },
                                gaLabelName: { value: "" },
                                gaCategoryName: { value: "" },
                              },
                            },
                          ],
                        },
                        {
                          id: "62039744-6e61-4a1f-92d3-93536136c872",
                          name: "About",
                          displayName: "About",
                          fields: {
                            buttonIcon: {
                              id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                              fieldType: "CustomDroplink",
                              fieldName: "buttonIcon",
                              url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                              fields: {
                                value: { value: "chevron-right" },
                                key: { value: "chevronRight" },
                              },
                            },
                            title: { value: "關於我們" },
                            link: {
                              value: {
                                href: "/about-us/",
                                text: "About us",
                                anchor: "",
                                linktype: "internal",
                                class: "",
                                title: "",
                                querystring: "",
                                id: "{E5F9A3FD-CB1D-4BE3-BC8B-C33AB0CA8199}",
                              },
                            },
                            listType: {
                              id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                              fieldType: "Droplink",
                              fieldName: "listType",
                              url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                              fields: {
                                value: { value: "Generic Link" },
                                key: { value: "generic_link" },
                              },
                            },
                            gaLabelName: { value: "" },
                            gaCategoryName: { value: "" },
                          },
                        },
                        {
                          id: "e22888b3-a607-475f-81d3-6a5ed3b73ab9",
                          name: "Press",
                          displayName: "Press",
                          fields: {
                            buttonIcon: {
                              id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                              fieldType: "CustomDroplink",
                              fieldName: "buttonIcon",
                              url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                              fields: {
                                value: { value: "chevron-right" },
                                key: { value: "chevronRight" },
                              },
                            },
                            title: { value: "新聞稿" },
                            link: {
                              value: {
                                href: "/press/",
                                text: "About us",
                                anchor: "",
                                linktype: "internal",
                                class: "",
                                title: "",
                                querystring: "",
                                id: "{054F3C02-2193-4124-A0F5-2C509121655F}",
                              },
                            },
                            listType: {
                              id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                              fieldType: "Droplink",
                              fieldName: "listType",
                              url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                              fields: {
                                value: { value: "Generic Link" },
                                key: { value: "generic_link" },
                              },
                            },
                            gaLabelName: { value: "" },
                            gaCategoryName: { value: "" },
                          },
                        },
                        {
                          id: "92c24d0e-cbe0-4aa5-bd90-cf874867b9e8",
                          name: "Live",
                          displayName: "Live",
                          fields: {
                            buttonIcon: {
                              id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                              fieldType: "CustomDroplink",
                              fieldName: "buttonIcon",
                              url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                              fields: {
                                value: { value: "chevron-right" },
                                key: { value: "chevronRight" },
                              },
                            },
                            title: { value: "網誌" },
                            link: {
                              value: {
                                href: "/blog/",
                                text: "",
                                anchor: "",
                                linktype: "internal",
                                class: "",
                                title: "",
                                querystring: "",
                                id: "{68E8B2B6-DD6C-411F-91E1-B1B25B2107EB}",
                              },
                            },
                            listType: {
                              id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                              fieldType: "Droplink",
                              fieldName: "listType",
                              url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                              fields: {
                                value: { value: "Generic Link" },
                                key: { value: "generic_link" },
                              },
                            },
                            gaLabelName: { value: "" },
                            gaCategoryName: { value: "" },
                          },
                        },
                      ],
                    },
                  ],
                  countrySelector: [
                    {
                      id: "b43fd69b-bd63-4f64-9aab-06f1b0d527c7",
                      name: "Group",
                      displayName: "Group",
                      fields: {
                        isDefault: { value: false },
                        buttonIcon: null,
                        title: { value: "富衛集團" },
                        link: {
                          value: {
                            href: "https://www.fwd.com/",
                            linktype: "external",
                            url: "https://www.fwd.com/",
                            anchor: "",
                            target: "_blank",
                          },
                        },
                        listType: {
                          id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                          fieldType: "Droplink",
                          fieldName: "listType",
                          url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                          fields: {
                            value: { value: "Generic Link" },
                            key: { value: "generic_link" },
                          },
                        },
                        gaLabelName: { value: "" },
                        gaCategoryName: { value: "" },
                      },
                    },
                    {
                      id: "eb9ee5ea-e079-4bde-af3c-b82e5ebee28a",
                      name: "Hong Kong",
                      displayName: "Hong Kong",
                      fields: {
                        isDefault: { value: true },
                        buttonIcon: null,
                        title: { value: "香港" },
                        link: {
                          value: {
                            href: "/",
                            text: "",
                            anchor: "",
                            linktype: "internal",
                            class: "",
                            title: "",
                            querystring: "",
                            id: "{9CB72689-FA18-4900-B876-3AE397D3B009}",
                          },
                        },
                        listType: {
                          id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                          fieldType: "Droplink",
                          fieldName: "listType",
                          url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                          fields: {
                            value: { value: "Generic Link" },
                            key: { value: "generic_link" },
                          },
                        },
                        gaLabelName: { value: "" },
                        gaCategoryName: { value: "" },
                      },
                    },
                    {
                      id: "dc6f0a0c-f056-44c6-a565-2044c8b494a6",
                      name: "Macau",
                      displayName: "Macau",
                      fields: {
                        isDefault: { value: false },
                        buttonIcon: null,
                        title: { value: "澳門" },
                        link: {
                          value: {
                            href: "https://www.fwd.com.mo/en/",
                            linktype: "external",
                            url: "https://www.fwd.com.mo/en/",
                            anchor: "",
                            target: "_blank",
                          },
                        },
                        listType: {
                          id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                          fieldType: "Droplink",
                          fieldName: "listType",
                          url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                          fields: {
                            value: { value: "Generic Link" },
                            key: { value: "generic_link" },
                          },
                        },
                        gaLabelName: { value: "" },
                        gaCategoryName: { value: "" },
                      },
                    },
                    {
                      id: "62bb0970-5392-494c-8969-53863b8728d3",
                      name: "China representative office",
                      displayName: "China representative office",
                      fields: {
                        isDefault: { value: false },
                        buttonIcon: null,
                        title: { value: "中國代表處" },
                        link: {
                          value: {
                            href: "https://www.fwd.cn/",
                            linktype: "external",
                            url: "https://www.fwd.cn/",
                            anchor: "",
                            target: "_blank",
                          },
                        },
                        listType: {
                          id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                          fieldType: "Droplink",
                          fieldName: "listType",
                          url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                          fields: {
                            value: { value: "Generic Link" },
                            key: { value: "generic_link" },
                          },
                        },
                        gaLabelName: { value: "" },
                        gaCategoryName: { value: "" },
                      },
                    },
                    {
                      id: "79ec13ea-0312-44f7-b305-3660acd71adf",
                      name: "Indonesia",
                      displayName: "Indonesia",
                      fields: {
                        isDefault: { value: false },
                        buttonIcon: null,
                        title: { value: "印尼" },
                        link: {
                          value: {
                            href: "https://www.fwd.co.id/en/",
                            linktype: "external",
                            url: "https://www.fwd.co.id/en/",
                            anchor: "",
                            target: "_blank",
                          },
                        },
                        listType: {
                          id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                          fieldType: "Droplink",
                          fieldName: "listType",
                          url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                          fields: {
                            value: { value: "Generic Link" },
                            key: { value: "generic_link" },
                          },
                        },
                        gaLabelName: { value: "" },
                        gaCategoryName: { value: "" },
                      },
                    },
                    {
                      id: "e5b1b516-9ca4-4a59-9417-03cdedeaab5a",
                      name: "Japan",
                      displayName: "Japan",
                      fields: {
                        isDefault: { value: false },
                        buttonIcon: null,
                        title: { value: "日本" },
                        link: {
                          value: {
                            href: "https://www.fwdlife.co.jp/",
                            linktype: "external",
                            url: "https://www.fwdlife.co.jp/",
                            anchor: "",
                            target: "_blank",
                          },
                        },
                        listType: {
                          id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                          fieldType: "Droplink",
                          fieldName: "listType",
                          url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                          fields: {
                            value: { value: "Generic Link" },
                            key: { value: "generic_link" },
                          },
                        },
                        gaLabelName: { value: "" },
                        gaCategoryName: { value: "" },
                      },
                    },
                    {
                      id: "d3f70c56-ff92-468e-a8e7-bdede76909d1",
                      name: "Malaysia",
                      displayName: "Malaysia",
                      fields: {
                        isDefault: { value: false },
                        buttonIcon: null,
                        title: { value: "馬來西亞" },
                        link: {
                          value: {
                            href: "https://www.fwd.com.my/en/",
                            linktype: "external",
                            url: "https://www.fwd.com.my/en/",
                            anchor: "",
                            target: "_blank",
                          },
                        },
                        listType: {
                          id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                          fieldType: "Droplink",
                          fieldName: "listType",
                          url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                          fields: {
                            value: { value: "Generic Link" },
                            key: { value: "generic_link" },
                          },
                        },
                        gaLabelName: { value: "" },
                        gaCategoryName: { value: "" },
                      },
                    },
                    {
                      id: "0bff6386-fa8a-4ba5-800f-24c2afffbbe0",
                      name: "Philippines",
                      displayName: "Philippines",
                      fields: {
                        isDefault: { value: false },
                        buttonIcon: null,
                        title: { value: "菲律賓" },
                        link: {
                          value: {
                            href: "https://www.fwd.com.ph/en/",
                            linktype: "external",
                            url: "https://www.fwd.com.ph/en/",
                            anchor: "",
                            target: "_blank",
                          },
                        },
                        listType: {
                          id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                          fieldType: "Droplink",
                          fieldName: "listType",
                          url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                          fields: {
                            value: { value: "Generic Link" },
                            key: { value: "generic_link" },
                          },
                        },
                        gaLabelName: { value: "" },
                        gaCategoryName: { value: "" },
                      },
                    },
                    {
                      id: "7bb44e4e-75eb-4b9d-8ff8-4a4a8203cf36",
                      name: "Singapore",
                      displayName: "Singapore",
                      fields: {
                        isDefault: { value: false },
                        buttonIcon: null,
                        title: { value: "新加坡" },
                        link: {
                          value: {
                            href: "https://www.fwd.com.sg/",
                            linktype: "external",
                            url: "https://www.fwd.com.sg/",
                            anchor: "",
                            target: "_blank",
                          },
                        },
                        listType: {
                          id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                          fieldType: "Droplink",
                          fieldName: "listType",
                          url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                          fields: {
                            value: { value: "Generic Link" },
                            key: { value: "generic_link" },
                          },
                        },
                        gaLabelName: { value: "" },
                        gaCategoryName: { value: "" },
                      },
                    },
                    {
                      id: "dc572c84-d525-48c9-a5e0-6215970d93b4",
                      name: "Thailand",
                      displayName: "Thailand",
                      fields: {
                        isDefault: { value: false },
                        buttonIcon: null,
                        title: { value: "泰國" },
                        link: {
                          value: {
                            href: "https://www.fwd.co.th/en/",
                            linktype: "external",
                            url: "https://www.fwd.co.th/en/",
                            anchor: "",
                            target: "_blank",
                          },
                        },
                        listType: {
                          id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                          fieldType: "Droplink",
                          fieldName: "listType",
                          url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                          fields: {
                            value: { value: "Generic Link" },
                            key: { value: "generic_link" },
                          },
                        },
                        gaLabelName: { value: "" },
                        gaCategoryName: { value: "" },
                      },
                    },
                    {
                      id: "4499f614-f9e5-4cd8-a924-8a8ce0c82348",
                      name: "Vietnam",
                      displayName: "Vietnam",
                      fields: {
                        isDefault: { value: false },
                        buttonIcon: null,
                        title: { value: "越南" },
                        link: {
                          value: {
                            href: "https://www.fwd.com.vn/en/",
                            linktype: "external",
                            url: "https://www.fwd.com.vn/en/",
                            anchor: "",
                            target: "_blank",
                          },
                        },
                        listType: {
                          id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                          fieldType: "Droplink",
                          fieldName: "listType",
                          url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                          fields: {
                            value: { value: "Generic Link" },
                            key: { value: "generic_link" },
                          },
                        },
                        gaLabelName: { value: "" },
                        gaCategoryName: { value: "" },
                      },
                    },
                  ],
                  socialMediaLinks: [
                    {
                      id: "edf939e0-1e60-42b5-93db-523f893f16dd",
                      name: "Facebook",
                      displayName: "Facebook",
                      fields: {
                        buttonIcon: {
                          id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                          fieldType: "CustomDroplink",
                          fieldName: "buttonIcon",
                          url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                          fields: {
                            value: { value: "chevron-right" },
                            key: { value: "chevronRight" },
                          },
                        },
                        title: { value: "facebook" },
                        link: {
                          value: {
                            href: "https://www.facebook.com/FWD.HK.MO/",
                            text: "facebook",
                            linktype: "external",
                            url: "https://www.facebook.com/FWD.HK.MO/",
                            anchor: "",
                            target: "_blank",
                          },
                        },
                        listType: {
                          id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                          fieldType: "Droplink",
                          fieldName: "listType",
                          url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                          fields: {
                            value: { value: "Generic Link" },
                            key: { value: "generic_link" },
                          },
                        },
                        gaLabelName: { value: "" },
                        gaCategoryName: { value: "" },
                      },
                    },
                    {
                      id: "90db1f26-feb6-4049-bd0b-f66ad50b6dd0",
                      name: "YouTube",
                      displayName: "YouTube",
                      fields: {
                        buttonIcon: {
                          id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                          fieldType: "CustomDroplink",
                          fieldName: "buttonIcon",
                          url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                          fields: {
                            value: { value: "chevron-right" },
                            key: { value: "chevronRight" },
                          },
                        },
                        title: { value: "youtube" },
                        link: {
                          value: {
                            href: "https://www.youtube.com/FWDHK",
                            text: "youtube",
                            linktype: "external",
                            url: "https://www.youtube.com/FWDHK",
                            anchor: "",
                            target: "_blank",
                          },
                        },
                        listType: {
                          id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                          fieldType: "Droplink",
                          fieldName: "listType",
                          url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                          fields: {
                            value: { value: "Generic Link" },
                            key: { value: "generic_link" },
                          },
                        },
                        gaLabelName: { value: "" },
                        gaCategoryName: { value: "" },
                      },
                    },
                  ],
                  footerQuickLinks: [
                    {
                      id: "e7ae2988-5323-46a2-bba4-6bbff858b107",
                      name: "Sitemap",
                      displayName: "Sitemap",
                      fields: {
                        buttonIcon: {
                          id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                          fieldType: "CustomDroplink",
                          fieldName: "buttonIcon",
                          url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                          fields: {
                            value: { value: "chevron-right" },
                            key: { value: "chevronRight" },
                          },
                        },
                        title: { value: "網站指南 " },
                        link: {
                          value: {
                            href: "/sitemap/",
                            text: "",
                            anchor: "",
                            linktype: "internal",
                            class: "",
                            title: "",
                            querystring: "",
                            id: "{163C1C9B-5497-413A-96C7-23AF7CB06E80}",
                          },
                        },
                        listType: {
                          id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                          fieldType: "Droplink",
                          fieldName: "listType",
                          url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                          fields: {
                            value: { value: "Generic Link" },
                            key: { value: "generic_link" },
                          },
                        },
                        gaLabelName: { value: "" },
                        gaCategoryName: { value: "" },
                      },
                    },
                    {
                      id: "814e649f-6415-4c2e-aed7-64b7f2e1bd7c",
                      name: "Online security",
                      displayName: "Online security",
                      fields: {
                        buttonIcon: {
                          id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                          fieldType: "CustomDroplink",
                          fieldName: "buttonIcon",
                          url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                          fields: {
                            value: { value: "chevron-right" },
                            key: { value: "chevronRight" },
                          },
                        },
                        title: { value: "網上保安 " },
                        link: {
                          value: {
                            href: "/online-security/",
                            text: "",
                            anchor: "",
                            linktype: "internal",
                            class: "",
                            title: "",
                            querystring: "",
                            id: "{B49AECB1-755D-4D22-BE7D-2F7263D5DE27}",
                          },
                        },
                        listType: {
                          id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                          fieldType: "Droplink",
                          fieldName: "listType",
                          url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                          fields: {
                            value: { value: "Generic Link" },
                            key: { value: "generic_link" },
                          },
                        },
                        gaLabelName: { value: "" },
                        gaCategoryName: { value: "" },
                      },
                    },
                    {
                      id: "a0d3a063-f1ba-48ad-94fb-e42f338af381",
                      name: "Disclaimer",
                      displayName: "Disclaimer",
                      fields: {
                        buttonIcon: {
                          id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                          fieldType: "CustomDroplink",
                          fieldName: "buttonIcon",
                          url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                          fields: {
                            value: { value: "chevron-right" },
                            key: { value: "chevronRight" },
                          },
                        },
                        title: { value: "免責聲明 " },
                        link: {
                          value: {
                            href: "/disclaimer/",
                            text: "",
                            anchor: "",
                            linktype: "internal",
                            class: "",
                            title: "",
                            querystring: "",
                            id: "{5A1FC210-94BB-4794-A258-23135CF3A3C1}",
                          },
                        },
                        listType: {
                          id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                          fieldType: "Droplink",
                          fieldName: "listType",
                          url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                          fields: {
                            value: { value: "Generic Link" },
                            key: { value: "generic_link" },
                          },
                        },
                        gaLabelName: { value: "" },
                        gaCategoryName: { value: "" },
                      },
                    },
                    {
                      id: "716e4166-da74-41d5-907d-04e7555c93f5",
                      name: "Insurance levy",
                      displayName: "Insurance levy",
                      fields: {
                        buttonIcon: {
                          id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                          fieldType: "CustomDroplink",
                          fieldName: "buttonIcon",
                          url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                          fields: {
                            value: { value: "chevron-right" },
                            key: { value: "chevronRight" },
                          },
                        },
                        title: { value: "保監局徵費附例 " },
                        link: {
                          value: {
                            href: "/insurance-levy/",
                            text: "",
                            anchor: "",
                            linktype: "internal",
                            class: "",
                            title: "",
                            querystring: "",
                            id: "{0B7F57BA-7515-413E-8AB2-C9EBF635B160}",
                          },
                        },
                        listType: {
                          id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                          fieldType: "Droplink",
                          fieldName: "listType",
                          url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                          fields: {
                            value: { value: "Generic Link" },
                            key: { value: "generic_link" },
                          },
                        },
                        gaLabelName: { value: "" },
                        gaCategoryName: { value: "" },
                      },
                    },
                    {
                      id: "49481599-18fa-4639-a656-bedb93e665f8",
                      name: "Common reporting standard",
                      displayName: "Common reporting standard",
                      fields: {
                        buttonIcon: {
                          id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                          fieldType: "CustomDroplink",
                          fieldName: "buttonIcon",
                          url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                          fields: {
                            value: { value: "chevron-right" },
                            key: { value: "chevronRight" },
                          },
                        },
                        title: { value: "共同匯報標準 " },
                        link: {
                          value: {
                            href: "/common-reporting-standard/",
                            text: "",
                            anchor: "",
                            linktype: "internal",
                            class: "",
                            title: "",
                            querystring: "",
                            id: "{253340F5-CCDF-4AEE-AE8F-767BA7F78C57}",
                          },
                        },
                        listType: {
                          id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                          fieldType: "Droplink",
                          fieldName: "listType",
                          url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                          fields: {
                            value: { value: "Generic Link" },
                            key: { value: "generic_link" },
                          },
                        },
                        gaLabelName: { value: "" },
                        gaCategoryName: { value: "" },
                      },
                    },
                    {
                      id: "db48da58-7cca-49a3-9cf7-f11b92c23f77",
                      name: "Important notice",
                      displayName: "Important notice",
                      fields: {
                        buttonIcon: {
                          id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                          fieldType: "CustomDroplink",
                          fieldName: "buttonIcon",
                          url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                          fields: {
                            value: { value: "chevron-right" },
                            key: { value: "chevronRight" },
                          },
                        },
                        title: { value: "重要通告 " },
                        link: {
                          value: {
                            href: "/important-notice/",
                            text: "",
                            anchor: "",
                            linktype: "internal",
                            class: "",
                            title: "",
                            querystring: "",
                            id: "{E6BC512A-E439-4527-BBC9-18DDD6512A35}",
                          },
                        },
                        listType: {
                          id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                          fieldType: "Droplink",
                          fieldName: "listType",
                          url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                          fields: {
                            value: { value: "Generic Link" },
                            key: { value: "generic_link" },
                          },
                        },
                        gaLabelName: { value: "" },
                        gaCategoryName: { value: "" },
                      },
                    },
                    {
                      id: "92c48be8-f427-406c-b6ac-7f23f0f11e76",
                      name: "Use of cookies",
                      displayName: "Use of cookies",
                      fields: {
                        buttonIcon: {
                          id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                          fieldType: "CustomDroplink",
                          fieldName: "buttonIcon",
                          url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                          fields: {
                            value: { value: "chevron-right" },
                            key: { value: "chevronRight" },
                          },
                        },
                        title: { value: "Cookie政策 " },
                        link: {
                          value: {
                            href: "/use-of-cookies/",
                            text: "",
                            anchor: "",
                            linktype: "internal",
                            class: "",
                            title: "",
                            querystring: "",
                            id: "{DCD61657-FA88-4252-B058-0B7EBE7F06F1}",
                          },
                        },
                        listType: {
                          id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                          fieldType: "Droplink",
                          fieldName: "listType",
                          url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                          fields: {
                            value: { value: "Generic Link" },
                            key: { value: "generic_link" },
                          },
                        },
                        gaLabelName: { value: "" },
                        gaCategoryName: { value: "" },
                      },
                    },
                    {
                      id: "15cd02ca-2c2e-4ae9-9442-dac60f1f4beb",
                      name: "Personal data protection policy and practices",
                      displayName:
                        "Personal data protection policy and practices",
                      fields: {
                        buttonIcon: {
                          id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                          fieldType: "CustomDroplink",
                          fieldName: "buttonIcon",
                          url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                          fields: {
                            value: { value: "chevron-right" },
                            key: { value: "chevronRight" },
                          },
                        },
                        title: { value: "個人資料保護政策及執行 " },
                        link: {
                          value: {
                            href: "/privacy-policy/",
                            text: "",
                            anchor: "",
                            linktype: "internal",
                            class: "",
                            title: "",
                            querystring: "",
                            id: "{BDB6C45F-3372-477C-A588-00DBEBB701C0}",
                          },
                        },
                        listType: {
                          id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                          fieldType: "Droplink",
                          fieldName: "listType",
                          url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                          fields: {
                            value: { value: "Generic Link" },
                            key: { value: "generic_link" },
                          },
                        },
                        gaLabelName: { value: "" },
                        gaCategoryName: { value: "" },
                      },
                    },
                  ],
                  copyrightLabel: {
                    value: "2022 富衛金融有限公司版權所有 不得轉載",
                  },
                  defaultComplianceAccreditation: null,
                  disableComplianceAccreditation: { value: false },
                  gaLabelName: { value: "" },
                  gaCategoryName: { value: "" },
                  enableLanguageToggle: { value: true },
                  languageList: [
                    {
                      id: "f7d73a71-1c14-4b6a-8db1-263b40425b4f",
                      fields: {
                        languageName: { value: "EN" },
                        defaultLanguage: { value: "Tc" },
                        languageCode: { value: "en" },
                      },
                    },
                    {
                      id: "8e721d84-8219-4d9b-9470-4621a8beff37",
                      fields: {
                        languageName: { value: "繁" },
                        defaultLanguage: { value: "En" },
                        languageCode: { value: "tc" },
                      },
                    },
                  ],
                  languageModalDescription: { value: "" },
                  languageModalLink: { value: {} },
                  languageModalSecondaryLink: { value: "" },
                  languageModalTitle: { value: "" },
                },
              },
            ],
          },
        },
      },
    },
    productDetails: {
      initializer: "bookAnAgent",
      enquiryInitializer: "SUPPORT",
      productName: "",
      minAge: "",
      maxAge: "",
      minSumAssured: "",
      maxSumAssured: "",
      calculationOptions: [],
      sumAssuredSelectionType: "",
      premiumSelectionType: "",
      minPremiumYearly: "",
      maxPremiumYearly: "",
      sumAssuredRange: "",
      sumAssuredPaymentMode: [],
      purchaseMethod: [],
      premiumRange: "",
      premiumStepperInterval: "",
      sumAssuredStepperInterval: "",
      plans: [],
      ridersAvailable: null,
      enableEnquiryForRiders: null,
      associatedItems: [],
      filteredAssociatedItems: [],
      allPlanCards: [],
      productType: "",
      talkToAgentLink: null,
      talkToAgentTitle: "",
      expectedInsuranceType: "",
      parameters: null,
      expectedInsuranceTypeProductCard: "",
      parametersProductCard: "",
    },
    formLinks: {
      calculateFormLink: "",
      recommenderFormLink: "",
      enquiryFormLink: "",
      callbackFormLink:
        "https://www.fwd.com.hk/sitecore/api/layout/render/jss?item=/forms-list/product-enquiry-form&sc_lang=tc&sc_apikey={D7333054-1DCE-4B0C-A9A5-AC7372A796AB}",
    },
    finalizer: "",
    apiStatus: {
      loading: false,
      apiStatus: null,
      errorCode: "",
      failCounter: 0,
    },
    form: {
      sitecore: {
        context: {
          pageEditing: false,
          site: { name: "fwd-hk" },
          pageState: "normal",
          language: "zh-HK",
          languageCode: "tc",
          defaultLanguage: "zh-HK",
          siteSettings: {
            productListPage: "/products/",
            splashPage: "",
            articleTagLink: "/search/",
            articleTypeDesign: [],
            articleOverlineText: false,
            globalMetaText: "富衛香港",
            globalMetaTag: "",
            cookieMessage:
              '<p>我們使用Cookies以優化您於我們網站的瀏覽體驗。如繼續瀏覽本網站，即表示您同意我們使用 Cookie 。</p>\n<p>詳情請參閱我們的<a href="~/link.aspx?_id=DCD61657FA884252B0580B7EBE7F06F1&amp;_z=z">Cookie</a>政策。</p>',
            cookieTimeStamp: "10",
            currencyPlacement: "BeforeNumericals",
            currencyWhitespace: false,
            currencySeparator: { value: {} },
            currencyLabel: {
              value: {
                USD: "美元",
                EUR: "歐元",
                HKD: "港元",
                AUD: "澳元",
                RMB: "人民幣",
              },
            },
            splashPageUpdatedDuration: "10",
            splashPageUpdatedDate: "",
            faviconImageUrl:
              "/-/media/global/images/icons/favicon.ico?rev=51cce1bfcfb347b3b2fc7d304180401d",
            productErrorPictogramUrl:
              "/-/media/pictograms/no-result-48px2x.png?rev=6b3f1e7975b545d780c8a676eb165ef0",
            dateFormat: "YYYY年M月D日",
            enablePlanCardSharePostCalc: "",
            sessionTimeout: "20",
            loaderTimeout: "20",
            gAID: "GTM-N6B3G67",
            gTMID: "GTM-N6B3G67",
            gtmParamters: [],
            optimize360: true,
            hostName: "https://www.fwd.com.hk",
            enableBackToTopButton: 1,
            dialogSessionTimeout: "20",
            productFallbackCTA: {
              value: {
                href: "/forms-list/product-enquiry-form",
                text: "查詢",
                anchor: "Enquire",
                linkType: "form",
                title: "查詢",
                queryString: "enquiry",
                id: "{F2728281-FA5C-41CB-B168-773E0C78197F}",
                gaLabel: "Enquiry",
              },
            },
            brightcoveAccountID: "5650355171001",
            languageIcon: { key: "language-globe", value: "language-globe" },
            enableMultipleNotifications: true,
            hidePrimaryLanguage: true,
            currencyGALabelName: "",
            showArticleSubtitle: false,
            hasArticleSubtitleFallback: false,
          },
          share: {
            socialApps: [
              {
                facebook: {
                  url: {
                    value: {
                      href: "https://www.facebook.com/sharer.php?u=",
                      text: "Facebook Url",
                      linktype: "external",
                      url: "https://www.facebook.com/sharer.php?u=",
                      anchor: "",
                      target: "",
                    },
                  },
                  header: { value: "分享至Facebook" },
                  toolTip: { value: "" },
                },
              },
              {
                Whatsapp: {
                  url: {
                    value: {
                      href: "https://web.whatsapp.com/send?text=",
                      linktype: "external",
                      url: "https://web.whatsapp.com/send?text=",
                      anchor: "",
                      target: "",
                    },
                  },
                  header: { value: "分享至Whatsapp" },
                  toolTip: { value: "" },
                },
              },
              {
                Linkedin: {
                  url: {
                    value: {
                      href: "https://www.linkedin.com/sharing/share-offsite/?url=",
                      linktype: "external",
                      url: "https://www.linkedin.com/sharing/share-offsite/?url=",
                      anchor: "",
                      target: "",
                    },
                  },
                  header: { value: "分享至Linkedin" },
                  toolTip: { value: "" },
                },
              },
            ],
          },
          siteNotifications: {
            notifications: [
              {
                hidePublishDate: { value: true },
                publishDate: "2022-08-18T04:08:00Z",
                description: {
                  value:
                    '<span style="color: #183028;">最新消息：富衛推出</span><span style="color: #183028;">「疫苗副作用特別保障」，</span>點擊<a href="/coronavirusfaq">此處</a>了解。',
                },
                expiryDate: "2024-03-31T00:00:00Z",
                pagesList: { value: "/" },
                icon: {
                  id: "c0c57154-6ec6-4264-8d86-a4efebbd1533",
                  fieldType: "CustomDroplink",
                  fieldName: "icon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/notification---obsolete",
                  fields: {
                    value: { value: "notification-icon" },
                    key: { value: "Notification" },
                  },
                },
              },
              {
                hidePublishDate: { value: true },
                publishDate: "2022-04-26T09:58:00Z",
                description: {
                  value:
                    "本網站 (https://fwd.com.hk/blog) 由富衛金融有限公司營運。富衛金融有限公司乃富衛人壽保險（百慕達）有限公司及富衛保險有限公司的委任持牌保險代理。",
                },
                expiryDate: "2030-12-31T23:30:00Z",
                pagesList: { value: "/blog/" },
              },
              {
                hidePublishDate: { value: true },
                publishDate: "2022-08-03T04:13:00Z",
                description: {
                  value:
                    "2019冠狀病毒病特別安排：富衛保險綜合服務中心之服務時間為星期一至六上午9時30分至下午5時30分，星期日及公眾假期休息。另外，客戶熱線的服務時間為每日上午9時至下午6時。",
                },
                expiryDate: "2025-11-30T11:36:00Z",
                pagesList: { value: "/, /business/" },
                icon: {
                  id: "c4ce9c6d-80fa-402f-9b49-87c412a21684",
                  fieldType: "CustomDroplink",
                  fieldName: "icon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/alert---obsolete",
                  fields: {
                    value: { value: "alert" },
                    key: { value: "alert" },
                  },
                },
              },
              {
                hidePublishDate: { value: true },
                publishDate: "2022-02-22T08:07:45Z",
                description: {
                  value:
                    '本網站 (<a href="https://www.fwd.com.hk/claims/">https://fwd.com.hk/claims</a>) 由富衛金融有限公司營運。富衛金融有限公司乃富衛人壽保險（百慕達）有限公司及富衛保險有限公司的委任持牌保險代理。',
                },
                expiryDate: "2030-02-22T00:00:00Z",
                pagesList: { value: "/claims/" },
              },
              {
                hidePublishDate: { value: true },
                publishDate: "2022-02-22T08:07:45Z",
                description: {
                  value:
                    '本網站 (<a href="https://www.fwd.com.hk/products">https://fwd.com.hk/products</a>) 由富衛金融有限公司營運。富衛金融有限公司乃富衛人壽保險（百慕達）有限公司及富衛保險有限公司的委任持牌保險代理。\n<div id="gtx-trans" style="position: absolute; left: 35px; top: 21px;">\n<div class="gtx-trans-icon">&nbsp;</div>\n</div>',
                },
                expiryDate: "2030-02-22T00:00:00Z",
                pagesList: { value: "/products/" },
              },
              {
                hidePublishDate: { value: true },
                publishDate: "2022-02-22T08:07:45Z",
                description: {
                  value:
                    '本網站 (<a href="https://www.fwd.com.hk/support">https://fwd.com.hk/support</a>) 由富衛金融有限公司營運。富衛金融有限公司乃富衛人壽保險（百慕達）有限公司及富衛保險有限公司的委任持牌保險代理。',
                },
                expiryDate: "2030-02-22T00:00:00Z",
                pagesList: { value: "https://www.fwd.com.hk/support/" },
              },
              {
                hidePublishDate: { value: true },
                publishDate: "2022-02-24T03:04:00Z",
                description: {
                  value:
                    "本網站 (https://fwd.com.hk) 由富衛人壽保險（百慕達）有限公司營運。",
                },
                expiryDate: "2025-11-30T11:36:00Z",
                pagesList: { value: "/, /business/" },
                icon: {
                  id: "c4ce9c6d-80fa-402f-9b49-87c412a21684",
                  fieldType: "CustomDroplink",
                  fieldName: "icon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/alert---obsolete",
                  fields: {
                    value: { value: "alert" },
                    key: { value: "alert" },
                  },
                },
              },
            ],
          },
          dialogModals: { modalList: [] },
          disclosurePopups: {
            popupList: [
              {
                title: { value: "風險披露聲明" },
                footerText: { value: "" },
                text: {
                  value:
                    '<p style="text-align: center;">（只適用於投資相連壽險計劃）\n</p>\n<ul>\n    <li>此乃富衛人壽保險（百慕達）有限公司<span style="color: #183028;">( 在百慕達註冊成立的有限責任公司</span><span style="color: #183028;">)</span>（"富衛"）發行之投資相連壽險計劃（"ILAS"）的投資選擇。 閣下之投資需承受富衛之信貸風險。<br />\n    <br />\n    </li>\n    <li>雖然閣下的<span style="color: #183028;">ILAS</span><span style="color: #183028;">是一份人壽保單，因身故權益與閣下不時所選擇的投資選擇表現掛鈎，閣下的身故權益須承受投資風險與市場波動。應付的身故權益可能顯著少於閣下已支付的保費，並且可能不足以滿足閣下的個人需求。</span></li>\n</ul>\n<ul>\n    <li><span style="color: #183028;">閣下就</span><span style="color: #183028;">ILAS</span><span style="color: #183028;">支付的保費</span>，<span style="color: #183028;">及任何由富衛按閣下選擇的投資選擇進行投資的相關基金，將成為</span>及留為<span style="color: #183028;">富衛資產的一部分。閣下對任何該等資產均沒有任何權利或擁有權。若追討賠償，閣下只可向富衛追索。</span></li>\n</ul>\n<ul>\n    <li>閣下所支付的保費將會由富衛按閣下所選擇的投資選擇，投資於投資選擇相對應的相關基金當中，以讓富衛進行資產負債管理。而分配給閣下保單戶口内的單位只是名義上的分配，目的只是用來釐定閣下保單内的戶口價值及權益。</li>\n</ul>\n<ul>\n    <li>閣下之投資回報是由富衛參照相關基金的的表現來計算。並且閣下的回報須持續支付收費及費用，並將從<span style="color: #183028;">ILAS</span><span style="color: #183028;">中扣除，因此回報或會低於相對應之相關基金的回報。各相關基金均有其各自的投資概況及相關風險。可供選擇的投資選擇相對應的相關基金均載列於投資選擇刊物內。這些相關基金是由證監會依據《單位信託及互惠基金守則》作出認可。請注意，證監會認可不等如對該產品作出推介或認許，亦不是對該產品的商業利弊或表現作出保證，更不代表該產品適合所有投資者，或認許該產品適合任何個別投資者或任何類別的投資者。</span></li>\n</ul>\n<ul>\n    <li>若提前終止、退保或於<span style="color: #183028;">ILAS</span><span style="color: #183028;">的戶口價值作部分提款</span>，<span style="color: #183028;">閣下的投資、已支付的本金及可收取的獎賞（如有）可能會蒙受重大損失。若相關基金表現欠佳，閣下所蒙受的投資虧損或會進一步擴大，而一切收費仍可被扣除。除此之外，根據美國的《外國帳戶稅收合規法》，若閣下的保單是由一家非參與的外國金融機構的公司持有，富衛可能終止閣下的</span><span style="color: #183028;">ILAS</span><span style="color: #183028;">。</span><span style="color: #183028;"></span></li>\n</ul>\n<ul>\n    <li><span style="color: #183028;">ILAS 所提供的各個投資選擇在產品特點及風險狀況或會有很大差異，部份投資選擇可能涉及高風險。部分投資選擇相對應的相關基金是衍生工具風險承擔淨額超逾其淨資產價值的50%的衍生產品基金。它可能只適合了解衍生產品複雜結構和相關風險的投資者。如果投資這些投資選擇，閣下可能會蒙受重大損失。懇請閣下謹慎選擇此投資選擇。</span><br />\n    <br />\n    </li>\n    <li>投資的決定是屬於閣下的，除非閣下已明白及獲解釋本產品適合閣下，否則閣下不應購買本產品。</li>\n</ul>\n<ul>\n    <li>投資選擇名字尾部標示有(「分派」) (統稱為「投資選擇(現金分派)」)連繫到相關基金旨在定期派息的股份類別。投資選擇(現金分派)可能會派發現金派息。若閣下選擇投資於此等投資選擇，若富衛從投資選擇的相關基金收取到相關的派息，閣下將獲現金派息。請注意:</li>\n</ul>\n<ol style="list-style-type: lower-roman; margin-left: 40px;">\n    <li><span>個別投資選擇</span><span>(</span><span>現金分派</span><span>)</span><span>相對應的相關基金可在其</span><span style="background: white; color: #1c1c1c;">酌情決定下從相關基金資本作出派息</span> <span>(</span><span>即是，獲總收入同時從<span style="background-color: #ffffff; color: #1c1c1c;">相關</span>基金的資本中收取</span><span>/</span><span>支付<span style="background-color: #ffffff; color: #1c1c1c;">相關基金</span>所有或部分費用及開支，從而導致<span style="background-color: #ffffff; color: #1c1c1c;">相關</span>基金用作派付的派息的可分派收入增加</span><span>。</span><span>)</span></li>\n    <li><span>相對應的相關基金從資本中</span><span style="background: white; color: #1c1c1c;">撥付派息，代表將投資者原投資金額或原投資金額應佔的任何資本收益部分退回或提取。</span></li>\n    <li><span>任何分派涉及從資本中撥付派息，將導致相關基金的每單位的淨資產價值即時減低，此舉會對投資選擇</span><span>(</span><span>現金分派</span><span>)</span><span>的價格有負面影響。這會導致閣下保單的戶口價值減低。在此情況下，身故權益、退保權益及期滿權益將會減少。</span></li>\n    <li><span>投資選擇</span><span>(</span><span>現金分派</span><span>)</span><span>相對應的相關基金並不保證</span><span>會派發現金派息或派發定額現金派息或定期派發現金派息。獲派發現金派息的金額並不能作為</span><span>未來將會派發的現金派息的</span><span>指標</span><span>、預測或推測</span><span>。</span></li>\n</ol>\n<p><strong><span style="color: #183028;">投資涉及風險，閣下應該細閱</span></strong><strong><span style="color: #183028;"> ILAS</span></strong><strong><span style="color: #183028;">及相關基金的銷售文件<strong>。</strong></span></strong></p>\n<p><strong>投資涉及風險。基金往績不應視作未來業績表現的指標。閣下不應只根據此資料而投資。有關 ILAS 之詳情及其風險因素，請參閱主要銷售文件。</strong></p>\n<p><strong>\n<br />\n發行人<br />\n富衛人壽保險（百慕達）有限公司</strong><strong><span style="color: #183028;">( 在百慕達註冊成立的有限責任公司</span></strong><strong><span style="color: #183028;">)</span></strong></p>\n<div><strong>&nbsp;</strong></div>',
                },
                sticky: { value: true },
                activeAtEndOfScroll: { value: true },
                isRiskDisclosure: { value: true },
                defaultPageLink: {
                  value: {
                    href: "/products/",
                    text: "",
                    anchor: "",
                    linktype: "internal",
                    class: "",
                    title: "",
                    querystring: "",
                    id: "{DB3FF0BC-2E10-4735-8BAA-76A87A906821}",
                  },
                },
                sessionTimeout: { value: "1" },
                enableSmallView: { value: false },
                frequency: {
                  id: "8342b7fa-a8ba-4fd5-b7ca-fea9248e4f42",
                  fieldType: "Droplink",
                  fieldName: "frequency",
                  url: "/sitecore/content/fwd/global/settings/list/disclosure-frequency-type/once-in-browsing-session",
                  fields: {
                    value: { value: "Once in browsing session" },
                    key: { value: "once-in-browsing-session" },
                  },
                },
                buttonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "buttonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                link: {
                  value: {
                    href: "/products/invest/",
                    text: "我已閱讀、了解及接受以上資訊。",
                    anchor: "",
                    linktype: "internal",
                    class: "",
                    title: "",
                    target: "",
                    querystring: "",
                    id: "{2375DA5B-104B-4B0C-A915-78223732320F}",
                  },
                },
                buttonMode: {
                  id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                  fieldType: "Droplink",
                  fieldName: "buttonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
                  fields: {
                    value: { value: "Primary" },
                    key: { value: "Primary" },
                  },
                },
                linkGALabelName: { value: "" },
                closeCTALabel: { value: "" },
                isCloseCTA: { value: false },
                secondaryLinkButtonMode: {
                  id: "b096e18e-daae-43a8-87dd-1775ad1f16b6",
                  fieldType: "Droplink",
                  fieldName: "secondaryLinkButtonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/secondary",
                  fields: {
                    value: { value: "Secondary" },
                    key: { value: "Secondary" },
                  },
                },
                secondaryLinkGALabelName: { value: "" },
                secondaryLink: { value: {} },
                secondaryLinkButtonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "secondaryLinkButtonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                secondaryCloseCTALabel: { value: "我不想繼續。" },
                isSecondaryCloseCTA: { value: true },
                FormParameters: { value: {} },
                IsFormPost: { value: false },
                id: "a502d7b5-56e5-49ee-af75-d767bb290981",
              },
              {
                title: { value: "" },
                footerText: { value: "" },
                text: {
                  value:
                    "富衛所分銷之強積金產品現由永明金融提供，您將被轉至相關強積金計劃的行政管理人網頁，以查閱您的強積金帳戶。",
                },
                sticky: { value: true },
                activeAtEndOfScroll: { value: true },
                isRiskDisclosure: { value: false },
                defaultPageLink: {
                  value: {
                    href: "/",
                    text: "",
                    anchor: "",
                    linktype: "internal",
                    class: "",
                    title: "",
                    querystring: "",
                    id: "{9CB72689-FA18-4900-B876-3AE397D3B009}",
                  },
                },
                sessionTimeout: { value: "10" },
                enableSmallView: { value: false },
                frequency: {
                  id: "8342b7fa-a8ba-4fd5-b7ca-fea9248e4f42",
                  fieldType: "Droplink",
                  fieldName: "frequency",
                  url: "/sitecore/content/fwd/global/settings/list/disclosure-frequency-type/once-in-browsing-session",
                  fields: {
                    value: { value: "Once in browsing session" },
                    key: { value: "once-in-browsing-session" },
                  },
                },
                buttonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "buttonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                link: {
                  value: {
                    href: "/products/invest/orso/",
                    text: "前往",
                    anchor: "",
                    linktype: "internal",
                    class: "",
                    title: "",
                    querystring: "",
                    id: "{1350A039-E306-4354-B38B-5BFB085DEC5A}",
                  },
                },
                buttonMode: {
                  id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                  fieldType: "Droplink",
                  fieldName: "buttonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
                  fields: {
                    value: { value: "Primary" },
                    key: { value: "Primary" },
                  },
                },
                linkGALabelName: { value: "" },
                closeCTALabel: { value: "" },
                isCloseCTA: { value: false },
                secondaryLinkButtonMode: {
                  id: "b096e18e-daae-43a8-87dd-1775ad1f16b6",
                  fieldType: "Droplink",
                  fieldName: "secondaryLinkButtonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/secondary",
                  fields: {
                    value: { value: "Secondary" },
                    key: { value: "Secondary" },
                  },
                },
                secondaryLinkGALabelName: { value: "" },
                secondaryLink: { value: {} },
                secondaryLinkButtonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "secondaryLinkButtonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                secondaryCloseCTALabel: { value: "" },
                isSecondaryCloseCTA: { value: false },
                FormParameters: { value: {} },
                IsFormPost: { value: false },
                id: "d6037e42-3522-4edd-8cd8-f814f3528e6b",
              },
              {
                title: { value: "" },
                footerText: { value: "" },
                text: {
                  value:
                    "<p>富衛與永明金融之香港退休保障服務分銷協議正式生效：</p>\n<p>由2017年10月3日起，富衛強積金計劃的保薦人改為香港永明金融有限公司（「永明金融」），故富衛強積金集成信託基本／綜合計劃亦改變為永明強積金基本／綜合計劃。</p>\n<p>富衛人壽保險（百慕達）有限公司（「富衛」）和永明金融雙方亦達成了為期15年的策略分銷協議，富衛的專屬代理人將可於香港分銷永明金融的強積金產品。</p>\n<p>如需更多有關永明金融強積金資料，請按「前往」瀏覽香港永明金融網站主頁及客戶服務專區，並登入網上退休金服務中心。如欲查詢相關強積金計劃，請致電 (852) 3183 1900。</p>\n<p>本網站所述之投資或不適合所有投資者。本網站提供的資料只供參考用途，並不構成任何投資建議。投資者應在作出任何投資決策之前尋求獨立意見。</p>\n<p>投資涉及風險，投資者或無法取回最初投資之金額。過往表現未必可作日後業績的準則。請詳細閱讀有關銷售文件，特別是基金特色及所涉及的風險。</p>\n<p>富衛受證監會監管。非香港居民在瀏灠本網頁所載資料前，有責任依循其所屬司法範圍的一切適用法例及規定。</p>\n<div>&nbsp;</div>",
                },
                sticky: { value: true },
                activeAtEndOfScroll: { value: true },
                isRiskDisclosure: { value: false },
                defaultPageLink: {
                  value: {
                    href: "/products/invest/orso/",
                    text: "",
                    anchor: "",
                    linktype: "internal",
                    class: "",
                    title: "",
                    target: "",
                    querystring: "",
                    id: "{1350A039-E306-4354-B38B-5BFB085DEC5A}",
                  },
                },
                sessionTimeout: { value: "10" },
                enableSmallView: { value: false },
                frequency: {
                  id: "0585858d-6024-4df6-a556-08bc04932510",
                  fieldType: "Droplink",
                  fieldName: "frequency",
                  url: "/sitecore/content/fwd/global/settings/list/disclosure-frequency-type/every-time-user-land-on-identified-page",
                  fields: {
                    value: {
                      value: "Every time user land on the identified page",
                    },
                    key: { value: "every-time-in-session" },
                  },
                },
                buttonIcon: null,
                link: {
                  value: {
                    href: "https://www.sunlife.com.hk/zh-hant/investments/mpf-orso-fund-prices-performance/?vgnLocale=zh_TW",
                    text: "前往",
                    linktype: "external",
                    url: "https://www.sunlife.com.hk/zh-hant/investments/mpf-orso-fund-prices-performance/?vgnLocale=zh_TW",
                    anchor: "",
                    target: "_blank",
                  },
                },
                buttonMode: {
                  id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                  fieldType: "Droplink",
                  fieldName: "buttonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
                  fields: {
                    value: { value: "Primary" },
                    key: { value: "Primary" },
                  },
                },
                linkGALabelName: { value: "" },
                closeCTALabel: { value: "" },
                isCloseCTA: { value: false },
                secondaryLinkButtonMode: {
                  id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                  fieldType: "Droplink",
                  fieldName: "secondaryLinkButtonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
                  fields: {
                    value: { value: "Primary" },
                    key: { value: "Primary" },
                  },
                },
                secondaryLinkGALabelName: { value: "" },
                secondaryLink: {
                  value: {
                    href: "/products/invest/orso/",
                    text: "關閉",
                    anchor: "",
                    linktype: "internal",
                    class: "",
                    title: "",
                    target: "",
                    querystring: "",
                    id: "{1350A039-E306-4354-B38B-5BFB085DEC5A}",
                  },
                },
                secondaryLinkButtonIcon: null,
                secondaryCloseCTALabel: { value: "" },
                isSecondaryCloseCTA: { value: true },
                FormParameters: { value: {} },
                IsFormPost: { value: false },
                id: "6907d3f8-481b-419c-b333-a1a0f654b773",
              },
              {
                title: { value: "" },
                footerText: { value: "" },
                text: {
                  value:
                    "<p><strong>重要</strong></p>\n<ul>\n    <li>富衛綜合公積金計劃（「本計劃」）是由富衛人壽保險(百慕達)有限公司 (「富衛人壽」）發出的保單所成立的集資退休計劃。</li>\n    <li>富衛本金保證基金的保證乃由富衛人壽所提供。因此，閣下於富衛本金保證基金的投資受富衛人壽的信用風險所影響。保證受本說明書附錄一所載有關富衛本金保證基金的限制性條件所管限。</li>\n    <li>計劃的各管理基金將投資於相應的項下基金。該等項下基金可能投資於具有不同風險概況的股票、債務證券及／或金融衍生工具（視情況而定）。</li>\n    <li>投資於新興市場的項下基金可能須承受較高的流通性及波動性風險。與依從更多元化投資政策的基金相比，投資於特定市場或行業的項下基金可能須承受較高的集中性風險。</li>\n    <li>與投資於較高信貸評級的債務證券的基金相比，投資於低評級或非投資級別的債務證券的項下基金或須承受較高的信貸及交易對手風險。</li>\n    <li>主要投資於金融衍生工具的項下基金可能須承受重大的流通性及交易對手違約風險，因此，項下基金可能出現重大損失。</li>\n    <li>計劃以保單形式組成。計劃的利益款項乃參考投資選項的表現計算，閣下並非投資於相關投資基金／資產，亦不會就相關投資基金／資產擁有任何權利或擁有權。有關相關投資基金／資產乃由富衛人壽合法擁有。閣下只擁有合約權利以向富衛人壽申索計劃項下利益的金額。閣下於計劃的投資因而須承受富衛人壽的信用風險。</li>\n    <li>閣下在作出任何投資選擇前，應考慮閣下本身的風險承受程度及財政狀況。如閣下對管理基金是否適合閣下（包括與閣下的投資目標是否一致）存有任何疑問，應諮詢獨立財務及╱或專業意見。</li>\n    <li>您不應僅倚賴此網站而作出投資。閣下應參閱本說明書以了解包括產品特點、費用及收費以及風險因素等有關進一步詳情（載列於第3節「投資風險及風險因素」）。</li>\n</ul>\n<p><strong>重要事項</strong>︰</p>\n<ul>\n    <li>本計劃已獲證劵及期貨事務監察委員會認可。有關認可並不意味著獲得證監會官方推介。</li>\n    <li>投資涉及風險；所呈列的過往表現資料不應視爲未來回報指標。本計劃內的每一項投資選擇不一定適合任何所有人士。投資回報並無擔保，而您的投資/累算權益或會承受重大損失。</li>\n    <li>有關本計劃和各基金的特點，請參閱本計劃的說明書。投資選擇或須承受的某些風險論述如下。有關項下基金的投資目標、政策、策略及風險，請參閱投資選擇相應的項下基金的最新銷售文件。如您對說明書及個别基金的銷售文件的內容的含義或影響有任何疑問，您應徵詢專業人士的意見。</li>\n</ul>\n<p>由富衛人壽保險（百慕達）有限公司發出。</p>\n<p><strong>重要資料</strong></p>\n<p>請細心閱讀下文後按 同意 ，以便繼續瀏覽網頁。</p>\n<p>本網站內包含的資料依其「現況」或「可利用之狀況」提取。本公司對上述資料及內容之充足性不予保證。關於上述資料本公司並不作出任何種類之暗示、明示或法律上保証，包括但不限於著作權、茲有權、可商售權、對開特定用途的適用權以及無電腦病毒等保証。</p>\n<p>本網站資料更新至刊載日期，如有更改將不會另行通知。</p>\n<p>獲強積金管理局和證券及期貨事務監察委員會註冊、核准或認可，並不意味官方推介。</p>\n<p>投資附帶風險，基金價格可跌可升。過往表現不應視為未來回報指標。詳情請參閱有關銷售說明書。</p>",
                },
                sticky: { value: true },
                activeAtEndOfScroll: { value: false },
                isRiskDisclosure: { value: false },
                defaultPageLink: {
                  value: {
                    href: "/products/invest/orso/",
                    text: "",
                    anchor: "",
                    linktype: "internal",
                    class: "",
                    title: "",
                    querystring: "",
                    id: "{1350A039-E306-4354-B38B-5BFB085DEC5A}",
                  },
                },
                sessionTimeout: { value: "2" },
                enableSmallView: { value: false },
                frequency: {
                  id: "0585858d-6024-4df6-a556-08bc04932510",
                  fieldType: "Droplink",
                  fieldName: "frequency",
                  url: "/sitecore/content/fwd/global/settings/list/disclosure-frequency-type/every-time-user-land-on-identified-page",
                  fields: {
                    value: {
                      value: "Every time user land on the identified page",
                    },
                    key: { value: "every-time-in-session" },
                  },
                },
                buttonIcon: null,
                link: {
                  value: {
                    href: "/products/invest/orso/fund-performance/",
                    text: "同意",
                    anchor: "",
                    linktype: "internal",
                    class: "",
                    title: "",
                    querystring: "",
                    id: "{08204FFD-2104-462A-9271-72552A3B5491}",
                  },
                },
                buttonMode: {
                  id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                  fieldType: "Droplink",
                  fieldName: "buttonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
                  fields: {
                    value: { value: "Primary" },
                    key: { value: "Primary" },
                  },
                },
                linkGALabelName: { value: "" },
                closeCTALabel: { value: "" },
                isCloseCTA: { value: false },
                secondaryLinkButtonMode: {
                  id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                  fieldType: "Droplink",
                  fieldName: "secondaryLinkButtonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
                  fields: {
                    value: { value: "Primary" },
                    key: { value: "Primary" },
                  },
                },
                secondaryLinkGALabelName: { value: "" },
                secondaryLink: {
                  value: {
                    href: "/products/invest/orso/",
                    text: "不同意",
                    anchor: "",
                    linktype: "internal",
                    class: "",
                    title: "",
                    querystring: "",
                    id: "{1350A039-E306-4354-B38B-5BFB085DEC5A}",
                  },
                },
                secondaryLinkButtonIcon: null,
                secondaryCloseCTALabel: { value: "" },
                isSecondaryCloseCTA: { value: true },
                FormParameters: { value: {} },
                IsFormPost: { value: false },
                id: "a87c6d76-dac0-4e31-b731-fd439a9d247b",
              },
              {
                title: { value: "閣下即將離開本網站" },
                footerText: { value: "" },
                text: {
                  value:
                    '<p>此超連結將連接至由第三方經營之網站。<br />\n<br />\n富衛人壽保險(百慕達) 有限公司 (於百慕達註冊成立之有限公司)(「富衛人壽」）不會就第三方網站之內容、產品、服務或資訊給予任何明示或暗示的批准、認可、保證及陳述，亦不會為該網站所包含之內容承擔任何責任。富衛人壽並不會就閣下因接入連結所引致或產生之損害或損失承擔任何責任。<br />\n<br />\n本人確認本人已參閱、明白及接受富衛人壽的<a rel="noopener noreferrer" href="https://www.fwd.com.hk/privacy-policy/fwd-life-insurance-company/" target="_blank">收集個人資料聲明</a>，並同意接受其約束。<br />\n<br />\n謹提示閣下當按下連結及進入第三方網站時，閣下將受所瀏覽之第三方網站的使用條款及私隱政策所約束。</p>\n<div>&nbsp;</div>\n<br />',
                },
                sticky: { value: true },
                activeAtEndOfScroll: { value: false },
                isRiskDisclosure: { value: false },
                defaultPageLink: { value: {} },
                sessionTimeout: { value: "" },
                enableSmallView: { value: false },
                frequency: {
                  id: "0585858d-6024-4df6-a556-08bc04932510",
                  fieldType: "Droplink",
                  fieldName: "frequency",
                  url: "/sitecore/content/fwd/global/settings/list/disclosure-frequency-type/every-time-user-land-on-identified-page",
                  fields: {
                    value: {
                      value: "Every time user land on the identified page",
                    },
                    key: { value: "every-time-in-session" },
                  },
                },
                buttonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "buttonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                link: {
                  value: {
                    href: "https://wa.me/85265320781",
                    text: "確認並繼續",
                    linktype: "external",
                    url: "https://wa.me/85265320781",
                    anchor: "",
                    target: "",
                  },
                },
                buttonMode: {
                  id: "02a5a5c7-c318-4919-b773-86a65ba98969",
                  fieldType: "Droplink",
                  fieldName: "buttonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/simple-link",
                  fields: {
                    value: { value: "SimpleLink" },
                    key: { value: "SimpleLink" },
                  },
                },
                linkGALabelName: { value: "" },
                closeCTALabel: { value: "" },
                isCloseCTA: { value: false },
                secondaryLinkButtonMode: {
                  id: "b096e18e-daae-43a8-87dd-1775ad1f16b6",
                  fieldType: "Droplink",
                  fieldName: "secondaryLinkButtonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/secondary",
                  fields: {
                    value: { value: "Secondary" },
                    key: { value: "Secondary" },
                  },
                },
                secondaryLinkGALabelName: { value: "" },
                secondaryLink: { value: {} },
                secondaryLinkButtonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "secondaryLinkButtonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                secondaryCloseCTALabel: { value: "返回" },
                isSecondaryCloseCTA: { value: true },
                FormParameters: { value: {} },
                IsFormPost: { value: false },
                id: "9393cb81-8d91-4cda-a494-70ab242c70a4",
              },
              {
                title: {
                  value: "正在前往富衛一般保險 (Bolttech集團成員) 網站",
                },
                footerText: { value: "" },
                text: {
                  value:
                    "此導向本身不構成富衛人壽保險(百慕達) 有限公司 (於百慕達註冊成立之有限公司)(「富衛人壽」）對富衛一般保險或其超連結之內容、產品、服務或其中包含或可用的資訊給予任何明示或暗示的批准、認可、保證及陳述。富衛人壽對連結之富衛一般保險網站所包含之內容並不負任何責任及不會就任何由於閣下接入連結所引致或產生之損害或損失負上任何責任。",
                },
                sticky: { value: true },
                activeAtEndOfScroll: { value: true },
                isRiskDisclosure: { value: true },
                defaultPageLink: {
                  value: {
                    href: "/fwd/fwd-hk/Home/Products/car-boat/motor-smart-plus",
                    linktype: "external",
                    url: "/fwd/fwd-hk/Home/Products/car-boat/motor-smart-plus",
                    anchor: "",
                    target: "",
                  },
                },
                sessionTimeout: { value: "1" },
                enableSmallView: { value: false },
                frequency: {
                  id: "0585858d-6024-4df6-a556-08bc04932510",
                  fieldType: "Droplink",
                  fieldName: "frequency",
                  url: "/sitecore/content/fwd/global/settings/list/disclosure-frequency-type/every-time-user-land-on-identified-page",
                  fields: {
                    value: {
                      value: "Every time user land on the identified page",
                    },
                    key: { value: "every-time-in-session" },
                  },
                },
                buttonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "buttonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                link: {
                  value: {
                    href: "https://www.fwdgi.hk/car-insurance?pc=FMSPO10&utm_source=ifwd&utm_medium=referral&utm_content=buynowbutton",
                    text: "同意並繼續",
                    linktype: "external",
                    url: "https://www.fwdgi.hk/car-insurance?pc=FMSPO10&utm_source=ifwd&utm_medium=referral&utm_content=buynowbutton",
                    anchor: "",
                    target: "",
                  },
                },
                buttonMode: {
                  id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                  fieldType: "Droplink",
                  fieldName: "buttonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
                  fields: {
                    value: { value: "Primary" },
                    key: { value: "Primary" },
                  },
                },
                linkGALabelName: { value: "" },
                closeCTALabel: { value: "" },
                isCloseCTA: { value: false },
                secondaryLinkButtonMode: {
                  id: "b096e18e-daae-43a8-87dd-1775ad1f16b6",
                  fieldType: "Droplink",
                  fieldName: "secondaryLinkButtonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/secondary",
                  fields: {
                    value: { value: "Secondary" },
                    key: { value: "Secondary" },
                  },
                },
                secondaryLinkGALabelName: { value: "" },
                secondaryLink: { value: {} },
                secondaryLinkButtonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "secondaryLinkButtonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                secondaryCloseCTALabel: { value: "" },
                isSecondaryCloseCTA: { value: false },
                FormParameters: { value: {} },
                IsFormPost: { value: false },
                id: "5ff33e21-1230-4247-8dfe-ae59221944fa",
              },
              {
                title: {
                  value: "正在前往富衛一般保險 (Bolttech集團成員) 網站",
                },
                footerText: { value: "" },
                text: {
                  value:
                    "此導向本身不構成富衛人壽保險(百慕達) 有限公司 (於百慕達註冊成立之有限公司)(「富衛人壽」）對富衛一般保險或其超連結之內容、產品、服務或其中包含或可用的資訊給予任何明示或暗示的批准、認可、保證及陳述。富衛人壽對連結之富衛一般保險網站所包含之內容並不負任何責任及不會就任何由於閣下接入連結所引致或產生之損害或損失負上任何責任。",
                },
                sticky: { value: true },
                activeAtEndOfScroll: { value: true },
                isRiskDisclosure: { value: true },
                defaultPageLink: {
                  value: {
                    href: "/fwd/fwd-hk/Home/Products/helper/helper-care-insurance",
                    linktype: "external",
                    url: "/fwd/fwd-hk/Home/Products/helper/helper-care-insurance",
                    anchor: "",
                    target: "",
                  },
                },
                sessionTimeout: { value: "1" },
                enableSmallView: { value: false },
                frequency: {
                  id: "0585858d-6024-4df6-a556-08bc04932510",
                  fieldType: "Droplink",
                  fieldName: "frequency",
                  url: "/sitecore/content/fwd/global/settings/list/disclosure-frequency-type/every-time-user-land-on-identified-page",
                  fields: {
                    value: {
                      value: "Every time user land on the identified page",
                    },
                    key: { value: "every-time-in-session" },
                  },
                },
                buttonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "buttonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                link: {
                  value: {
                    href: "https://www.fwdgi.hk/domestic-helper-insurance?utm_source=ifwd&utm_content=buynowbutton&pc=HELPER10",
                    text: "同意並繼續",
                    linktype: "external",
                    url: "https://www.fwdgi.hk/domestic-helper-insurance?utm_source=ifwd&utm_content=buynowbutton&pc=HELPER10",
                    anchor: "",
                    target: "",
                  },
                },
                buttonMode: {
                  id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                  fieldType: "Droplink",
                  fieldName: "buttonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
                  fields: {
                    value: { value: "Primary" },
                    key: { value: "Primary" },
                  },
                },
                linkGALabelName: { value: "" },
                closeCTALabel: { value: "" },
                isCloseCTA: { value: false },
                secondaryLinkButtonMode: {
                  id: "b096e18e-daae-43a8-87dd-1775ad1f16b6",
                  fieldType: "Droplink",
                  fieldName: "secondaryLinkButtonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/secondary",
                  fields: {
                    value: { value: "Secondary" },
                    key: { value: "Secondary" },
                  },
                },
                secondaryLinkGALabelName: { value: "" },
                secondaryLink: { value: {} },
                secondaryLinkButtonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "secondaryLinkButtonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                secondaryCloseCTALabel: { value: "" },
                isSecondaryCloseCTA: { value: false },
                FormParameters: { value: {} },
                IsFormPost: { value: false },
                id: "0a84b12a-2810-414e-a01c-ffc8f28b71c0",
              },
              {
                title: {
                  value: "正在前往富衛一般保險 (Bolttech集團成員) 網站",
                },
                footerText: { value: "" },
                text: {
                  value:
                    "此導向本身不構成富衛人壽保險(百慕達) 有限公司 (於百慕達註冊成立之有限公司)(「富衛人壽」）對富衛一般保險或其超連結之內容、產品、服務或其中包含或可用的資訊給予任何明示或暗示的批准、認可、保證及陳述。富衛人壽對連結之富衛一般保險網站所包含之內容並不負任何責任及不會就任何由於閣下接入連結所引致或產生之損害或損失負上任何責任。",
                },
                sticky: { value: true },
                activeAtEndOfScroll: { value: true },
                isRiskDisclosure: { value: true },
                defaultPageLink: {
                  value: {
                    href: "/fwd/fwd-hk/Home/Products/household-pets/home-care-insurance/",
                    linktype: "external",
                    url: "/fwd/fwd-hk/Home/Products/household-pets/home-care-insurance/",
                    anchor: "",
                    target: "",
                  },
                },
                sessionTimeout: { value: "1" },
                enableSmallView: { value: false },
                frequency: {
                  id: "0585858d-6024-4df6-a556-08bc04932510",
                  fieldType: "Droplink",
                  fieldName: "frequency",
                  url: "/sitecore/content/fwd/global/settings/list/disclosure-frequency-type/every-time-user-land-on-identified-page",
                  fields: {
                    value: {
                      value: "Every time user land on the identified page",
                    },
                    key: { value: "every-time-in-session" },
                  },
                },
                buttonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "buttonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                link: {
                  value: {
                    href: "https://www.fwdgi.hk/home-care-insurance?utm_source=ifwd&utm_content=buynowbutton&pc=HOMEC10",
                    text: "同意並繼續",
                    linktype: "external",
                    url: "https://www.fwdgi.hk/home-care-insurance?utm_source=ifwd&utm_content=buynowbutton&pc=HOMEC10",
                    anchor: "",
                    target: "",
                  },
                },
                buttonMode: {
                  id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                  fieldType: "Droplink",
                  fieldName: "buttonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
                  fields: {
                    value: { value: "Primary" },
                    key: { value: "Primary" },
                  },
                },
                linkGALabelName: { value: "" },
                closeCTALabel: { value: "" },
                isCloseCTA: { value: false },
                secondaryLinkButtonMode: {
                  id: "b096e18e-daae-43a8-87dd-1775ad1f16b6",
                  fieldType: "Droplink",
                  fieldName: "secondaryLinkButtonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/secondary",
                  fields: {
                    value: { value: "Secondary" },
                    key: { value: "Secondary" },
                  },
                },
                secondaryLinkGALabelName: { value: "" },
                secondaryLink: { value: {} },
                secondaryLinkButtonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "secondaryLinkButtonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                secondaryCloseCTALabel: { value: "" },
                isSecondaryCloseCTA: { value: false },
                FormParameters: { value: {} },
                IsFormPost: { value: false },
                id: "1af378f3-ec18-4f13-90aa-37c28070087d",
              },
              {
                title: {
                  value: "正在前往富衛一般保險 (Bolttech集團成員) 網站",
                },
                footerText: { value: "" },
                text: {
                  value:
                    "此導向本身不構成富衛人壽保險(百慕達) 有限公司 (於百慕達註冊成立之有限公司)(「富衛人壽」）對富衛一般保險或其超連結之內容、產品、服務或其中包含或可用的資訊給予任何明示或暗示的批准、認可、保證及陳述。富衛人壽對連結之富衛一般保險網站所包含之內容並不負任何責任及不會就任何由於閣下接入連結所引致或產生之損害或損失負上任何責任。",
                },
                sticky: { value: true },
                activeAtEndOfScroll: { value: true },
                isRiskDisclosure: { value: true },
                defaultPageLink: {
                  value: {
                    href: "/products/household-pets/easy-home-care/",
                    text: "",
                    anchor: "",
                    linktype: "internal",
                    class: "",
                    title: "",
                    target: "",
                    querystring: "",
                    id: "{4C2582F3-9667-4957-B3F9-53C8056EBA7F}",
                  },
                },
                sessionTimeout: { value: "1" },
                enableSmallView: { value: false },
                frequency: {
                  id: "0585858d-6024-4df6-a556-08bc04932510",
                  fieldType: "Droplink",
                  fieldName: "frequency",
                  url: "/sitecore/content/fwd/global/settings/list/disclosure-frequency-type/every-time-user-land-on-identified-page",
                  fields: {
                    value: {
                      value: "Every time user land on the identified page",
                    },
                    key: { value: "every-time-in-session" },
                  },
                },
                buttonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "buttonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                link: {
                  value: {
                    href: "https://www.fwdgi.hk/easy-home-insurance?utm_source=ifwd&pc=EHOME10",
                    text: "同意並繼續",
                    linktype: "external",
                    url: "https://www.fwdgi.hk/easy-home-insurance?utm_source=ifwd&pc=EHOME10",
                    anchor: "",
                    target: "",
                  },
                },
                buttonMode: {
                  id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                  fieldType: "Droplink",
                  fieldName: "buttonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
                  fields: {
                    value: { value: "Primary" },
                    key: { value: "Primary" },
                  },
                },
                linkGALabelName: { value: "" },
                closeCTALabel: { value: "" },
                isCloseCTA: { value: false },
                secondaryLinkButtonMode: {
                  id: "b096e18e-daae-43a8-87dd-1775ad1f16b6",
                  fieldType: "Droplink",
                  fieldName: "secondaryLinkButtonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/secondary",
                  fields: {
                    value: { value: "Secondary" },
                    key: { value: "Secondary" },
                  },
                },
                secondaryLinkGALabelName: { value: "" },
                secondaryLink: { value: {} },
                secondaryLinkButtonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "secondaryLinkButtonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                secondaryCloseCTALabel: { value: "" },
                isSecondaryCloseCTA: { value: false },
                FormParameters: { value: {} },
                IsFormPost: { value: false },
                id: "81e0fce7-b5ed-4ff2-959a-d1ef9a1d1fd9",
              },
              {
                title: {
                  value: "正在前往富衛一般保險 (Bolttech集團成員) 網站",
                },
                footerText: { value: "" },
                text: {
                  value:
                    "此導向本身不構成富衛人壽保險(百慕達) 有限公司 (於百慕達註冊成立之有限公司)(「富衛人壽」）對富衛一般保險或其超連結之內容、產品、服務或其中包含或可用的資訊給予任何明示或暗示的批准、認可、保證及陳述。富衛人壽對連結之富衛一般保險網站所包含之內容並不負任何責任及不會就任何由於閣下接入連結所引致或產生之損害或損失負上任何責任。",
                },
                sticky: { value: true },
                activeAtEndOfScroll: { value: true },
                isRiskDisclosure: { value: true },
                defaultPageLink: {
                  value: {
                    href: "/products/travel-golf/travel-care-insurance/",
                    text: "",
                    anchor: "",
                    linktype: "internal",
                    class: "",
                    title: "",
                    target: "",
                    querystring: "",
                    id: "{42609B4A-3495-46CB-93CD-20B2BA82AABD}",
                  },
                },
                sessionTimeout: { value: "1" },
                enableSmallView: { value: false },
                frequency: {
                  id: "0585858d-6024-4df6-a556-08bc04932510",
                  fieldType: "Droplink",
                  fieldName: "frequency",
                  url: "/sitecore/content/fwd/global/settings/list/disclosure-frequency-type/every-time-user-land-on-identified-page",
                  fields: {
                    value: {
                      value: "Every time user land on the identified page",
                    },
                    key: { value: "every-time-in-session" },
                  },
                },
                buttonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "buttonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                link: {
                  value: {
                    href: "https://www.fwdgi.hk/travel-insurance?utm_source=ifwd&pc=TRAVEL30",
                    text: "同意並繼續",
                    linktype: "external",
                    url: "https://www.fwdgi.hk/travel-insurance?utm_source=ifwd&pc=TRAVEL30",
                    anchor: "",
                    target: "",
                  },
                },
                buttonMode: {
                  id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                  fieldType: "Droplink",
                  fieldName: "buttonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
                  fields: {
                    value: { value: "Primary" },
                    key: { value: "Primary" },
                  },
                },
                linkGALabelName: { value: "" },
                closeCTALabel: { value: "" },
                isCloseCTA: { value: false },
                secondaryLinkButtonMode: {
                  id: "b096e18e-daae-43a8-87dd-1775ad1f16b6",
                  fieldType: "Droplink",
                  fieldName: "secondaryLinkButtonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/secondary",
                  fields: {
                    value: { value: "Secondary" },
                    key: { value: "Secondary" },
                  },
                },
                secondaryLinkGALabelName: { value: "" },
                secondaryLink: { value: {} },
                secondaryLinkButtonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "secondaryLinkButtonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                secondaryCloseCTALabel: { value: "" },
                isSecondaryCloseCTA: { value: false },
                FormParameters: { value: {} },
                IsFormPost: { value: false },
                id: "70835a3d-3089-4cb4-9520-cb33336b4eac",
              },
            ],
          },
          localizedPages: [
            { "en-hk": "/en/forms-list/product-enquiry-form" },
            { "zh-Hant-hk": "/forms-list/product-enquiry-form" },
          ],
          isRequestFromExternalSource: false,
          availableLanguages: ["en", "tc"],
        },
        route: {
          name: "Product Enquiry Form",
          displayName: "Product Enquiry Form",
          fields: {
            apiList: [
              {
                id: "2334a4bf-d431-461f-b313-1dd10100c27e",
                fields: {
                  apiName: { value: "Email" },
                  value: {
                    value: "https://prd-api-www.fwd.com/api/v1/factors/send",
                  },
                  key: {
                    value:
                      "C9VX6X34b56tC2n2b67hlL5N97VoHguVy1mVnH65KgCm0MWVATlgx9Z453Zb0gE0HXpOzo0Z6ery6oRiNN28z34mBk",
                  },
                },
              },
            ],
            formEmailTemplate: {
              value: {
                text: "",
                linktype: "form",
                querystring: "",
                target: "",
                id: "{0BA99DDB-35CD-497C-B8F4-C07C15C42F07}",
                href: "/forms-list/product-enquiry-form/product-enquiry-form-template",
                apiKey: "{D7333054-1DCE-4B0C-A9A5-AC7372A796AB}",
                apiHost: 'https://www.fwd.com.hk'
              },
            },
            enableProductName: { value: true },
            gtmEventType: null,
            dynamicFormParams: { value: {} },
          },
          databaseName: "web",
          deviceId: "fe5d7fdf-89c0-4d99-9aa3-b5fbd009c9f3",
          itemId: "f2728281-fa5c-41cb-b168-773e0c78197f",
          itemLanguage: "zh-HK",
          itemVersion: 1,
          layoutId: "e60605a5-f4f9-479a-b992-741bce767b1d",
          templateId: "d48ab251-45a3-498a-a8c1-629e33a6b9b4",
          templateName: "Form",
          placeholders: {
            "jss-metadata": [],
            "jss-header": [],
            "jss-main": [
              {
                uid: "9e687e41-fa14-4810-a780-5b42b5322ae8",
                componentName: "Forms",
                dataSource: "{67232667-4C94-4762-9F36-D07F7A5FC6E7}",
                params: { formType: "conversational" },
                fields: {
                  items: [
                    {
                      id: "cddc2c82-dcad-4ec4-9d0e-d10de405d570",
                      name: "splashPage",
                      displayName: "Splash Screen",
                      parentId: "67232667-4c94-4762-9f36-d07f7a5fc6e7",
                      fields: {
                        gaLabel: { value: "" },
                        backgroundColor: {
                          id: "b47928d6-98fc-4b29-8d0f-586ab477286e",
                          fieldType: "Droplink",
                          fieldName: "backgroundColor",
                          url: "/sitecore/content/fwd/global/settings/list/colors/orangewhite",
                          fields: {
                            value: { value: "orange-white" },
                            key: { value: "OrangeWhite" },
                          },
                        },
                        "Css Class": { value: "splashScreenPage darkMode" },
                        isHidden: { value: false },
                        HelpText: { value: "" },
                        GeneralError: { value: "" },
                        SpecificError: { value: "" },
                        apiName: null,
                        serverValidationErrorText: { value: "" },
                        enableServerValidation: { value: false },
                        serverValidationLoadingText: { value: "" },
                        serverValidationAPI: null,
                        "Field Type": {
                          id: "d819b43e-c136-4392-9393-8be7fce32f5e",
                          fieldType: "Droptree",
                          fieldName: "Field Type",
                          url: "/sitecore/system/settings/forms/field-types/structure/page",
                          fields: {
                            BackgroundColor: { value: "Eggplant" },
                            Icon: {
                              value: "OfficeWhite/32x32/window_split_ver.png",
                            },
                            IsDisabled: { value: false },
                            SpritePosition: { value: "" },
                            "Field Template": {
                              id: "cfee7b51-8505-45ce-b843-9358f827df87",
                              fieldType: "Droptree",
                              fieldName: "Field Template",
                              url: "/sitecore/templates/system/forms/fields/page",
                              fields: {},
                            },
                            "Allowed Validations": [],
                            "Model Type": {
                              value:
                                "FWD.Foundation.Forms.CustomPageViewModel,FWD.Foundation.Forms",
                            },
                            "Property Editor": null,
                            "View Path": { value: "FieldTemplates/Page" },
                          },
                        },
                        Conditions: { value: '{"fieldConditions":[]}' },
                        "Field Key": {
                          value: "04B6B0BE40774539912EB6E4268008B9",
                        },
                        "Collapsed by Default": { value: false },
                      },
                      items: [
                        {
                          id: "79893aef-9412-46df-bca0-e770b724e0cc",
                          name: "introText",
                          displayName: "introText",
                          parentId: "cddc2c82-dcad-4ec4-9d0e-d10de405d570",
                          fields: {
                            "Html Tag": { value: "p" },
                            Text: { value: "花數分鐘查詢這個計劃 " },
                            "Css Class": { value: "intro" },
                            isHidden: { value: false },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationLoadingText: { value: "" },
                            serverValidationAPI: null,
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Text" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "AFCE8381306E4C6683542430C46614F4",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "9e4429dd-a09c-4e9d-8bc7-dbed05c2878b",
                          name: "Text",
                          displayName: "Text",
                          parentId: "cddc2c82-dcad-4ec4-9d0e-d10de405d570",
                          fields: {
                            "Html Tag": { value: "p" },
                            Text: {
                              value: "我們只需要您提供與您問題相關的必要資訊 ",
                            },
                            "Css Class": { value: "splashScreenDisclaimer" },
                            isHidden: { value: false },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationLoadingText: { value: "" },
                            serverValidationAPI: null,
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Text" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "7CE5790CA96A427497DB463A5156D1D0",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "88f1a1bb-a74a-441c-b86b-4d664bc74230",
                          name: "splashScreenClick",
                          displayName: "Next Page",
                          parentId: "cddc2c82-dcad-4ec4-9d0e-d10de405d570",
                          fields: {
                            "Navigation Step": { value: "1" },
                            emailTemplateLink: { value: "" },
                            "Css Class": { value: "" },
                            isHidden: { value: false },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationLoadingText: { value: "" },
                            serverValidationAPI: null,
                            "Label Css Class": { value: "" },
                            Title: { value: "開始 " },
                            "Field Type": {
                              id: "7ce25cab-ef3a-4f73-ab13-d33bdc1e4ee2",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/structure/submit-button",
                              fields: {
                                BackgroundColor: { value: "Eggplant" },
                                Icon: { value: "OfficeWhite/32x32/button.png" },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "94a46d66-b1b8-405d-aae4-7b5a9cd61c5e",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/button",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomButtonViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Button" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "0B059E90D26E41B2B35BE476FB35A168",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [
                            {
                              id: "8a59c46d-28c7-4f8b-b2d9-71bf42dc8d6d",
                              name: "Redirect to Page",
                              displayName: "Redirect to Page",
                              parentId: "88f1a1bb-a74a-441c-b86b-4d664bc74230",
                              fields: {
                                Description: { value: "Summary Screen" },
                                Parameters: {
                                  value:
                                    '{"referenceId":"{59CDD628-9C31-4A03-B612-ACBCDDF6EE59}"}',
                                },
                                "Submit Action": {
                                  id: "3f3e2093-9dea-4199-86ca-44fc69ef624d",
                                  fieldType: "Droptree",
                                  fieldName: "Submit Action",
                                  url: "/sitecore/system/settings/forms/submit-actions/redirect-to-page",
                                  fields: {
                                    Editor: null,
                                    "Error Message": { value: "" },
                                    "Model Type": {
                                      value:
                                        "Sitecore.ExperienceForms.Processing.Actions.RedirectToPage",
                                    },
                                  },
                                },
                              },
                              items: [],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      id: "59cdd628-9c31-4a03-b612-acbcddf6ee59",
                      name: "namePage",
                      displayName: "Name",
                      parentId: "67232667-4c94-4762-9f36-d07f7a5fc6e7",
                      fields: {
                        gaLabel: { value: "" },
                        backgroundColor: {
                          id: "cbdc6265-d09f-4982-981a-bcc8f118f36f",
                          fieldType: "Droplink",
                          fieldName: "backgroundColor",
                          url: "/sitecore/content/fwd/global/settings/list/colors/whiteorange",
                          fields: {
                            value: { value: "white-orange" },
                            key: { value: "WhiteOrange" },
                          },
                        },
                        "Css Class": { value: "namePage" },
                        isHidden: { value: false },
                        HelpText: { value: "" },
                        GeneralError: { value: "" },
                        SpecificError: { value: "" },
                        apiName: null,
                        serverValidationErrorText: { value: "" },
                        enableServerValidation: { value: false },
                        serverValidationLoadingText: { value: "" },
                        serverValidationAPI: null,
                        "Field Type": {
                          id: "d819b43e-c136-4392-9393-8be7fce32f5e",
                          fieldType: "Droptree",
                          fieldName: "Field Type",
                          url: "/sitecore/system/settings/forms/field-types/structure/page",
                          fields: {
                            BackgroundColor: { value: "Eggplant" },
                            Icon: {
                              value: "OfficeWhite/32x32/window_split_ver.png",
                            },
                            IsDisabled: { value: false },
                            SpritePosition: { value: "" },
                            "Field Template": {
                              id: "cfee7b51-8505-45ce-b843-9358f827df87",
                              fieldType: "Droptree",
                              fieldName: "Field Template",
                              url: "/sitecore/templates/system/forms/fields/page",
                              fields: {},
                            },
                            "Allowed Validations": [],
                            "Model Type": {
                              value:
                                "FWD.Foundation.Forms.CustomPageViewModel,FWD.Foundation.Forms",
                            },
                            "Property Editor": null,
                            "View Path": { value: "FieldTemplates/Page" },
                          },
                        },
                        Conditions: { value: '{"fieldConditions":[]}' },
                        "Field Key": {
                          value: "F2B07BE6685F41968F59E8E76ABBC8AD",
                        },
                        "Collapsed by Default": { value: false },
                      },
                      items: [
                        {
                          id: "9c017179-888c-4939-bb8f-69b536b44cc3",
                          name: "Text",
                          displayName: "Text",
                          parentId: "59cdd628-9c31-4a03-b612-acbcddf6ee59",
                          fields: {
                            "Html Tag": { value: "h3" },
                            Text: { value: "我是 " },
                            "Css Class": { value: "block" },
                            isHidden: { value: false },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationLoadingText: { value: "" },
                            serverValidationAPI: null,
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Text" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "04919D66DA774E6D896DB65E36D0E8D8",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "b5f0604f-0888-43d7-97e0-53b331d891fb",
                          name: "first-name",
                          displayName: "First Name",
                          parentId: "59cdd628-9c31-4a03-b612-acbcddf6ee59",
                          fields: {
                            "Default Value": { value: "" },
                            "Max Length": { value: "255" },
                            "Min Length": { value: "1" },
                            "Placeholder Text": { value: "名字 " },
                            dialInCodeLength: {
                              id: "924aee12-9c96-42e0-8548-8378e251a8c7",
                              fieldType: "Droplink",
                              fieldName: "dialInCodeLength",
                              url: "/sitecore/content/fwd/global/settings/list/formdiallingcodelength/zero",
                              fields: {
                                value: { value: "No" },
                                key: { value: "zero" },
                              },
                            },
                            "Css Class": { value: "inline" },
                            isHidden: { value: false },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            apiName: {
                              id: "f20d5651-f7b9-49a8-9e57-0a3c7e0b5cb8",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/firstname",
                              fields: {
                                value: { value: "firstName" },
                                key: { value: "firstName" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationLoadingText: { value: "" },
                            serverValidationAPI: null,
                            "Label Css Class": { value: "" },
                            Title: { value: "" },
                            Required: { value: true },
                            Validations: [
                              {
                                id: "83e96d09-11c8-4132-8a8a-76d8db8208d6",
                                fields: {
                                  Message: { value: "" },
                                  Parameters: { value: "" },
                                  Type: {
                                    value:
                                      "Sitecore.ExperienceForms.Mvc.Models.Validation.StringLengthValidation,Sitecore.ExperienceForms.Mvc",
                                  },
                                },
                              },
                            ],
                            "Is Tracking Enabled": { value: true },
                            "Allow Save": { value: true },
                            "Value Provider Parameters": { value: "" },
                            "Value Provider": null,
                            "Field Type": {
                              id: "4ee89ea7-cefe-4c8e-8532-467ef64591fc",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/single-line-text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/text_field.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "0908030b-4564-42ea-a6fa-c7a5a2d921a8",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/input",
                                  fields: {},
                                },
                                "Allowed Validations": [
                                  {
                                    id: "83e96d09-11c8-4132-8a8a-76d8db8208d6",
                                    fields: {
                                      Message: { value: "" },
                                      Parameters: { value: "" },
                                      Type: {
                                        value:
                                          "Sitecore.ExperienceForms.Mvc.Models.Validation.StringLengthValidation,Sitecore.ExperienceForms.Mvc",
                                      },
                                    },
                                  },
                                ],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomSingleLineViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/SingleLineText",
                                },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "57CE7E7216534F4F9033E231AD69AFE0",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "fef06ef5-acf7-4373-a8d1-a978e0bf8a43",
                          name: "last-name",
                          displayName: "Last Name",
                          parentId: "59cdd628-9c31-4a03-b612-acbcddf6ee59",
                          fields: {
                            "Default Value": { value: "" },
                            "Max Length": { value: "255" },
                            "Min Length": { value: "1" },
                            "Placeholder Text": { value: "姓氏 " },
                            dialInCodeLength: {
                              id: "924aee12-9c96-42e0-8548-8378e251a8c7",
                              fieldType: "Droplink",
                              fieldName: "dialInCodeLength",
                              url: "/sitecore/content/fwd/global/settings/list/formdiallingcodelength/zero",
                              fields: {
                                value: { value: "No" },
                                key: { value: "zero" },
                              },
                            },
                            "Css Class": { value: "inline" },
                            isHidden: { value: false },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            apiName: {
                              id: "ceb2b470-c127-4eda-b777-0d5943f0c90a",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/lastname",
                              fields: {
                                value: { value: "lastName" },
                                key: { value: "lastName" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationLoadingText: { value: "" },
                            serverValidationAPI: null,
                            "Label Css Class": { value: "" },
                            Title: { value: "" },
                            Required: { value: true },
                            Validations: [
                              {
                                id: "83e96d09-11c8-4132-8a8a-76d8db8208d6",
                                fields: {
                                  Message: { value: "" },
                                  Parameters: { value: "" },
                                  Type: {
                                    value:
                                      "Sitecore.ExperienceForms.Mvc.Models.Validation.StringLengthValidation,Sitecore.ExperienceForms.Mvc",
                                  },
                                },
                              },
                            ],
                            "Is Tracking Enabled": { value: true },
                            "Allow Save": { value: true },
                            "Value Provider Parameters": { value: "" },
                            "Value Provider": null,
                            "Field Type": {
                              id: "4ee89ea7-cefe-4c8e-8532-467ef64591fc",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/single-line-text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/text_field.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "0908030b-4564-42ea-a6fa-c7a5a2d921a8",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/input",
                                  fields: {},
                                },
                                "Allowed Validations": [
                                  {
                                    id: "83e96d09-11c8-4132-8a8a-76d8db8208d6",
                                    fields: {
                                      Message: { value: "" },
                                      Parameters: { value: "" },
                                      Type: {
                                        value:
                                          "Sitecore.ExperienceForms.Mvc.Models.Validation.StringLengthValidation,Sitecore.ExperienceForms.Mvc",
                                      },
                                    },
                                  },
                                ],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomSingleLineViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/SingleLineText",
                                },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "EF0F512D39CE4F759715B4680BF02EF5",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "9902964f-a12d-4f3f-a954-31eb13980c16",
                          name: "nameButtonNextClick",
                          displayName: "Next Page",
                          parentId: "59cdd628-9c31-4a03-b612-acbcddf6ee59",
                          fields: {
                            "Navigation Step": { value: "1" },
                            emailTemplateLink: { value: "" },
                            "Css Class": { value: "next-button" },
                            isHidden: { value: false },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationLoadingText: { value: "" },
                            serverValidationAPI: null,
                            "Label Css Class": { value: "" },
                            Title: { value: "下一步 " },
                            "Field Type": {
                              id: "7ce25cab-ef3a-4f73-ab13-d33bdc1e4ee2",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/structure/submit-button",
                              fields: {
                                BackgroundColor: { value: "Eggplant" },
                                Icon: { value: "OfficeWhite/32x32/button.png" },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "94a46d66-b1b8-405d-aae4-7b5a9cd61c5e",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/button",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomButtonViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Button" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "3AD1E5279740470796028C7203617EB0",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [
                            {
                              id: "91b9df2f-26a8-42cf-8ab4-12433ad46ccb",
                              name: "Redirect to Page",
                              displayName: "Redirect to Page",
                              parentId: "9902964f-a12d-4f3f-a954-31eb13980c16",
                              fields: {
                                Description: { value: "Email" },
                                Parameters: {
                                  value:
                                    '{"referenceId":"{F4F6D69A-B0EE-448E-A918-DE572F13E071}"}',
                                },
                                "Submit Action": {
                                  id: "3f3e2093-9dea-4199-86ca-44fc69ef624d",
                                  fieldType: "Droptree",
                                  fieldName: "Submit Action",
                                  url: "/sitecore/system/settings/forms/submit-actions/redirect-to-page",
                                  fields: {
                                    Editor: null,
                                    "Error Message": { value: "" },
                                    "Model Type": {
                                      value:
                                        "Sitecore.ExperienceForms.Processing.Actions.RedirectToPage",
                                    },
                                  },
                                },
                              },
                              items: [],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      id: "f4f6d69a-b0ee-448e-a918-de572f13e071",
                      name: "emailPage",
                      displayName: "Email",
                      parentId: "67232667-4c94-4762-9f36-d07f7a5fc6e7",
                      fields: {
                        gaLabel: { value: "" },
                        backgroundColor: {
                          id: "cbdc6265-d09f-4982-981a-bcc8f118f36f",
                          fieldType: "Droplink",
                          fieldName: "backgroundColor",
                          url: "/sitecore/content/fwd/global/settings/list/colors/whiteorange",
                          fields: {
                            value: { value: "white-orange" },
                            key: { value: "WhiteOrange" },
                          },
                        },
                        "Css Class": { value: "emailPage" },
                        isHidden: { value: false },
                        HelpText: { value: "" },
                        GeneralError: { value: "" },
                        SpecificError: { value: "" },
                        apiName: null,
                        serverValidationErrorText: { value: "" },
                        enableServerValidation: { value: false },
                        serverValidationLoadingText: { value: "" },
                        serverValidationAPI: null,
                        "Field Type": {
                          id: "d819b43e-c136-4392-9393-8be7fce32f5e",
                          fieldType: "Droptree",
                          fieldName: "Field Type",
                          url: "/sitecore/system/settings/forms/field-types/structure/page",
                          fields: {
                            BackgroundColor: { value: "Eggplant" },
                            Icon: {
                              value: "OfficeWhite/32x32/window_split_ver.png",
                            },
                            IsDisabled: { value: false },
                            SpritePosition: { value: "" },
                            "Field Template": {
                              id: "cfee7b51-8505-45ce-b843-9358f827df87",
                              fieldType: "Droptree",
                              fieldName: "Field Template",
                              url: "/sitecore/templates/system/forms/fields/page",
                              fields: {},
                            },
                            "Allowed Validations": [],
                            "Model Type": {
                              value:
                                "FWD.Foundation.Forms.CustomPageViewModel,FWD.Foundation.Forms",
                            },
                            "Property Editor": null,
                            "View Path": { value: "FieldTemplates/Page" },
                          },
                        },
                        Conditions: { value: '{"fieldConditions":[]}' },
                        "Field Key": {
                          value: "A822D936CE184893B07F20E4B97E9B22",
                        },
                        "Collapsed by Default": { value: false },
                      },
                      items: [
                        {
                          id: "5e63c75b-326f-425b-b13c-e0d35c6ccd51",
                          name: "Text",
                          displayName: "Text",
                          parentId: "f4f6d69a-b0ee-448e-a918-de572f13e071",
                          fields: {
                            "Html Tag": { value: "h5" },
                            Text: { value: "我的電郵是 " },
                            "Css Class": { value: "inline" },
                            isHidden: { value: false },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationLoadingText: { value: "" },
                            serverValidationAPI: null,
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Text" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "97A7E3EA18774D5EBD50D8D73064CD99",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "2a8bfc65-47b9-4d38-a03c-f170043e7878",
                          name: "Email",
                          displayName: "Email",
                          parentId: "f4f6d69a-b0ee-448e-a918-de572f13e071",
                          fields: {
                            "Default Value": { value: "" },
                            "Max Length": { value: "255" },
                            "Min Length": { value: "0" },
                            "Placeholder Text": { value: "abc@xyz.com" },
                            dialInCodeLength: {
                              id: "924aee12-9c96-42e0-8548-8378e251a8c7",
                              fieldType: "Droplink",
                              fieldName: "dialInCodeLength",
                              url: "/sitecore/content/fwd/global/settings/list/formdiallingcodelength/zero",
                              fields: {
                                value: { value: "No" },
                                key: { value: "zero" },
                              },
                            },
                            "Css Class": { value: "inline" },
                            isHidden: { value: false },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            apiName: {
                              id: "fa36b97a-b013-41b6-b33a-b8c3e2843137",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/email",
                              fields: {
                                value: { value: "email" },
                                key: { value: "email" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationLoadingText: { value: "" },
                            serverValidationAPI: null,
                            "Label Css Class": { value: "" },
                            Title: { value: "" },
                            Required: { value: true },
                            Validations: [
                              {
                                id: "9bae3e9a-d89f-4f93-9577-68b5e9d44a38",
                                fields: {
                                  Message: { value: "" },
                                  Parameters: {
                                    value:
                                      "/[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]/",
                                  },
                                  Type: {
                                    value:
                                      "FWD.Foundation.Forms.Validators.CustomRegularExpressionValidation,FWD.Foundation.Forms",
                                  },
                                },
                              },
                            ],
                            "Is Tracking Enabled": { value: true },
                            "Allow Save": { value: true },
                            "Value Provider Parameters": { value: "" },
                            "Value Provider": null,
                            "Field Type": {
                              id: "04c39cac-8976-4910-be0d-879ed3368429",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/email",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: { value: "OfficeWhite/32x32/mail.png" },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "886adec1-abf8-40e1-9926-d9189c4e8e1b",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/email",
                                  fields: {},
                                },
                                "Allowed Validations": [
                                  {
                                    id: "9bae3e9a-d89f-4f93-9577-68b5e9d44a38",
                                    fields: {
                                      Message: { value: "" },
                                      Parameters: {
                                        value:
                                          "/[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]/",
                                      },
                                      Type: {
                                        value:
                                          "FWD.Foundation.Forms.Validators.CustomRegularExpressionValidation,FWD.Foundation.Forms",
                                      },
                                    },
                                  },
                                  {
                                    id: "83e96d09-11c8-4132-8a8a-76d8db8208d6",
                                    fields: {
                                      Message: { value: "" },
                                      Parameters: { value: "" },
                                      Type: {
                                        value:
                                          "Sitecore.ExperienceForms.Mvc.Models.Validation.StringLengthValidation,Sitecore.ExperienceForms.Mvc",
                                      },
                                    },
                                  },
                                ],
                                "Model Type": {
                                  value:
                                    " FWD.Foundation.Forms.CustomSingleLineViewModel, FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Email" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "CF485B1F33E5435281D931A3DD5B328B",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "b0c9436d-dded-4276-b991-802f72a0e446",
                          name: "emailNextClick",
                          displayName: "Next Page",
                          parentId: "f4f6d69a-b0ee-448e-a918-de572f13e071",
                          fields: {
                            "Navigation Step": { value: "1" },
                            emailTemplateLink: { value: "" },
                            "Css Class": { value: "next-button" },
                            isHidden: { value: false },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationLoadingText: { value: "" },
                            serverValidationAPI: null,
                            "Label Css Class": { value: "" },
                            Title: { value: "下一步 " },
                            "Field Type": {
                              id: "7ce25cab-ef3a-4f73-ab13-d33bdc1e4ee2",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/structure/submit-button",
                              fields: {
                                BackgroundColor: { value: "Eggplant" },
                                Icon: { value: "OfficeWhite/32x32/button.png" },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "94a46d66-b1b8-405d-aae4-7b5a9cd61c5e",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/button",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomButtonViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Button" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "7BB73BAD1EEC4F309AB7046C2FFF2ED2",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [
                            {
                              id: "7bef61ea-2b04-4eb9-b93e-a0fff767cb86",
                              name: "Redirect to Page",
                              displayName: "Redirect to Page",
                              parentId: "b0c9436d-dded-4276-b991-802f72a0e446",
                              fields: {
                                Description: { value: "Phone Number" },
                                Parameters: {
                                  value:
                                    '{"referenceId":"{D8ECAC52-C61C-45B4-88F3-22BA305760EC}"}',
                                },
                                "Submit Action": {
                                  id: "3f3e2093-9dea-4199-86ca-44fc69ef624d",
                                  fieldType: "Droptree",
                                  fieldName: "Submit Action",
                                  url: "/sitecore/system/settings/forms/submit-actions/redirect-to-page",
                                  fields: {
                                    Editor: null,
                                    "Error Message": { value: "" },
                                    "Model Type": {
                                      value:
                                        "Sitecore.ExperienceForms.Processing.Actions.RedirectToPage",
                                    },
                                  },
                                },
                              },
                              items: [],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      id: "d8ecac52-c61c-45b4-88f3-22ba305760ec",
                      name: "phonePage",
                      displayName: "Phone Number",
                      parentId: "67232667-4c94-4762-9f36-d07f7a5fc6e7",
                      fields: {
                        gaLabel: { value: "" },
                        backgroundColor: {
                          id: "cbdc6265-d09f-4982-981a-bcc8f118f36f",
                          fieldType: "Droplink",
                          fieldName: "backgroundColor",
                          url: "/sitecore/content/fwd/global/settings/list/colors/whiteorange",
                          fields: {
                            value: { value: "white-orange" },
                            key: { value: "WhiteOrange" },
                          },
                        },
                        "Css Class": { value: "phonePage" },
                        isHidden: { value: false },
                        HelpText: { value: "" },
                        GeneralError: { value: "" },
                        SpecificError: { value: "" },
                        apiName: null,
                        serverValidationErrorText: { value: "" },
                        enableServerValidation: { value: false },
                        serverValidationLoadingText: { value: "" },
                        serverValidationAPI: null,
                        "Field Type": {
                          id: "d819b43e-c136-4392-9393-8be7fce32f5e",
                          fieldType: "Droptree",
                          fieldName: "Field Type",
                          url: "/sitecore/system/settings/forms/field-types/structure/page",
                          fields: {
                            BackgroundColor: { value: "Eggplant" },
                            Icon: {
                              value: "OfficeWhite/32x32/window_split_ver.png",
                            },
                            IsDisabled: { value: false },
                            SpritePosition: { value: "" },
                            "Field Template": {
                              id: "cfee7b51-8505-45ce-b843-9358f827df87",
                              fieldType: "Droptree",
                              fieldName: "Field Template",
                              url: "/sitecore/templates/system/forms/fields/page",
                              fields: {},
                            },
                            "Allowed Validations": [],
                            "Model Type": {
                              value:
                                "FWD.Foundation.Forms.CustomPageViewModel,FWD.Foundation.Forms",
                            },
                            "Property Editor": null,
                            "View Path": { value: "FieldTemplates/Page" },
                          },
                        },
                        Conditions: { value: '{"fieldConditions":[]}' },
                        "Field Key": {
                          value: "9D55C171FC094F128842ACE2B3DDA4A9",
                        },
                        "Collapsed by Default": { value: false },
                      },
                      items: [
                        {
                          id: "97cb3d11-e6e5-4601-87ad-84c09217c682",
                          name: "Text",
                          displayName: "Text",
                          parentId: "d8ecac52-c61c-45b4-88f3-22ba305760ec",
                          fields: {
                            "Html Tag": { value: "h5" },
                            Text: { value: "我的電話是 " },
                            "Css Class": { value: "inline" },
                            isHidden: { value: false },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationLoadingText: { value: "" },
                            serverValidationAPI: null,
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Text" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "68525ADA341A44E4A149A8B8DFECA243",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "64272b8e-172d-4181-9c79-e01c8be2532f",
                          name: "country_code",
                          displayName: "Country Code",
                          parentId: "d8ecac52-c61c-45b4-88f3-22ba305760ec",
                          fields: {
                            "Default Value": { value: "+852" },
                            "Max Length": { value: "255" },
                            "Min Length": { value: "0" },
                            "Placeholder Text": { value: "" },
                            dialInCodeLength: {
                              id: "924aee12-9c96-42e0-8548-8378e251a8c7",
                              fieldType: "Droplink",
                              fieldName: "dialInCodeLength",
                              url: "/sitecore/content/fwd/global/settings/list/formdiallingcodelength/zero",
                              fields: {
                                value: { value: "No" },
                                key: { value: "zero" },
                              },
                            },
                            "Css Class": {
                              value: "inline disabled countryCodeInput",
                            },
                            isHidden: { value: false },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            apiName: {
                              id: "01b8756b-4bc7-4534-b990-516943821261",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/countrycode",
                              fields: {
                                value: { value: "countryCode" },
                                key: { value: "countryCode" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationLoadingText: { value: "" },
                            serverValidationAPI: null,
                            "Label Css Class": { value: "" },
                            Title: { value: "" },
                            Required: { value: true },
                            Validations: [],
                            "Is Tracking Enabled": { value: true },
                            "Allow Save": { value: true },
                            "Value Provider Parameters": { value: "" },
                            "Value Provider": null,
                            "Field Type": {
                              id: "4ee89ea7-cefe-4c8e-8532-467ef64591fc",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/single-line-text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/text_field.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "0908030b-4564-42ea-a6fa-c7a5a2d921a8",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/input",
                                  fields: {},
                                },
                                "Allowed Validations": [
                                  {
                                    id: "83e96d09-11c8-4132-8a8a-76d8db8208d6",
                                    fields: {
                                      Message: { value: "" },
                                      Parameters: { value: "" },
                                      Type: {
                                        value:
                                          "Sitecore.ExperienceForms.Mvc.Models.Validation.StringLengthValidation,Sitecore.ExperienceForms.Mvc",
                                      },
                                    },
                                  },
                                ],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomSingleLineViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/SingleLineText",
                                },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "8964ED2ED7E64233BBB0708A7872ABD8",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "e397fcb9-49f6-4b0c-ac1c-f8d5e4dba0fb",
                          name: "Telephone",
                          displayName: "Telephone",
                          parentId: "d8ecac52-c61c-45b4-88f3-22ba305760ec",
                          fields: {
                            "Default Value": { value: "" },
                            "Max Length": { value: "8" },
                            "Min Length": { value: "8" },
                            "Placeholder Text": { value: "00000000" },
                            dialInCodeLength: {
                              id: "924aee12-9c96-42e0-8548-8378e251a8c7",
                              fieldType: "Droplink",
                              fieldName: "dialInCodeLength",
                              url: "/sitecore/content/fwd/global/settings/list/formdiallingcodelength/zero",
                              fields: {
                                value: { value: "No" },
                                key: { value: "zero" },
                              },
                            },
                            "Css Class": { value: "inline telephoneInput" },
                            isHidden: { value: false },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            apiName: {
                              id: "22259656-b6e9-4f74-993e-4578dbcf0741",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/cellphone",
                              fields: {
                                value: { value: "cellPhone" },
                                key: { value: "cellPhone" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationLoadingText: { value: "" },
                            serverValidationAPI: null,
                            "Label Css Class": { value: "" },
                            Title: { value: "" },
                            Required: { value: true },
                            Validations: [
                              {
                                id: "e61ea5ab-77bb-4278-9b13-eac1c30e8e0e",
                                fields: {
                                  Message: { value: "請輸入8位數字電話號碼" },
                                  Parameters: { value: "/\\d{2}\\s?\\d{6}$/" },
                                  Type: {
                                    value:
                                      "FWD.Foundation.Forms.Validators.CustomRegularExpressionValidation,FWD.Foundation.Forms",
                                  },
                                },
                              },
                            ],
                            "Is Tracking Enabled": { value: true },
                            "Allow Save": { value: true },
                            "Value Provider Parameters": { value: "" },
                            "Value Provider": null,
                            "Field Type": {
                              id: "df74f55b-47e6-4d1c-92f8-b0d46a7b2704",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/telephone",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/mobile_phone.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "0908030b-4564-42ea-a6fa-c7a5a2d921a8",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/input",
                                  fields: {},
                                },
                                "Allowed Validations": [
                                  {
                                    id: "1aa74652-2177-48c9-88f5-1214445fea34",
                                    fields: {
                                      Message: { value: "" },
                                      Parameters: { value: "//^d +$//" },
                                      Type: {
                                        value:
                                          "FWD.Foundation.Forms.Validators.CustomRegularExpressionValidation,FWD.Foundation.Forms",
                                      },
                                    },
                                  },
                                  {
                                    id: "83e96d09-11c8-4132-8a8a-76d8db8208d6",
                                    fields: {
                                      Message: { value: "" },
                                      Parameters: { value: "" },
                                      Type: {
                                        value:
                                          "Sitecore.ExperienceForms.Mvc.Models.Validation.StringLengthValidation,Sitecore.ExperienceForms.Mvc",
                                      },
                                    },
                                  },
                                ],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomSingleLineViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/Telephone",
                                },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "17D41C11355B4567AF0A9A0E1C21E415",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "a7324495-834e-4952-9f5f-8ed87667ec10",
                          name: "phoneNextClick",
                          displayName: "Phone Next Page",
                          parentId: "d8ecac52-c61c-45b4-88f3-22ba305760ec",
                          fields: {
                            "Navigation Step": { value: "1" },
                            emailTemplateLink: { value: "" },
                            "Css Class": { value: "next-button" },
                            isHidden: { value: false },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationLoadingText: { value: "" },
                            serverValidationAPI: null,
                            "Label Css Class": { value: "" },
                            Title: { value: "下一步 " },
                            "Field Type": {
                              id: "7ce25cab-ef3a-4f73-ab13-d33bdc1e4ee2",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/structure/submit-button",
                              fields: {
                                BackgroundColor: { value: "Eggplant" },
                                Icon: { value: "OfficeWhite/32x32/button.png" },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "94a46d66-b1b8-405d-aae4-7b5a9cd61c5e",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/button",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomButtonViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Button" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "0D2F27C755FB4C2DA0D53F6A1178BBAD",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [
                            {
                              id: "1bae53be-b4f4-440c-bee2-17e160806b2e",
                              name: "Redirect to Page",
                              displayName: "Redirect to Page",
                              parentId: "a7324495-834e-4952-9f5f-8ed87667ec10",
                              fields: {
                                Description: { value: "Time Details" },
                                Parameters: {
                                  value:
                                    '{"referenceId":"{3B4CB499-4D21-48AC-AEEB-8C593DA796E2}"}',
                                },
                                "Submit Action": {
                                  id: "3f3e2093-9dea-4199-86ca-44fc69ef624d",
                                  fieldType: "Droptree",
                                  fieldName: "Submit Action",
                                  url: "/sitecore/system/settings/forms/submit-actions/redirect-to-page",
                                  fields: {
                                    Editor: null,
                                    "Error Message": { value: "" },
                                    "Model Type": {
                                      value:
                                        "Sitecore.ExperienceForms.Processing.Actions.RedirectToPage",
                                    },
                                  },
                                },
                              },
                              items: [],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      id: "3b4cb499-4d21-48ac-aeeb-8c593da796e2",
                      name: "timePage",
                      displayName: "Time Details",
                      parentId: "67232667-4c94-4762-9f36-d07f7a5fc6e7",
                      fields: {
                        gaLabel: { value: "" },
                        backgroundColor: {
                          id: "cbdc6265-d09f-4982-981a-bcc8f118f36f",
                          fieldType: "Droplink",
                          fieldName: "backgroundColor",
                          url: "/sitecore/content/fwd/global/settings/list/colors/whiteorange",
                          fields: {
                            value: { value: "white-orange" },
                            key: { value: "WhiteOrange" },
                          },
                        },
                        "Css Class": { value: "timePage" },
                        isHidden: { value: false },
                        HelpText: { value: "" },
                        GeneralError: { value: "" },
                        SpecificError: { value: "" },
                        apiName: null,
                        serverValidationErrorText: { value: "" },
                        enableServerValidation: { value: false },
                        serverValidationLoadingText: { value: "" },
                        serverValidationAPI: null,
                        "Field Type": {
                          id: "d819b43e-c136-4392-9393-8be7fce32f5e",
                          fieldType: "Droptree",
                          fieldName: "Field Type",
                          url: "/sitecore/system/settings/forms/field-types/structure/page",
                          fields: {
                            BackgroundColor: { value: "Eggplant" },
                            Icon: {
                              value: "OfficeWhite/32x32/window_split_ver.png",
                            },
                            IsDisabled: { value: false },
                            SpritePosition: { value: "" },
                            "Field Template": {
                              id: "cfee7b51-8505-45ce-b843-9358f827df87",
                              fieldType: "Droptree",
                              fieldName: "Field Template",
                              url: "/sitecore/templates/system/forms/fields/page",
                              fields: {},
                            },
                            "Allowed Validations": [],
                            "Model Type": {
                              value:
                                "FWD.Foundation.Forms.CustomPageViewModel,FWD.Foundation.Forms",
                            },
                            "Property Editor": null,
                            "View Path": { value: "FieldTemplates/Page" },
                          },
                        },
                        Conditions: { value: '{"fieldConditions":[]}' },
                        "Field Key": {
                          value: "F46A6A39786642D2A743E145F488033A",
                        },
                        "Collapsed by Default": { value: false },
                      },
                      items: [
                        {
                          id: "9169e6f7-63ed-43fd-a08d-ecb5c46115d4",
                          name: "Text",
                          displayName: "Text",
                          parentId: "3b4cb499-4d21-48ac-aeeb-8c593da796e2",
                          fields: {
                            "Html Tag": { value: "p" },
                            Text: { value: "我現在可以對話 " },
                            "Css Class": { value: "inline" },
                            isHidden: { value: false },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationLoadingText: { value: "" },
                            serverValidationAPI: null,
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Text" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "1F077668016D44FB84DED130859AFD6D",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "63d7513a-0fdc-4760-b025-e4ad47b34d36",
                          name: "timeDropdown",
                          displayName: "timeDropdown",
                          parentId: "3b4cb499-4d21-48ac-aeeb-8c593da796e2",
                          fields: {
                            "Show Empty Item": { value: true },
                            isAutoSuggest: { value: false },
                            isDynamicDropdown: { value: false },
                            node: { value: "" },
                            Datasource: {
                              id: "58f59e4e-2486-42c4-8ed7-0663f6709b55",
                              fieldType: "Droptree",
                              fieldName: "Datasource",
                              url: "/content/forms/contacttimelist",
                              fields: {},
                            },
                            "Default Selection": { value: "" },
                            "Display Field Name": { value: "value" },
                            "Is Dynamic": { value: true },
                            "Value Field Name": { value: "key" },
                            "Css Class": { value: "inline" },
                            isHidden: { value: false },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            apiName: {
                              id: "1e985703-c4e7-402d-a310-c17b2d90d381",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/preferredtime",
                              fields: {
                                value: { value: "preferredTime" },
                                key: { value: "preferredTime" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationLoadingText: { value: "" },
                            serverValidationAPI: null,
                            "Label Css Class": { value: "" },
                            Title: { value: "選擇時間 " },
                            Required: { value: true },
                            Validations: [],
                            "Is Tracking Enabled": { value: true },
                            "Allow Save": { value: true },
                            "Value Provider Parameters": { value: "" },
                            "Value Provider": null,
                            "Collapsed by Default": { value: false },
                            "Field Type": {
                              id: "e0cfadee-1ac0-471d-a820-2e70d1547b4b",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/lists/dropdown-list",
                              fields: {
                                BackgroundColor: { value: "Grass" },
                                Icon: {
                                  value: "OfficeWhite/32x32/drop_down_list.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "9121d435-48b8-4649-9d13-03d680474fad",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/dropdownlist",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomDropDownListViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/DropdownList",
                                },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "3769A8E2F8484912B8012DBDCD9A47CA",
                            },
                          },
                          items: [
                            {
                              id: "e8276918-4b19-479f-bf99-812073dd26e2",
                              name: "Anytime",
                              displayName: "任何時間",
                              parentId: "58f59e4e-2486-42c4-8ed7-0663f6709b55",
                              fields: {
                                value: { value: "任何時間" },
                                key: { value: "1" },
                              },
                            },
                            {
                              id: "3f8e1d48-91e3-4b9e-aee8-ac0298640733",
                              name: "Morning",
                              displayName: "上午",
                              parentId: "58f59e4e-2486-42c4-8ed7-0663f6709b55",
                              fields: {
                                value: { value: "上午" },
                                key: { value: "2" },
                              },
                            },
                            {
                              id: "acfd5752-51e9-47c7-8076-dc7535941906",
                              name: "Afternoon",
                              displayName: "下午",
                              parentId: "58f59e4e-2486-42c4-8ed7-0663f6709b55",
                              fields: {
                                value: { value: "下午" },
                                key: { value: "3" },
                              },
                            },
                            {
                              id: "4e60ba21-687c-4d8e-8b04-142cae2d85c7",
                              name: "Evening",
                              displayName: "晚上",
                              parentId: "58f59e4e-2486-42c4-8ed7-0663f6709b55",
                              fields: {
                                value: { value: "晚上" },
                                key: { value: "4" },
                              },
                            },
                          ],
                        },
                        {
                          id: "2023c795-54ff-4d3b-876d-55e1d001e583",
                          name: "ToolTip",
                          displayName: "ToolTip",
                          parentId: "3b4cb499-4d21-48ac-aeeb-8c593da796e2",
                          fields: {
                            toolTipText: {
                              value: "我們會根據您所選擇的時間聯絡您 ",
                            },
                            label: { value: "您為甚麼詢問這些資料？ " },
                            "Css Class": { value: "tool-tip" },
                            isHidden: { value: false },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            apiName: null,
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationLoadingText: { value: "" },
                            serverValidationAPI: null,
                            "Is Tracking Enabled": { value: true },
                            "Field Type": {
                              id: "fff6a7f6-db43-49f4-80aa-519af8ede3c5",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/tooltip",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: { value: "Office/32x32/question.png" },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "1edd4140-c0f7-4b64-aaf6-dd99abd590de",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/tooltip",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomToolTipViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/ToolTip",
                                },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "29ED9249AB9443A7AE544758CCAA7313",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "590269d5-bbb6-491d-806d-481f0a391182",
                          name: "ConsentSection",
                          displayName: "ConsentSection",
                          parentId: "3b4cb499-4d21-48ac-aeeb-8c593da796e2",
                          fields: {
                            backgroundColor: {
                              id: "cf8cf9a4-0f70-4db2-b298-90e820aca94b",
                              fieldType: "Droplink",
                              fieldName: "backgroundColor",
                              url: "/sitecore/content/fwd/global/settings/list/colors/greywhite",
                              fields: {
                                value: { value: "grey-white" },
                                key: { value: "grey-white" },
                              },
                            },
                            "Css Class": { value: "consentSection" },
                            isHidden: { value: false },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            apiName: null,
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationLoadingText: { value: "" },
                            serverValidationAPI: null,
                            "Field Type": {
                              id: "447aa745-6d29-4b65-a5a3-8173aa8af548",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/structure/section",
                              fields: {
                                BackgroundColor: { value: "Eggplant" },
                                Icon: {
                                  value:
                                    "OfficeWhite/32x32/document_header.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "8cddb194-f456-4a75-89b7-346f8f39f95c",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/section",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "Sitecore.ExperienceForms.Mvc.Models.Fields.FieldViewModel,Sitecore.ExperienceForms.Mvc",
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/Section",
                                },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "D1DB62D5FEC444C2A45286CD26178BF9",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [
                            {
                              id: "60ba5856-cd35-4344-942d-502f2f678295",
                              name: "privacyPolicy",
                              displayName: "privacyPolicy",
                              parentId: "590269d5-bbb6-491d-806d-481f0a391182",
                              fields: {
                                Datasource: {
                                  id: "6972a94e-4114-4ddc-b610-c76d2f5e0aa2",
                                  fieldType: "Droptree",
                                  fieldName: "Datasource",
                                  url: "/content/forms/product-enquiry-privacy-policy",
                                  fields: {},
                                },
                                "Default Selection": {
                                  value:
                                    "{0B9BD9FA-6439-496C-8400-978BFFE515A2}",
                                },
                                "Display Field Name": { value: "value" },
                                "Is Dynamic": { value: true },
                                "Value Field Name": { value: "value" },
                                "Css Class": {
                                  value: "block privacyPolicyCheckbox",
                                },
                                isHidden: { value: false },
                                HelpText: { value: "" },
                                GeneralError: { value: "" },
                                SpecificError: { value: "" },
                                apiName: {
                                  id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                                  fieldType: "Droplink",
                                  fieldName: "apiName",
                                  url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                                  fields: {
                                    value: { value: "" },
                                    key: { value: "" },
                                  },
                                },
                                serverValidationErrorText: { value: "" },
                                enableServerValidation: { value: false },
                                serverValidationLoadingText: { value: "" },
                                serverValidationAPI: null,
                                "Label Css Class": { value: "" },
                                Title: { value: "" },
                                Required: { value: false },
                                Validations: [],
                                "Is Tracking Enabled": { value: true },
                                "Allow Save": { value: true },
                                "Value Provider Parameters": { value: "" },
                                "Value Provider": null,
                                "Field Type": {
                                  id: "d86a361a-d4ff-46b2-9e97-a37fc5b1fe1a",
                                  fieldType: "Droptree",
                                  fieldName: "Field Type",
                                  url: "/sitecore/system/settings/forms/field-types/lists/checkbox-list",
                                  fields: {
                                    BackgroundColor: { value: "Grass" },
                                    Icon: {
                                      value:
                                        "OfficeWhite/32x32/checkbox_group.png",
                                    },
                                    IsDisabled: { value: false },
                                    SpritePosition: { value: "" },
                                    "Field Template": {
                                      id: "5b672865-55d2-413e-b699-fdfc7e732ccf",
                                      fieldType: "Droptree",
                                      fieldName: "Field Template",
                                      url: "/sitecore/templates/system/forms/fields/list",
                                      fields: {},
                                    },
                                    "Allowed Validations": [],
                                    "Model Type": {
                                      value:
                                        "FWD.Foundation.Forms.CustomCheckBoxListViewModel,FWD.Foundation.Forms",
                                    },
                                    "Property Editor": null,
                                    "View Path": {
                                      value: "FieldTemplates/CheckBoxList",
                                    },
                                  },
                                },
                                Conditions: { value: '{"fieldConditions":[]}' },
                                "Field Key": {
                                  value: "C470CC60AF974C7AADFF19FFAF9BF37D",
                                },
                                "Collapsed by Default": { value: false },
                              },
                              items: [
                                {
                                  id: "0b9bd9fa-6439-496c-8400-978bffe515a2",
                                  name: "product enquiry privacy-policy",
                                  displayName: "product enquiry privacy-policy",
                                  parentId:
                                    "6972a94e-4114-4ddc-b610-c76d2f5e0aa2",
                                  fields: {
                                    value: {
                                      value:
                                        '免責聲明：以上提及的產品特點只作參考性質，並不包括保單內所有的條款、權益，以及主要產品風險和主要不保事項。如欲獲取詳細資料，請細閱有關產品小冊子。如欲了解詳盡的條款及細則，請在辦公時間星期一至日上午9時至晚上11時致電我們的客戶聯繫熱線+852 3123 3123。<br />\n<br />\n當你提交這個表格時，代表著\n<ul>\n    <li>我已細閱及明白<a href="/404?item=web%3a%7bE10372DB-B865-433F-B3FE-C0F40018E4AA%7d%40zh-HK" target="_blank">個人資料收集聲明</a>，並同意受其約束。 </li>\n    <li>我明白富衛人壽保險（百慕達）有限公司 (於百慕達成立之有限公司) 收集我的個人資料只用作就本表格提供進一步服務之用。\n    </li>\n</ul>',
                                    },
                                  },
                                },
                              ],
                            },
                          ],
                        },
                        {
                          id: "7055a4d5-4b5d-4ec7-a36b-f34f2d882ba9",
                          name: "phoneSubmitClick",
                          displayName: "Phone Submit",
                          parentId: "3b4cb499-4d21-48ac-aeeb-8c593da796e2",
                          fields: {
                            "Navigation Step": { value: "0" },
                            emailTemplateLink: { value: "" },
                            "Css Class": { value: "submitButton" },
                            isHidden: { value: false },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationLoadingText: { value: "" },
                            serverValidationAPI: null,
                            "Label Css Class": { value: "" },
                            Title: { value: "提交 " },
                            "Field Type": {
                              id: "7ce25cab-ef3a-4f73-ab13-d33bdc1e4ee2",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/structure/submit-button",
                              fields: {
                                BackgroundColor: { value: "Eggplant" },
                                Icon: { value: "OfficeWhite/32x32/button.png" },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "94a46d66-b1b8-405d-aae4-7b5a9cd61c5e",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/button",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomButtonViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Button" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "1BCD51427EDA4A908AD768C2D9CA67CF",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [
                            {
                              id: "7b9e2027-125e-45d6-abd1-5cfaef0011a1",
                              name: "Send Email",
                              displayName: "Send Email",
                              parentId: "7055a4d5-4b5d-4ec7-a36b-f34f2d882ba9",
                              fields: {
                                Description: { value: "" },
                                Parameters: { value: "" },
                                "Submit Action": {
                                  id: "2f66e378-be9d-4d9d-b43b-fc6ddc0e3db5",
                                  fieldType: "Droptree",
                                  fieldName: "Submit Action",
                                  url: "/sitecore/system/settings/forms/submit-actions/custom-action",
                                  fields: {
                                    Editor: null,
                                    "Error Message": { value: "" },
                                    "Model Type": {
                                      value:
                                        "Sitecore.ExperienceForms.Processing.Actions.SaveData",
                                    },
                                  },
                                },
                              },
                              items: [],
                            },
                            {
                              id: "9e333088-052f-496d-ae6c-c8ff5dc08dc3",
                              name: "Redirect to Page",
                              displayName: "Redirect to Page",
                              parentId: "7055a4d5-4b5d-4ec7-a36b-f34f2d882ba9",
                              fields: {
                                Description: { value: "Thank You - Phone" },
                                Parameters: {
                                  value:
                                    '{"referenceId":"{BD6AE5DF-DB1F-4A31-9F95-9F2633B3BB0C}"}',
                                },
                                "Submit Action": {
                                  id: "3f3e2093-9dea-4199-86ca-44fc69ef624d",
                                  fieldType: "Droptree",
                                  fieldName: "Submit Action",
                                  url: "/sitecore/system/settings/forms/submit-actions/redirect-to-page",
                                  fields: {
                                    Editor: null,
                                    "Error Message": { value: "" },
                                    "Model Type": {
                                      value:
                                        "Sitecore.ExperienceForms.Processing.Actions.RedirectToPage",
                                    },
                                  },
                                },
                              },
                              items: [],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      id: "bd6ae5df-db1f-4a31-9f95-9f2633b3bb0c",
                      name: "phoneEnquiryThankYouPage",
                      displayName: "Thank You - Phone",
                      parentId: "67232667-4c94-4762-9f36-d07f7a5fc6e7",
                      fields: {
                        gaLabel: { value: "" },
                        backgroundColor: {
                          id: "b47928d6-98fc-4b29-8d0f-586ab477286e",
                          fieldType: "Droplink",
                          fieldName: "backgroundColor",
                          url: "/sitecore/content/fwd/global/settings/list/colors/orangewhite",
                          fields: {
                            value: { value: "orange-white" },
                            key: { value: "OrangeWhite" },
                          },
                        },
                        "Css Class": {
                          value: "phoneSubmitPage darkMode conditionPage",
                        },
                        isHidden: { value: false },
                        HelpText: { value: "" },
                        GeneralError: { value: "" },
                        SpecificError: { value: "" },
                        apiName: null,
                        serverValidationErrorText: { value: "" },
                        enableServerValidation: { value: false },
                        serverValidationLoadingText: { value: "" },
                        serverValidationAPI: null,
                        "Field Type": {
                          id: "d819b43e-c136-4392-9393-8be7fce32f5e",
                          fieldType: "Droptree",
                          fieldName: "Field Type",
                          url: "/sitecore/system/settings/forms/field-types/structure/page",
                          fields: {
                            BackgroundColor: { value: "Eggplant" },
                            Icon: {
                              value: "OfficeWhite/32x32/window_split_ver.png",
                            },
                            IsDisabled: { value: false },
                            SpritePosition: { value: "" },
                            "Field Template": {
                              id: "cfee7b51-8505-45ce-b843-9358f827df87",
                              fieldType: "Droptree",
                              fieldName: "Field Template",
                              url: "/sitecore/templates/system/forms/fields/page",
                              fields: {},
                            },
                            "Allowed Validations": [],
                            "Model Type": {
                              value:
                                "FWD.Foundation.Forms.CustomPageViewModel,FWD.Foundation.Forms",
                            },
                            "Property Editor": null,
                            "View Path": { value: "FieldTemplates/Page" },
                          },
                        },
                        Conditions: { value: '{"fieldConditions":[]}' },
                        "Field Key": {
                          value: "F880144362CB4E118C0EE581A4C3D11C",
                        },
                        "Collapsed by Default": { value: false },
                      },
                      items: [
                        {
                          id: "963b3962-3620-4d40-ac83-62529f95cfd8",
                          name: "Text",
                          displayName: "Text",
                          parentId: "bd6ae5df-db1f-4a31-9f95-9f2633b3bb0c",
                          fields: {
                            "Html Tag": { value: "p" },
                            Text: { value: "感謝您 " },
                            "Css Class": { value: "" },
                            isHidden: { value: false },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationLoadingText: { value: "" },
                            serverValidationAPI: null,
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Text" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "753703DC08564AD893AFA873A6215A42",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "271dce0d-5d4a-49ac-810f-e19bb20a67f5",
                          name: "Text",
                          displayName: "Text",
                          parentId: "bd6ae5df-db1f-4a31-9f95-9f2633b3bb0c",
                          fields: {
                            "Html Tag": { value: "p" },
                            Text: {
                              value: "我們的代表將會在您所選擇時間聯絡您  ",
                            },
                            "Css Class": { value: "" },
                            isHidden: { value: false },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationLoadingText: { value: "" },
                            serverValidationAPI: null,
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Text" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "AD687F01371E4675ACA08600A3624030",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "843244ed-0fbc-4618-9b58-8274019d4000",
                          name: "MediaSource",
                          displayName: "MediaSource",
                          parentId: "bd6ae5df-db1f-4a31-9f95-9f2633b3bb0c",
                          fields: {
                            "Html Tag": { value: "p" },
                            Text: { value: "" },
                            "Css Class": { value: "" },
                            isHidden: { value: false },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            apiName: {
                              id: "9966e4e3-f61b-48f4-9958-8eedf4aa3665",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/mediasource",
                              fields: {
                                value: { value: "mediaSource" },
                                key: { value: "mediaSource" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationLoadingText: { value: "" },
                            serverValidationAPI: null,
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Text" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "3DA1A3628894402E9BE4E5BC3B57C06A",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "aceae7c7-d88a-4cd8-9dd1-419678a08aa1",
                          name: "backToHome",
                          displayName: "Back to Home",
                          parentId: "bd6ae5df-db1f-4a31-9f95-9f2633b3bb0c",
                          fields: {
                            "Navigation Step": { value: "1" },
                            emailTemplateLink: { value: "" },
                            "Css Class": { value: "back-to-home" },
                            isHidden: { value: false },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationLoadingText: { value: "" },
                            serverValidationAPI: null,
                            "Label Css Class": { value: "" },
                            Title: { value: "返回 " },
                            "Field Type": {
                              id: "7ce25cab-ef3a-4f73-ab13-d33bdc1e4ee2",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/structure/submit-button",
                              fields: {
                                BackgroundColor: { value: "Eggplant" },
                                Icon: { value: "OfficeWhite/32x32/button.png" },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "94a46d66-b1b8-405d-aae4-7b5a9cd61c5e",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/button",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomButtonViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Button" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "1B48EED990F64B8DBA5887B6BCFC9DC5",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            "jss-footer": [],
          },
        },
      },
    },
  },
};
